import dayjs from "dayjs";
import config from '@config/config';
const today=new Date();
const twoDaysAgo = new Date(today);
twoDaysAgo.setDate(today.getDate()-2);
const yesterday = new Date(today);
yesterday.setDate(yesterday.getDate() - 1);
const tomorrow = new Date(today);
tomorrow.setDate(today.getDate() + 1);
const tenMonthsAgo = new Date(today);
tenMonthsAgo.setDate(today.getDate()-304);
const oneYearAgo=new Date();
oneYearAgo.setDate(today.getDate()-365);
const oneYearAgoDate=oneYearAgo.toISOString().split('T')[0];
export const formJson = {
  user_details: {
    '#type': 'webform_section',
    '#title': 'User Details',
    beneficiary_abha_id: {
      '#type': 'textfield',
      '#title': 'ABHA Number of Beneficiary',
      '#webform': 'beneficiary_registration_women',
      '#webform_id': 'beneficiary_registration_women--beneficiary_abha_id',
      '#webform_key': 'beneficiary_abha_id',
      '#webform_parent_key': 'user_details',
      '#webform_parent_flexbox': false,
      '#webform_depth': 1,
      '#webform_children': [],
      '#webform_multiple': false,
      '#webform_composite': false,
      '#webform_parents': ['user_details', 'beneficiary_abha_id'],
      '#admin_title': 'ABHA Number of Beneficiary',
      '#webform_plugin_id': 'textfield',
    },
    beneficiary_name: {
      '#type': 'textfield',
      '#title': 'Name of Beneficiary',
      '#webform': 'beneficiary_registration_women',
      '#webform_id': 'beneficiary_registration_women--beneficiary_name',
      '#webform_key': 'beneficiary_name',
      '#webform_parent_key': 'user_details',
      '#webform_parent_flexbox': false,
      '#webform_depth': 1,
      '#webform_children': [],
      '#webform_multiple': false,
      '#webform_composite': false,
      '#webform_parents': ['user_details', 'beneficiary_name'],
      '#admin_title': 'Name of Beneficiary',
      '#webform_plugin_id': 'textfield',
    },
    beneficiary_gender: {
      '#type': 'select',
      '#title': 'Gender',
      '#options': {
        Male: 'Male',
        Female: 'Female',
        Other: 'Other',
      },
      '#webform': 'beneficiary_registration_women',
      '#webform_id': 'beneficiary_registration_women--beneficiary_gender',
      '#webform_key': 'beneficiary_gender',
      '#webform_parent_key': 'user_details',
      '#webform_parent_flexbox': false,
      '#webform_depth': 1,
      '#webform_children': [],
      '#webform_multiple': false,
      '#webform_composite': false,
      '#webform_parents': ['user_details', 'beneficiary_gender'],
      '#admin_title': 'Gender',
      '#webform_plugin_id': 'select',
    },
    beneficiary_dob: {
      '#type': 'date',
      '#title': 'DOB of beneficiary',
      '#webform': 'beneficiary_registration_women',
      '#webform_id': 'beneficiary_registration_women--beneficiary_dob',
      '#webform_key': 'beneficiary_dob',
      '#webform_parent_key': 'user_details',
      '#webform_parent_flexbox': false,
      '#webform_depth': 1,
      '#webform_children': [],
      '#webform_multiple': false,
      '#webform_composite': false,
      '#webform_parents': ['user_details', 'beneficiary_dob'],
      '#admin_title': 'DOB of beneficiary',
      '#webform_plugin_id': 'date',
    },
    '#webform': 'beneficiary_registration_women',
    '#webform_id': 'beneficiary_registration_women--user_details',
    '#webform_key': 'user_details',
    '#webform_parent_key': '',
    '#webform_parent_flexbox': false,
    '#webform_depth': 0,
    '#webform_children': [],
    '#webform_multiple': false,
    '#webform_composite': false,
    '#webform_parents': ['user_details'],
    '#admin_title': 'User Details',
    '#webform_plugin_id': 'webform_section',
  },
  other_details: {
    '#type': 'webform_section',
    '#title': 'Other Details',
    '#title_display': 'invisible',
    beneficiary_pmjay_id: {
      '#type': 'number',
      '#title': 'PMJAY ID',
      '#webform': 'beneficiary_registration_women',
      '#webform_id': 'beneficiary_registration_women--beneficiary_pmjay_id',
      '#webform_key': 'beneficiary_pmjay_id',
      '#webform_parent_key': 'other_details',
      '#webform_parent_flexbox': false,
      '#webform_depth': 1,
      '#webform_children': [],
      '#webform_multiple': false,
      '#webform_composite': false,
      '#webform_parents': ['other_details', 'beneficiary_pmjay_id'],
      '#admin_title': 'PMJAY ID',
      '#webform_plugin_id': 'number',
    },
    beneficiary_spouse: {
      '#type': 'textfield',
      '#title': 'Name of Husband',
      '#webform': 'beneficiary_registration_women',
      '#webform_id': 'beneficiary_registration_women--beneficiary_spouse',
      '#webform_key': 'beneficiary_spouse',
      '#webform_parent_key': 'other_details',
      '#webform_parent_flexbox': false,
      '#webform_depth': 1,
      '#webform_children': [],
      '#webform_multiple': false,
      '#webform_composite': false,
      '#webform_parents': ['other_details', 'beneficiary_spouse'],
      '#admin_title': 'Name of Husband',
      '#webform_plugin_id': 'textfield',
    },
    beneficiary_mobile_number: {
      '#type': 'textfield',
      '#title': 'Mobile number of Primary Beneficiary',
      '#pattern': '[789][0-9]{9}',
      '#pattern_error': 'Invalid Phone number',
      '#webform': 'beneficiary_registration_women',
      '#webform_id':
        'beneficiary_registration_women--beneficiary_mobile_number',
      '#webform_key': 'beneficiary_mobile_number',
      '#webform_parent_key': 'other_details',
      '#webform_parent_flexbox': false,
      '#webform_depth': 1,
      '#webform_children': [],
      '#webform_multiple': false,
      '#webform_composite': false,
      '#webform_parents': ['other_details', 'beneficiary_mobile_number'],
      '#admin_title': 'Mobile number of Primary Beneficiary',
      '#webform_plugin_id': 'textfield',
    },
    beneficiary_health_provider_name: {
      '#type': 'textfield',
      '#title': 'Health Provider Name',
      '#webform': 'beneficiary_registration_women',
      '#webform_id':
        'beneficiary_registration_women--beneficiary_health_provider_name',
      '#webform_key': 'beneficiary_health_provider_name',
      '#webform_parent_key': 'other_details',
      '#webform_parent_flexbox': false,
      '#webform_depth': 1,
      '#webform_children': [],
      '#webform_multiple': false,
      '#webform_composite': false,
      '#webform_parents': ['other_details', 'beneficiary_health_provider_name'],
      '#admin_title': 'Health Provider Name',
      '#webform_plugin_id': 'textfield',
    },
    beneficiary_asha_name: {
      '#type': 'textfield',
      '#title': 'ASHA Name',
      '#webform': 'beneficiary_registration_women',
      '#webform_id': 'beneficiary_registration_women--beneficiary_asha_name',
      '#webform_key': 'beneficiary_asha_name',
      '#webform_parent_key': 'other_details',
      '#webform_parent_flexbox': false,
      '#webform_depth': 1,
      '#webform_children': [],
      '#webform_multiple': false,
      '#webform_composite': false,
      '#webform_parents': ['other_details', 'beneficiary_asha_name'],
      '#admin_title': 'ASHA Name',
      '#webform_plugin_id': 'textfield',
    },
    '#webform': 'beneficiary_registration_women',
    '#webform_id': 'beneficiary_registration_women--other_details',
    '#webform_key': 'other_details',
    '#webform_parent_key': '',
    '#webform_parent_flexbox': false,
    '#webform_depth': 0,
    '#webform_children': [],
    '#webform_multiple': false,
    '#webform_composite': false,
    '#webform_parents': ['other_details'],
    '#admin_title': 'Other Details',
    '#webform_plugin_id': 'webform_section',
  },
  checkboxes: {
    '#type': 'checkboxes',
    '#title': 'Checkboxes',
    '#title_display': 'none',
    '#options': {
      'Is PGTV Classified ?': 'Is PGTV Classified ?',
      'Enroll for SMS': 'Enroll for SMS',
    },
    '#webform': 'beneficiary_registration_women',
    '#webform_id': 'beneficiary_registration_women--checkboxes',
    '#webform_key': 'checkboxes',
    '#webform_parent_key': '',
    '#webform_parent_flexbox': false,
    '#webform_depth': 0,
    '#webform_children': [],
    '#webform_multiple': true,
    '#webform_composite': false,
    '#webform_parents': ['checkboxes'],
    '#admin_title': 'Checkboxes',
    '#webform_plugin_id': 'checkboxes',
  },
};

export const zoneDetailsForUpdate:any={
  type: {
    '#type': 'textfield',
    '#title': 'Type',
    '#webform_key': 'type',
    '#isDisabled':true,
    '#required': true,
    '#options': {
      Zone: {type_name:"Zone",type_code:"9000",type_id:30},
      Division: {type_name:"Division",type_code:"10000",type_id:31},
      Circle: {type_name:"Circle",type_code:"11000",type_id:32}
    },
  },
  effectiveFromDate: {
    '#type': 'date',
    '#title': 'Effective From Date',
    '#isDisabled':true,
    '#webform_key': 'effectiveFromDate',
    '#required': true,
    '#maxDate':today,
    
  },

  zone_name: {
    '#type': 'textfield',
    '#title': 'Zone Name',
    '#isDisabled':false,
    '#webform_key': 'zoneName',
    '#required': true,
  },
  // 'division_name': {
  //   '#type': 'textfield',
  //   '#title': 'Division Name',
  //   '#webform_key': 'division_name',
  //   '#required': false,
  // },
  // 'circle_name': {
  //   '#type': 'textfield',
  //   '#title': 'Circle Name',
  //   '#webform_key': 'circle_name',
  //   '#required': false,
  // },
  
};

export const zoneDetails:any = {
  'type': {
    '#type': 'select',
    '#title': 'Type',
    '#webform_key': 'type',
    '#required': true,
    '#options': {
      Zone: {type_name:"Zone",type_code:"9000",type_id:30},
      Division: {type_name:"Division",type_code:"10000",type_id:31},
      Circle: {type_name:"Circle",type_code:"11000",type_id:32}
    },
  },
  'effective_form_date': {
    '#type': 'date',
    '#title': 'Effective From Date',
    '#webform_key': 'effective_form_date',
    '#required': true,
    '#maxDate':today,
    
  },
  'state': {
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    '#required': true,
    '#options': [],
    '#isDisabled':true
  },
  'district': {
    '#type': 'select',
    '#title': 'District',
    '#multiDropdown':true,
    '#options': [],
    '#webform_key': 'district',
    '#required': true,
  },
  

  'zone_name': {
    '#type': 'textfield',
    '#title': 'Zone Name',
    '#webform_key': 'zone_name',
    '#required': true,
  },
  // 'division_name': {
  //   '#type': 'textfield',
  //   '#title': 'Division Name',
  //   '#webform_key': 'division_name',
  //   '#required': true,
  // },
  // 'circle_name': {
  //   '#type': 'textfield',
  //   '#title': 'Circle Name',
  //   '#webform_key': 'circle_name',
  //   '#required': true,
  // },
  
};

export const ZONE_DETAILS:any={
  'type': {
    '#type': 'select',
    '#title': 'Type',
    '#webform_key': 'type',
    '#required': true,
    '#options': {
      Zone: {type_name:"Zone",type_code:"9000",type_id:30},
      Division: {type_name:"Division",type_code:"10000",type_id:31},
      Circle: {type_name:"Circle",type_code:"11000",type_id:32}
    },
  },
  'state': {
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    '#required': true,
    '#options': {
      Goa:{state_name:"Goa",state_code:"12",state_id:12},
      UP:{state_name:"Uttar Pradesh",state_code:"11",state_id:11}
    },
  },
  'district': {
    '#type': 'select',
    '#title': 'District',
    '#multiDropdown':true,
    '#options': {
      district1: {district_name:"Kalyan",district_code:"1",district_id:1},
      district2: {district_name:"Lonavla",district_code:"1",district_id:1}
    },
    '#webform_key': 'district',
    '#required': true,
  },
  'effective_form_date': {
    '#type': 'date',
    '#title': 'Effective From Date',
    '#webform_key': 'effective_form_date',
    '#required': true,
  },

  'zone_name': {
    '#type': 'textfield',
    '#title': 'Zone Name',
    '#webform_key': 'zone_name',
    '#required': true,
  },
  'division_name': {
    '#type': 'textfield',
    '#title': 'Division Name',
    '#webform_key': 'division_name',
    '#required': true,
  },
  'circle_name': {
    '#type': 'textfield',
    '#title': 'Circle Name',
    '#webform_key': 'circle_name',
    '#required': true,
  },
  
};

// export const HEALTH_DIVISION_DETAILS:any = {
//   'type_name': {
//     '#type': 'select',
//     '#title': 'Type',
//     '#webform_key': 'type_name',
//     '#required': true,
//     '#options': {
//       Zone:'Zone',
//       Division:'Division',
//       Circle:'Circle'
//     },
//   },
//   'district': {
//     '#type': 'select',
//     '#title': 'District',
//     '#webform_key': 'district',
//     '#isDisabled':true,
//     '#multiDropdown':false,
//     '#options': {
//       'district1': {district_name:"Kalyan",district_code:"1",district_id:1},
//       'district2': {district_name:"Lonavla",district_code:"1",district_id:1}
//     },
   
//     '#required': true,
//   },
  
  
//   'effective_form_date': {
//     '#type': 'date',
//     '#title': 'Effective From Date',
//     '#webform_key': 'effective_form_date',
//     '#required': true,
//   },
 
//   'block': {
//     '#type': 'select',
//     '#title': 'Block',
//     '#required': false,
//     '#multiDropdown':true,
//     '#options': {
//       block1: {block_name:"block 1",block_code:"1",block_id:1},
//       block2: {block_name:"block 2",block_code:"2",block_id:2}
//     },
//     '#webform_key': 'block',
//   },
//   'ULB': {
//     '#type': 'select',
//     '#title': 'ULB',
//     '#multiDropdown':true,
//     '#options': {
//       ulb1: {ulb_name:"ULB 1",ulb_code:"1",ulb_id:1},
//       ulb2: {ulb_name:"ULB 2",ulb_code:"2",ulb_id:2}
//     },
//     '#webform_key': 'ulb',
//     '#required': false,
//   },
//   'sub_district': {
//     '#type': 'select',
//     '#title': 'Sub District',
//     '#multiDropdown':true,
//     '#options': {
//       sub_district1: {sub_district_name:"Kalyan",sub_district_code:"1",sub_district_id:1},
//       sub_district2: {sub_district_name:"Lonavla",sub_district_code:"2",sub_district_id:2}
//     },
//     '#webform_key': 'sub_district',
//     '#required': false,
//   },
//   'health_block_name': {
//     '#type': 'textfield',
//     '#title': 'Health Block Name',
//     '#webform_key': 'health_block_name',
//     '#required': true,
//   },
//   'villages_mapped': {
//     '#type': 'selectionModal',
//     '#title': 'Villages Mapped',
//     '#webform_key': 'villages_mapped',
//     '#required': true,
//   },
//   'wards_mapped': {
//     '#type': 'selectionModal',
//     '#title': 'Wards Mapped',
//     '#webform_key': 'wards_mapped',
//     '#required': true,
//   },

  
  
// };
export const healthBlockDivision:any = {
  type_name: {
    '#type': 'select',
    '#title': 'Type',
    '#webform_key': 'type_name',
    '#required': true,
    '#options': {
      Zone:'Zone',
      Division:'Division',
      Circle:'Circle'
    },
  },
  effective_form_date: {
    '#type': 'date',
    '#title': 'Effective From Date',
    '#webform_key': 'effective_form_date',
    '#required': true,
    '#maxDate':today,  
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    '#isDisabled':true,
    '#multiDropdown':false,
    '#options': {
      'district1': {district_name:"Kalyan",district_code:"1",district_id:1},
      'district2': {district_name:"Lonavla",district_code:"1",district_id:1}
    },
   
    '#required': false,
  },
  
  sub_district: {
    '#type': 'select',
    '#title': 'Sub District',
    '#multiDropdown':false,
    '#options': [],
    '#webform_key': 'sub_district',
    '#required': false,
  },
  ulb: {
    '#type': 'select',
    '#title': 'ULB',
    '#multiDropdown':false,
    // '#options': {
    //   ulb1: {ulb_name:"ULB 1",ulb_code:"1",ulb_id:1},
    //   ulb2: {ulb_name:"ULB 2",ulb_code:"2",ulb_id:2}
    // },
    '#webform_key': 'ulb',
    '#required': false,
    '#isDisabled':false,
    '#showPlaceholder':true,
    '#options': [],
  },
  wards_mapped: {
    '#type': 'select',
    '#multiDropdown':true,
    '#title': 'Wards Mapped',
    '#webform_key': 'wards_mapped',
    '#required': true,
    '#isDisabled':true,
    '#options': {},
    '#showSelectedOption':true,
    '#tooltipNeeded':true,
    '#tooltipText':"Select ULB to select Wards",
  },
  block: {
    '#type': 'select',
    '#title': 'Block',
    '#required': false,
    '#isDisabled':false,
    '#multiDropdown':false,
    '#options': [],
    '#webform_key': 'block',
  },
  villages_mapped: {
    '#type': 'select',
    '#multiDropdown':true,
    '#title': 'Villages Mapped',
    '#webform_key': 'villages_mapped',
    '#isVisible':false,
    '#required': true,
    '#isDisabled':true,
    '#showSelectedOption':true,
    '#tooltipNeeded':true,
    '#tooltipText':"Select Sub District and Block to select Villages",
  },
  gram_panchayat_mapped: {
    '#type': 'select',
    '#multiDropdown':true,
    '#title': 'Gram Panchayat / ADC Village Mapped',
    '#webform_key': 'gram_panchayat_mapped',
    '#isVisible':false,
    '#required': true,
    '#isDisabled':true,
    '#showSelectedOption':true,
    '#tooltipNeeded':true,
    '#tooltipText':"Select Sub District and Block to select Gram Panchayat / ADC Villages",
  },
  health_block_name: {
    '#type': 'textfield',
    '#title': 'Health Block Name',
    '#webform_key': 'health_block_name',
    '#required': true,
  },
};
export const healthBlockSubDivLocationDetails:any={
  'district': {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    '#isDisabled':true,
    '#multiDropdown':false,
    '#options': {
      'district1': {district_name:"Kalyan",district_code:"1",district_id:1},
      'district2': {district_name:"Lonavla",district_code:"1",district_id:1}
    },
   
    '#required': false,
  },
  
  'sub_district': {
    '#type': 'select',
    '#title': 'Sub District',
    '#multiDropdown':false,
    // '#options': {
    //   sub_district1: {sub_district_name:"Kalyan",sub_district_code:"1",sub_district_id:1},
    //   sub_district2: {sub_district_name:"Lonavla",sub_district_code:"2",sub_district_id:2}
    // },
    '#webform_key': 'sub_district',
    '#required': false,
    '#options': [],
  },
  'ULB': {
    '#type': 'select',
    '#title': 'ULB',
    '#multiDropdown':false,
    '#webform_key': 'ulb',
    '#required': false,
    '#isDisabled':false,
    '#showPlaceholder':true,
    '#options': [],
  },
  'wards_mapped': {
    '#type': 'select',
    '#multiDropdown':true,
    '#title': 'Wards Mapped',
    '#webform_key': 'wards_mapped',
    '#required': true,
    '#isDisabled':true,
    '#options': {},
    '#showSelectedOption':true,
    '#tooltipNeeded':true,
    '#tooltipText':"Select ULB to select Wards"
  },
  'block': {
    '#type': 'select',
    '#title': 'Block',
    '#required': false,
    '#isDisabled':false,
    '#multiDropdown':false,
    '#options': [],
    '#webform_key': 'block',
  },
  'villages_mapped': {
    '#type': 'select',
    '#multiDropdown':true,
    '#title': 'Villages Mapped',
    '#webform_key': 'villages_mapped',
    '#required': true,
    '#isVisible':false,
    '#isDisabled':true,
    '#options': {},
    '#showSelectedOption':true,
    '#tooltipNeeded':true,
    '#tooltipText':"Select Sub District and Block to select Villages"

  },
  'gram_panchayat_mapped': {
    '#type': 'select',
    '#multiDropdown':true,
    '#title': 'Gram Panchayat / ADC Village Mapped',
    '#webform_key': 'gram_panchayat_mapped',
    '#required': true,
    '#isVisible':false,
    '#isDisabled':true,
     '#options': {},
    '#showSelectedOption':true,
    '#tooltipNeeded':true,
    '#tooltipText':"Select Sub District and Block to select Gram Panchayat / ADC Villages"
  },
  'health_block_name': {
    '#type': 'textfield',
    '#title': 'Health Block Name',
    '#webform_key': 'health_block_name',
    '#required': true,
  },
}
export const healthBlockDivisionDetails:any = {
  'type_name': {
    '#type': 'select',
    '#title': 'Type',
    '#webform_key': 'type_name',
    '#required': true,
    '#isDisabled':true,
    '#options': {
     
    },
  },
  'effective_form_date': {
    '#type': 'date',
    '#title': 'Effective From Date',
    '#webform_key': 'effectiveFromDate',
    '#required': true,
    '#maxDate':today,
  },
 
};
export const userdetails = {
  fName: {
    '#type': 'textfield',
    '#title': 'First Name (as per Aadhaar)',
    '#webform_key': 'fName',
    '#required': true,
    '#isDisabled':false
  },
  lName: {
    '#type': 'textfield',
    '#title': 'Last Name (as per Aadhaar)',
    '#webform_key': 'lName',
    '#required': true,
    '#isDisabled':false
  },
  user_type: {
    '#type': 'select',
    '#title': 'User Type',
    '#webform_key': 'user_type',
    '#required': true,
    '#options': {
      National: 'National Level User',
      State: 'State Level User',
      District:'District Level User',
      Block: 'Block Level User',
      Health:'Health Block User',
      Facility:'Facility Level User',
      Field:'Field Level User'
    },
  },
  designation: {
    '#type': 'select',
    '#title': 'Designation',
    '#webform_key': 'designation',
    '#required': true,
    '#options': {
      National1: 'National Level Program division-RBSK',
      National2:'MMPC (Master Consumers)',
      State: 'State Level User-MD',
      District:'District Program Manager-DPM',
      Block: 'Block Program Manager',
    },
  },
  hpr_id:{
    '#type': 'verifyHPR',
    '#title': 'HPR ID/ ABHA Number',
    '#webform_key': 'hpr_id',
    '#required': false,
    '#isDisabled':true,
  },
  mob: {
    '#type': 'textfield',
    '#title': 'Mobile Number',
    '#webform_key': 'mob',
    '#required': true,
  },
  a_mob: {
    '#type': 'textfield',
    '#title': 'Alternate Mobile Number',
    '#webform_key': 'a_mob',
    '#required': false,
  },
  email: {
    '#type': 'textfield',
    '#title': 'Email',
    '#webform_key': 'email',
    '#required': false,
  },
  doj: {
    '#type': 'date',
    '#title': 'Date of Registration on JANANI',
    '#webform_key': 'doj',
    '#required': true,
    '#dateMinimum':'true',
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate':'2000-01-01'
  },
  user_status: {
    '#type': 'toggle',
    '#title': 'User Status',
    '#webform_key': 'user_status',
    '#required': true,
    '#isDisabled':false,
    '#options': {
      Active: 'Active',
      InActive: 'InActive',
    },
    
  },
};
export const userdetailsForField = {
  fName: {
    '#type': 'textfield',
    '#title': 'First Name',
    '#webform_key': 'fName',
    '#required': true,
  },
  lName: {
    '#type': 'textfield',
    '#title': 'Last Name',
    '#webform_key': 'lName',
    '#required': true,
  },
  email: {
    '#type': 'textfield',
    '#title': 'Email',
    '#webform_key': 'email',
    '#required': false,
  },
  mob: {
    '#type': 'number',
    '#title': 'Mobile Number',
    '#webform_key': 'mob',
    '#required': true,
  },
  a_mob: {
    '#type': 'number',
    '#title': 'Alternate Mobile Number',
    '#webform_key': 'a_mob',
    '#required': false,
  },
  designation: {
    '#type': 'select',
    '#title': 'Designation',
    '#webform_key': 'designation',
    '#required': true,
    '#options': {
      National1: 'National Level Program division-RBSK',
      National2:'MMPC (Master Consumers)',
      State: 'State Level User-MD',
      District:'District Program Manager-DPM',
      Block: 'Block Program Manager',
    },
  },
  doj: {
    '#type': 'date',
    '#title': 'Date of Registration on JANANI',
    '#webform_key': 'doj',
    '#required': true,
  },
  user_type: {
    '#type': 'select',
    '#title': 'User Type',
    '#webform_key': 'user_type',
    '#required': true,
    '#options': {
      National: 'National Level User',
      State: 'State Level User',
      District:'District Level User',
      Block: 'Block Level User',
      Health:'Health Block User',
      Facility:'Facility Level User',
      Field:'Field Level User'
    },
  },
  abha_id: {
    '#type': 'verify',
    '#title': 'ABHA Verification',
    '#webform_key': 'abha_id',
    '#required': false,
    '#isDisabled':true
    },
  user_status: {
    '#type': 'toggle',
    '#title': 'User Status',
    '#webform_key': 'user_status',
    '#required': true,
    '#isDisabled':true,
    '#options': {
      Active: 'Active',
      InActive: 'InActive',
    },
    
  },
};
export const userdetailsForFacility = {
  fName: {
    '#type': 'textfield',
    '#title': 'First Name',
    '#webform_key': 'fName',
    '#required': true,
  },
  lName: {
    '#type': 'textfield',
    '#title': 'Last Name',
    '#webform_key': 'lName',
    '#required': true,
  },
  email: {
    '#type': 'textfield',
    '#title': 'Email',
    '#webform_key': 'email',
    '#required': false,
  },
  mob: {
    '#type': 'number',
    '#title': 'Mobile Number',
    '#webform_key': 'mob',
    '#required': true,
  },
  a_mob: {
    '#type': 'number',
    '#title': 'Alternate Mobile Number',
    '#webform_key': 'a_mob',
    '#required': false,
  },
  designation: {
    '#type': 'select',
    '#title': 'Designation',
    '#webform_key': 'designation',
    '#required': true,
    '#options': {
      National1: 'National Level Program division-RBSK',
      National2:'MMPC (Master Consumers)',
      State: 'State Level User-MD',
      District:'District Program Manager-DPM',
      Block: 'Block Program Manager',
    },
  },
  doj: {
    '#type': 'date',
    '#title': 'Date of Registration on JANANI',
    '#webform_key': 'doj',
    '#required': true,
  },
  user_type: {
    '#type': 'select',
    '#title': 'User Type',
    '#webform_key': 'user_type',
    '#required': true,
    '#options': {
      National: 'National Level User',
      State: 'State Level User',
      District:'District Level User',
      Block: 'Block Level User',
      Health:'Health Block User',
      Facility:'Facility Level User',
      Field:'Field Level User'
    },
  },
  hpr_id: {
    '#type': 'verify',
    '#title': 'HPR ID',
    '#webform_key': 'hpr_id',
    '#required': false,
    '#isDisabled':true
    },
  user_status: {
    '#type': 'toggle',
    '#title': 'User Status',
    '#webform_key': 'user_status',
    '#required': true,
    '#isDisabled':true,
    '#options': {
      Active: 'Active',
      InActive: 'InActive',
    },
    
  }
};

export const childPersonalDetails = {
  name: {
    '#type': 'textfield',
    '#title': 'Name of Child',
    '#webform_key': 'name',
    '#isDisabled':false,
    '#required': true
  },
  
  motherAbhaId: {
    '#type': 'textfield',
    '#title': "Mother's ABHA ID",
    '#webform_key': 'motherAbhaId',
    '#isDisabled':true,
    '#required': true
  },
  motherName: {
    '#type': 'textfield',
    '#title': "Mother's Name",
    '#webform_key': 'motherName',
    '#isDisabled':true,
    '#required': true
  },
  number: {
    '#type': 'textfield',
    '#title': "Mother's Mobile Number",
    '#webform_key': 'number',
    '#isDisabled':true,
    '#required': true
  },
  dob: {
    '#type': 'date',
    '#title': 'Date of Birth',
    '#webform_key': 'dob',
    '#required': true,
    '#dateMinimum':'true',
    '#isDisabled':true,
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate':'2000-01-01'
  },
  maturity: {
    '#type': 'select',
    '#title': 'Maturity',
    '#webform_key': 'maturity',
    '#required': true,
    '#options': {},
  },
  gender: {
    '#type': 'select',
    '#title': 'Sex',
    '#webform_key': 'gender',
    '#required': true,
    '#isDisabled':true,
    '#options': {
      Male: 'Male',
      Female: 'Female',
    },
  },
  
  weight:{
    '#type': 'textfield',
    '#title': 'Weight at Birth(gms)',
    '#webform_key': 'weight',
    '#required': false,
    '#isDisabled':false,
  },
  dateOfreg: {
    '#type': 'date',
    '#title': 'Date of Registration',
    '#webform_key': 'dateOfreg',
    '#required': true,
    '#dateMinimum':'true',
    '#isDisabled':true,
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate':'2000-01-01'
  },
  timeOfreg: {
    '#type': 'date',
    '#title': 'Time of Registration',
    '#webform_key': 'timeOfreg',
    '#required': true,
    '#dateMinimum':'true',
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate':'2000-01-01',
    '#isDisabled':true,
    '#showTime':true,
  },
}


export const beneficiaryPersonalDetails = {
  abhaId: {
    '#type': 'textfield',
    '#title': 'ABHA Number',
    '#webform_key': 'abhaId',
    '#isDisabled':true,
    '#required': true
  },
  abhaAddress: {
    '#type': 'textfield',
    '#title': 'ABHA Address',
    '#webform_key': 'abhaAddress',
    '#isDisabled':true,
    '#isVisible':true,
    '#required': false,
  },
  name: {
    '#type': 'textfield',
    '#title': 'Name',
    '#webform_key': 'name',
    '#isDisabled':true,
    '#required': true
  },
  dob: {
    '#type': 'date',
    '#title': 'Date of Birth',
    '#webform_key': 'dob',
    '#required': true,
    '#dateMinimum':'true',
    '#isDisabled':true,
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate':'2000-01-01'
  },
  number: {
    '#type': 'textfield',
    '#title': 'Beneficiary Mobile Number',
    '#webform_key': 'primaryMob',
    '#isDisabled':true,
    '#required': true,
    '#showEditIconInInputField': false
  },
  address: {
    '#type': 'textfield',
    '#title': 'ABHA Address',
    '#webform_key': 'address',
    '#required': true,
    '#isDisabled':true,
    '#isVisible':false
  },
  sName: {
    '#type': 'textfield',
    '#title': 'Spouse Name',
    '#webform_key': 'sName',
    // '#isDisabled':true,
    '#required': true
  },
  caste: {
    '#type': 'select',
    '#title': 'Caste',
    '#webform_key': 'caste',
    '#required': false,
    '#options':[],
    '#isDisabled':false,
  },
  Religion:{
    '#type': 'select',
    '#title': 'Religion',
    '#webform_key': 'Religion',
    '#required': false,
    '#options': [],
  },
  other_religion:{
    '#type': 'textfield',
    '#title': 'Others',
    '#webform_key': 'other_religion',
  },
  aNumber: {
    '#type': 'textfield',
    '#title': 'Alternate Mobile Number',
    '#webform_key': 'aNumber',
    // '#isDisabled':true,
    '#required': false
  },
  sms:{
    '#type': 'checkbox',
    '#title': 'Enroll for SMS',
    '#webform_key': 'sms',
    '#required': false,
  },
  village: {
    '#type': 'select',
    '#title': 'Village Name',
    '#webform_key': 'village',
    '#required': false,
    '#options':[],
    '#isDisabled':false,
  },
  ward: {
    '#type': 'select',
    '#title': 'Ward Name',
    '#webform_key': 'ward',
    '#required': false,
    '#options':[],
    '#isDisabled':false,
  },
  state: {
    '#type': 'textfield',
    '#title': 'State',
    '#webform_key': 'state',
    '#required': false,
    '#options':[],
    '#isDisabled':true,
  },
  district: {
    '#type': 'textfield',
    '#title': 'District',
    '#webform_key': 'district',
    '#required': false,
    '#options':[],
    '#isDisabled':true,
  },
  rch1Id: {
    '#type': 'textfield',
    '#title': 'RCH 1 ID',
    '#webform_key': 'rch1Id',
    '#required': false,
    '#isVisible':false,
    '#options':[],
    '#isDisabled':true,
  },
};

export const beneficiaryData = {
  abhaId: {
    '#type': 'textfield',
    '#title': 'ABHA Number',
    '#webform_key': 'abhaId',
    '#isDisabled':true,
    '#required': true
  },
  abhaAddress: {
    '#type': 'InputFieldWithSuffix',
    '#title': 'ABHA Address',
    '#webform_key': 'abhaAddress',
    '#isDisabled':true,
    '#isBtnDisabled':false,
    '#isVisible':false,
    '#required': true,
    '#suffix':"@sbx",
    '#showCheckMark':false,
  },
  name: {
    '#type': 'textfield',
    '#title': 'Beneficiary Name',
    '#webform_key': 'name',
    '#isDisabled':true,
    '#required': true
  },
  gender: {
    '#type': 'textfield',
    '#title': 'Gender',
    '#webform_key': 'gender',
    '#isDisabled':true,
    '#required': true
  },
  dob: {
    '#type': 'date',
    '#title': 'BeneficiaryDOB',
    '#webform_key': 'dob',
    '#required': true,
    '#dateMinimum':'true',
    '#isDisabled':true,
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate':'2000-01-01'
  },
  number: {
    '#type': 'textfield',
    '#title': 'Primary Phone Number',
    '#webform_key': 'primaryMob',
    '#isDisabled':true,
    '#required': true
  },
  address: {
    '#type': 'textfield',
    '#title': 'ABHA Address',
    '#webform_key': 'address',
    '#required': true,
    '#isDisabled':true,
    '#isVisible':false
  },
  sName: {
    '#type': 'textfield',
    '#title': 'Spouse/ Guardian Name',
    '#webform_key': 'sName',
    // '#isDisabled':true,
    '#required': true
  },
  caste: {
    '#type': 'select',
    '#title': 'Caste',
    '#webform_key': 'caste',
    '#required': false,
    '#options':[],
  },
  aNumber: {
    '#type': 'number',
    '#title': 'Alternate Phone Number',
    '#webform_key': 'aNumber',
    // '#isDisabled':true,
    '#required': false
  },
  healthProviderName:{
    '#type': 'select',
    '#title': 'Health Provider Name',
    '#webform_key': 'healthProviderName',
    '#required': true,
    // '#isDisabled':true,
    '#options': [],
  },
  mobiliserName: {
    '#type': 'select',
    '#title': 'Asha /Mobiliser Name',
    '#webform_key': 'mobiliserName',
    // '#isDisabled':true,
    '#required': false,
    '#options': [],
  },
  facilityType: {
    '#type': 'select',
    '#title': 'Facility Type',
    // '#isDisabled':true,
    '#webform_key': 'facilityType',
    '#required': true,
    '#options': [],
  },
  village: {
    '#type': 'select',
    '#title': 'Village',
    // '#isDisabled':true,
    '#webform_key': 'village',
    '#required': false,
    '#options':[],
  },
  ward: {
    '#type': 'select',
    '#title': 'Ward',
    // '#isDisabled':true,
    '#webform_key': 'ward',
    '#required': false,
    '#options': [],
  },
  facilityName: {
    '#type': 'select',
    '#title': 'Facility Name',
    // '#isDisabled':true,
    '#webform_key': 'facilityName',
    '#required': true,
    '#options':[],
  },
  sms:{
    '#type': 'checkbox',
    '#title': 'Enroll for SMS',
    '#webform_key': 'sms',
    '#required': false,
  },
  pvtg:{
    '#type': 'checkbox',
    '#title': 'Is PVTG Classified',
    '#webform_key': 'pvtg',
    '#required': true,
  },
  Religion:{
    '#type': 'select',
    '#title': 'Religion',
    '#webform_key': 'Religion',
    '#required': false,
    '#options': [],
  },
  other_religion:{
    '#type': 'textfield',
    '#title': 'Others',
    '#webform_key': 'other_religion',
  },
};

export const selfRegBeneficiaryData = {
  abhaId: {
    '#type': 'textfield',
    '#title': 'ABHA ID of Beneficiary',
    '#webform_key': 'abhaId',
    '#isDisabled':true,
    '#required': true
  },
    abhaAddress: {
    '#type': 'InputFieldWithSuffix',
    '#title': 'ABHA Address',
    '#webform_key': 'abhaAddress',
    '#isDisabled':true,
    '#isBtnDisabled':false,
    '#isVisible':false,
    '#required': true,
    '#suffix':"@sbx",
    '#showCheckMark':false,
  },
  name: {
    '#type': 'textfield',
    '#title': 'Name of Beneficiary',
    '#webform_key': 'name',
    '#isDisabled':true,
    '#required': true
  },
  gender: {
    '#type': 'textfield',
    '#title': 'Gender',
    '#webform_key': 'gender',
    '#isDisabled':true,
    '#required': true
  },
  dob: {
    '#type': 'date',
    '#title': 'DOB of beneficiary',
    '#webform_key': 'dob',
    '#required': true,
    '#dateMinimum':'true',
    '#isDisabled':true,
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate':'2000-01-01'
  },
    religion:{
    '#type': 'select',
    '#title': 'Religion',
    '#webform_key': 'religion',
    '#required': false,
    '#options': [],
  },
  others:{
    '#type': 'textfield',
    '#title': 'Others',
    '#webform_key': 'others',
    '#isDisabled': true,
  },
  number: {
    '#type': 'textfield',
    '#title': 'Mobile number of Beneficiary',
    '#webform_key': 'primaryMob',
    '#isDisabled':true,
    '#required': true
  },
  sName: {
    '#type': 'textfield',
    '#title': 'Spouse/ Guardian Name',
    '#webform_key': 'sName',
    '#required': true
  },
  category: {
    '#type': 'select',
    '#title': 'Category',
    '#webform_key': 'category',
    '#required': true,
    '#options':[],
  },
  aNumber: {
    '#type': 'number',
    '#title': 'Alternate Number of Beneficiary',
    '#webform_key': 'aNumber',
    '#required': false
  },
  subDistrict:{
    '#type': 'select',
    '#title': 'Sub District',
    '#webform_key': 'subDistrict',
    '#required': false,
    '#options': [],
  },
  district:{
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    '#required': true,
    '#options': [],
  },
  pincode: {
    '#type': 'textfield',
    '#title': 'PIN Code',
    '#webform_key': 'pincode',
    '#required': true,
    '#options': [],
  },
  block: {
    '#type': 'select',
    '#title': 'Block',
    '#webform_key': 'block',
    '#required': false,
    '#isDisabled':true,
    '#options': [],
  },
  village: {
    '#type': 'select',
    '#title': 'Village',
    '#webform_key': 'village',
    '#required': false,
    '#isDisabled':true,
    '#options':[],
  },
  ward: {
    '#type': 'select',
    '#title': 'Ward',
    '#webform_key': 'ward',
    '#required': false,
    '#isDisabled':true,
    '#options': [],
  },
  ulb:{
    '#type': 'select',
    '#title': 'ULB',
    '#webform_key': 'ulb',
    '#isDisabled':true,
    '#required': false,
  },
  ruralUrban:{
    '#type': 'select',
    '#title': 'Rural/Urban',
    '#webform_key': 'ruralUrban',
    '#required': false,
    '#options': [],
  },
  state:{
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    '#required': true,
    '#options': [],
  }
};

export const selfRegHealthProviderData = {
  abhaId: {
    '#type': 'textfield',
    '#title': 'ABHA ID of Beneficiary',
    '#webform_key': 'abhaId',
    '#isDisabled':true,
    '#required': true
  },
  firstName: {
    '#type': 'textfield',
    '#title': 'First Name',
    '#webform_key': 'firstName',
    '#isDisabled':true,
    '#required': true
  },
  lastName: {
    '#type': 'textfield',
    '#title': 'Last Name',
    '#webform_key': 'lastName',
    '#isDisabled':true,
    '#required': true
  },
  number: {
    '#type': 'textfield',
    '#title': 'Mobile number',
    '#webform_key': 'primaryMob',
    '#isDisabled':true,
    '#required': true
  },
  email: {
    '#type': 'textfield',
    '#title': 'Email',
    '#webform_key': 'email',
    '#required': true
  },
  aNumber: {
    '#type': 'number',
    '#title': 'Alternate Number',
    '#webform_key': 'aNumber',
    '#required': false
  },
  subDistrict:{
    '#type': 'select',
    '#title': 'Sub District',
    '#webform_key': 'subDistrict',
    '#required': false,
    '#options': [],
  },
  district:{
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    '#required': true,
    '#options': [],
  },
  pincode: {
    '#type': 'textfield',
    '#title': 'PIN Code',
    '#webform_key': 'pincode',
    '#required': true,
    '#options': [],
  },
  block: {
    '#type': 'select',
    '#title': 'Block',
    '#webform_key': 'block',
    '#required': false,
    '#isDisabled':true,
    '#options': [],
  },
  village: {
    '#type': 'select',
    '#title': 'Village',
    '#webform_key': 'village',
    '#required': false,
    '#isDisabled':true,
    '#options':[],
  },
  ward: {
    '#type': 'select',
    '#title': 'Ward',
    '#webform_key': 'ward',
    '#required': false,
    '#isDisabled':true,
    '#options': [],
  },
  ulb:{
    '#type': 'select',
    '#title': 'ULB',
    '#webform_key': 'ulb',
    '#isDisabled':true,
    '#required': false,
  },
  ruralUrban:{
    '#type': 'select',
    '#title': 'Rural/Urban',
    '#webform_key': 'ruralUrban',
    '#required': false,
    '#options': [],
  },
  state:{
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    '#required': true,
    '#options': [],
  }
};

export const selfRegFacilityData={
    facilityName: {
    '#type': 'select',
    '#title': 'Facility Name',
    '#webform_key': 'facilityName',
    '#required': false,
    '#options':[],
  },
  facilityType: {
    '#type': 'select',
    '#title': 'Facility Type',
    '#webform_key': 'facilityType',
    '#required': false,
    '#options':[],
  },
}

export const userdetailsForUpdate = {
  fName: {
    '#type': 'textfield',
    '#title': 'First Name',
    '#webform_key': 'fName',
    '#required': true,
    '#isDisabled':false,
  },
  lName: {
    '#type': 'textfield',
    '#title': 'Last Name',
    '#webform_key': 'lName',
    '#isDisabled':false,
    '#required': true,
  },
  email: {
    '#type': 'textfield',
    '#title': 'Email',
    '#webform_key': 'email',
    '#isDisabled':false,
    '#required': false,
  },
  mob: {
    '#type': 'textfield',
    '#title': 'Mobile Number(User ID)',
    '#webform_key': 'mob',
    '#isDisabled':true,
    '#required': false,
    '#showEditIconInInputField': true
  },
  a_mob: {
    '#type': 'number',
    '#title': 'Alternate Mobile Number',
    '#webform_key': 'a_mob',
    '#isDisabled':true,
    '#required': false,
  },
  designation: {
    '#type': 'select',
    '#title': 'Designation',
    '#webform_key': 'designation',
    '#isDisabled':true,
    '#required': true,
    '#options': {
      National1: 'National Level Program division-RBSK',
      National2:'MMPC (Master Consumers)',
      State: 'State Level User-MD',
      District:'District Program Manager-DPM',
      Block: 'Block Program Manager',
    },
  },
  
  doj: {
    '#type': 'date',
    '#title': 'Date of Registration on JANANI',
    '#webform_key': 'doj',
    '#isDisabled':true,
    '#required': true,
  },
  user_type: {
    '#type': 'select',
    '#title': 'User Type',
    '#webform_key': 'user_type',
    '#isDisabled':true,
    '#required': false,
    '#options': {
      National: 'National Level User',
      State: 'State Level User',
      District:'District Level User',
      Block: 'Block Level User',
      Health:'Health Block User',
      Facility:'Facility Level User',
      Field:'Field Level User'
    },
  },
 
  hpr_id: {
    '#type': 'verifyHPR',
    '#title': 'HPR ID/ ABHA Number',
    '#webform_key': 'hpr_id',
    '#required': true,
    '#isDisabled':true,
    },
    user_status: {
      '#type': 'toggle',
      '#title': 'User Status',
      '#webform_key': 'user_status',
      '#required': false,
      '#isDisabled':false,
      '#options': {
        Active: 'Active',
        InActive: 'InActive',
      },
    },
  effective_from_date: {
    '#type': 'date',
    '#title': 'Effective From Date',
    '#webform_key': 'effective_from_date',
    '#required': false,
    '#isDisabled':true,
    '#minDate':today.toISOString().split('T')[0],
    },
};
export const childDetails = {
  childAbha: {
    '#type': 'createAndVerify',
    '#title': 'Child/ BALABHA',
    '#webform_key': 'childAbha',
  },
  abhaAddress: {
    '#type': 'textfield',
    '#title': 'ABHA Address',
    '#webform_key': 'abhaAddress',
    '#required': true,
    '#isVisible':false
  },
  checkboxToggle: {
    '#type': 'checkboxToggle',
    '#title': 'Is Mother Alive?',
    '#webform_key': 'checkboxToggle',
    '#required': true,
    '#isMotherAlive': false,
  },
  dateOfreg: {
    '#type': 'date',
    '#title': 'Date of Registration',
    '#webform_key': 'dateOfreg',
    '#required': true,
    '#dateMinimum':'true',
    '#isDisabled':true,
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate':'2000-01-01'
  },
  timeOfreg: {
    '#type': 'date',
    '#title': 'Time of Registration',
    '#webform_key': 'timeOfreg',
    '#required': true,
    '#dateMinimum':'true',
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate':'2000-01-01',
    '#isDisabled':true,
    '#showTime':true,
  },
  relationWithChild: {
    '#type': 'select',
    '#title': 'Relation with Child',
    '#webform_key': 'relationWithChild',
    '#required': true,
    '#options': [],
  },
  name: {
    '#type': 'textfield',
    '#title': 'Name of Child',
    '#webform_key': 'name',
    '#required': true,
  },
  dob: {
    '#type': 'date',
    '#title': 'Date of Birth',
    '#webform_key': 'dob',
    '#required': true,
    '#dateMinimum':'true',
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate':dayjs().subtract(5, 'year').format('YYYY-MM-DD'),
    '#useRelativePopup': true,
  },
  timeOfbirth: {
    '#type': 'time',
    '#title': 'Time of Birth',
    '#webform_key': 'timeOfbirth',
    '#required': true,
    '#isDisabled':true,
  },
  gender: {
    '#type': 'select',
    '#title': 'Sex',
    '#webform_key': 'gender',
    '#required': true,
    '#options': {
      Male: 'Male',
      Female: 'Female',
    },
  },
  maturity: {
    '#type': 'select',
    '#title': 'Maturity',
    '#webform_key': 'maturity',
    '#required': true,
    '#options': {},
  },
  weight: {
    '#type': 'textfield',
    '#title': 'Weight at Birth(gms)',
    '#webform_key': 'weight',
    '#required': true,
  },
  facilityType: {
    '#type': 'select',
    '#title': 'Facility Type',
    '#webform_key': 'facilityType',
    '#required': true,
    '#options': [],
  },
  facilityName: {
    '#type': 'select',
    '#title': 'Facility Name',
    '#webform_key': 'facilityName',
    '#required': true,
    '#options': [],
  },
  healthProviderName: {
    '#type': 'select',
    '#title': 'Health Provider Name',
    '#webform_key': 'healthProviderName',
    '#required': true,
    '#options': [],
  },
  ashaName: {
    '#type': 'select',
    '#title': 'Asha Name',
    '#webform_key': 'ashaName',
    '#required': false,
    '#options': [],
  },
  dateOfVisit: {
    '#type': 'date',
    '#title': 'Date of Visit',
    '#webform_key': 'dateOfVisit',
    '#required': true,
    '#dateMinimum':'true',
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate':dayjs().subtract(config.serviceDateLimit, 'day').format('YYYY-MM-DD'),
    '#useRelativePopup': true,
  },
};

export const fatherDetails = {
  name: {
    '#type': 'textfield',
    '#title': "Father's Name",
    '#webform_key': 'name',
    '#required': true,
  },
  mob: {
    '#type': 'textfield',
    '#title': "Father's Phone Number",
    '#webform_key': 'mob',
    '#required': true,
  },
}

export const motherDetails = {
  name: {
    '#type': 'textfield',
    '#title': "Mother's Name",
    '#webform_key': 'name',
    '#required': true,
  },
  mob: {
    '#type': 'textfield',
    '#title': "Mother's Phone Number",
    '#webform_key': 'mob',
    '#required': true,
  },
}

export const guardianDetails = {
  name: {
    '#type': 'textfield',
    '#title': "Guardian's Name",
    '#webform_key': 'name',
    '#required': true,
  },
  mob: {
    '#type': 'textfield',
    '#title': "Guardian's Phone Number",
    '#webform_key': 'mob',
    '#required': true,
  },
}
export const childModalDetails = {
  name: {
    '#type': 'textfield',
    '#title': 'Name of Child',
    '#webform_key': 'name',
    '#required': true,
  },
  dob: {
    '#type': 'date',
    '#title': 'Date of Birth',
    '#webform_key': 'dob',
    '#required': true,
    '#dateMinimum':'true',
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate': dayjs().subtract(5, 'year').format('YYYY-MM-DD'),
    '#useRelativePopup':true,
  },
  gender: {
    '#type': 'select',
    '#title': 'Sex',
    '#webform_key': 'gender',
    '#required': true,
    '#options': {
      Male: 'Male',
      Female: 'Female',
    },
  },
};
export const childDetailsUpdate = {
  mob: {
    '#type': 'textfield',
    '#title': "Mother's Mobile Number",
    '#webform_key': 'mob',
    '#required': true,
  },
};
export const facilityDetails = {
  facilityType: {
    '#type': 'select',
    '#title': 'Facility Type',
    '#webform_key': 'facilityType',
    '#required': true,
    '#options': []
  },
  facilityName: {
    '#type': 'select',
    '#title': 'Facility Name',
    '#webform_key': 'facilityName',
    '#required': true,
    '#options': []
  },
  hprName: {
    '#type': 'select',
    '#title': 'Health Provider Name',
    '#webform_key': 'hprName',
    '#required': true,
  },
  ashaName: {
    '#type': 'select',
    '#title': 'Asha Name',
    '#webform_key': 'ashaName',
    // '#required': true,
  },
};

export const hrpFacilityDetails = {
  facilityType: {
    '#type': 'select',
    '#title': 'Facility Type',
    '#webform_key': 'facilityType',
    '#required': true,
    '#options': []
  },
  facilityName: {
    '#type': 'select',
    '#title': 'Facility Name',
    '#webform_key': 'facilityName',
    '#required': true,
    '#options': []
  },
  hprName: {
    '#type': 'select',
    '#title': 'Health Provider Name',
    '#webform_key': 'hprName',
    '#required': true,
  },
  ashaName: {
    '#type': 'select',
    '#title': 'Asha Name',
    '#webform_key': 'ashaName',
    // '#required': true,
  },
  dateOfVisit: {
    '#type': 'date',
    '#title': 'Date of Visit',
    '#webform_key': 'dateOfVisit',
    '#required': true,
    "#minDate": dayjs().subtract(14, 'day').format('YYYY-MM-DD'),
    '#maxDate': today,
  },
};

export const ancServiceData = {
  albendazoleGiven: {
    '#type': 'select',
    '#title': 'Whether Tab Albendazole given?',
    '#webform_key': 'albendazoleGiven',
    '#required': true,
    '#options': []
  },
  fatGiven: {
    '#type': 'textfield',
    '#title': 'Number of Folic acid tabs given',
    '#webform_key': 'fatGiven',
    '#required': true,
  },
  tdDose: {
    '#type': 'select',
    '#title': 'Td dose',
    '#webform_key': 'tdDose',
    '#options': [],
  },
  tdDoseDate: {
    '#type': 'date',
    '#title': 'Td dose Date',
    '#webform_key': 'tdDoseDate',
    '#maxDate':today
  },
  numIFATabsGiven: {
    '#type': 'textfield',
    '#title': 'Number of IFA tabs given',
    '#webform_key': 'numIFATabsGiven',
  },
  numCalciumTabsGiven: {
    '#type': 'textfield',
    '#title': 'Number of Calcium + Vit D3 tabs given',
    '#webform_key': 'numCalciumTabsGiven',
  },
};

export const deathData = {
  dateOfDeath: {
    '#type': 'date',
    '#title': 'Date of Death',
    '#webform_key': 'dateOfDeath',
    '#required': true,
    '#maxDate':today,
    '#useRelativePopup': true,
  },
  placeOfDeath: {
    '#type': 'select',
    '#title': 'Place of Death',
    '#webform_key': 'placeOfDeath',
    '#options': [],
    '#isDisabled':true
  },
  probableCauseOfDeath: {
    '#type': 'select',
    '#title': 'Probable cause of Death',
    '#webform_key': 'probableCauseOfDeath',
    '#options': [],
    '#isDisabled':true
  },
  facilityType: {
    '#type': 'select',
    '#title': 'Facility Type',
    '#webform_key': 'facilityType',
    '#required': true,
    '#options': [],
  },
  facilityName: {
    '#type': 'select',
    '#title': 'Facility Name',
    '#webform_key': 'facilityName',
    '#required': true,
    '#options': [],
  },
  healthProviderName: {
    '#type': 'select',
    '#title': 'Health Provider Name',
    '#webform_key': 'healthProviderName',
    '#required': true,
    '#options': [],
  },
  ashaName: {
    '#type': 'select',
    '#title': 'Asha Name',
    '#webform_key': 'ashaName',
    '#required': false,
    '#options': [],
  },
  dateOfVisit: {
    '#type': 'date',
    '#title': 'Date of Visit',
    '#webform_key': 'dateOfVisit',
    '#required': true,
    '#dateMinimum':'true',
    '#minDate': dayjs().subtract(config.serviceDateLimit, 'day').format('YYYY-MM-DD'),
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#useRelativePopup': true,
  },
  notificationSentByASHA:{
    '#type': 'checkbox',
    '#title':'Notification sent by ASHA within 24Hrs* ',
    '#webform_key': 'notificationSentByASHA',
  },
  FBIRCompletedByANM:{
    '#type': 'checkbox',
    '#title':'FBIR completed by ANM*',
    '#webform_key': 'FBIRCompletedByANM',
  },
};

export const childHbycData = {
  weightOfBaby: {
    '#type': 'textfield',
    '#title': 'Weight of Baby (gms)',
    '#webform_key': 'weightOfBaby',
    '#required': true,
  },
  lengthOfBaby: {
    '#type': 'textfield',
    '#title': 'Length of Baby (cm)',
    '#webform_key': 'lengthOfBaby',
    '#required': true,
  },
  growthChartOfMcpCard: {
    '#type': 'select',
    '#title': 'Wheather child is in Green/Yellow/Red Zone of Growth chart of MCH card based on current visit vitals.',
    '#webform_key': 'growthChartOfMcpCard',
    '#isDisabled':true,
    '#required': true
  },
  redFlagSign: {
    '#type': 'select',
    '#title': 'Based on current visit vitals which "Red flag sign" of development issue identified',
    '#webform_key': 'redFlagSign',
    '#options': [],
    '#required': true,
    '#isDisabled':false
  },
  weatherChildIsSick: {
    '#type': 'select',
    '#title': 'Whether Child is Sick',
    '#webform_key': 'weatherChildIsSick',
    '#options': [],
    '#required': true,
    '#isDisabled':false,
    '#multiDropdown':true,
  },
  weatherChildIsReffered: {
    '#type': 'select',
    '#title': 'Whether Child Referred ?',
    '#webform_key': 'weatherChildIsReffered',
    '#options': [],
    '#isDisabled':false
  },
  breastfeedingContinue: {
    '#type': 'select',
    '#title': 'Whether Exclusive Breastfeeding Continued ?',
    '#webform_key': 'breastfeedingContinue',
    '#options': [],
    '#required': true,
    '#isDisabled':false
  },
  syphilisTest: {
    '#type': 'select',
    '#title': 'Syphilis Test',
    '#webform_key': 'syphilisTest',
    '#options': [],
    '#isDisabled':false
  },
  hivTest: {
    '#type': 'select',
    '#title': 'HIV Test',
    '#webform_key': 'hivTest',
    '#options': [],
    '#isDisabled':false
  },
  whetherOrsProvided : {
    '#type': 'select',
    '#title': 'Whether ORS Provided',
    '#webform_key': 'whetherOrsProvided',
    '#options': [],
    '#isDisabled':false
  },
  whetherComplementaryFeedingStartedAt6months : {
    '#type': 'select',
    '#title': 'Whether Complementary Feeding Started At 6 Months ?',
    '#webform_key': 'whetherComplementaryFeedingStartedAt6months',
    '#options': [],
    '#isDisabled':false
  },
  whetherComplementaryFeedingAdequatelyProvided : {
    '#type': 'select',
    '#title': 'Whether Complementary Feeding adequately provided ?',
    '#webform_key': 'whether_complementary_feeding_adequately_provided',
    '#options': [],
    '#isDisabled':false
  },
  whetherBottleOfIfaProvided : {
    '#type': 'select',
    '#title': 'Whether Bottle of IFA provided ?',
    '#webform_key': 'whether_bottle_of_ifa_provided',
    '#options': [],
    '#isDisabled':false
  },
 
};

export const healthProviderData = {
  facilityType: {
    '#type': 'select',
    '#title': 'Facility Type',
    '#webform_key': 'facilityType',
    '#options': [],
    '#required': true,
  },
  facilityName: {
    '#type': 'select',
    '#title': 'Facility Name',
    '#webform_key': 'facilityName',
    '#required': true,
  },
  healthProviderName: {
    '#type': 'textfield',
    '#title': 'Place of Death',
    '#webform_key': 'healthProviderName',
    '#isDisabled':true
  },
  ashaName: {
    '#type': 'textfield',
    '#title': 'Probable cause of Death',
    '#webform_key': 'probableCauseOfDeath',
    '#options': [],
    '#isDisabled':true
  },
};


export const HealthProviderDetailsData = {
  facilityType: {
    '#type': 'select',
    '#title': 'Facility Type',
    '#webform_key': 'facilityType',
    '#options': [],
    '#required': true,
  },
  facilityName: {
    '#type': 'select',
    '#title': 'Facility Name',
    '#webform_key': 'facilityName',
    '#options': [],
    '#required': true,
  },
  hprName: {
    '#type': 'select',
    '#title': 'Health Provider Name',
    '#webform_key': 'hprName',
    '#options': [],
    '#required': true,
  },
  ashaName: {
    '#type': 'select',
    '#title': 'Asha Name',
    '#webform_key': 'ashaName',
    '#options': [],
    '#required': true,
  },
};

export const FamilyPlanningDetailsData = {
  serviceDate:{
    '#type': 'date',
    '#title': 'Service Date',
    '#webform_key': 'serviceDate',
    '#required': true,
    '#maxDate':today,
    '#showTime': false,
    '#showDateTimeFormat': false,
  },
  contraceptionCategory: {
    '#type': 'select',
    '#title': 'Contraception Type',
    '#webform_key': 'contraceptionCategory',
    '#required': true,
    '#options': []
  },
  contraceptiveMethod: {
    '#type': 'select',
    '#title': 'Contraceptive Method',
    '#webform_key': 'contraceptiveMethod',
    '#required': true,
    '#options': [],
  },
};

export const complicationData = {
  serviceDate:{
    '#type': 'date',
    '#title': 'Service Date',
    '#webform_key': 'serviceDate',
    '#maxDate':today,
    '#required': true,
  },
  conditionsObserved: {
    '#type': 'select',
    '#title': 'Conditions Observed',
    '#webform_key': 'conditionsObserved',
    '#required': true,
    '#options': [],
    '#multiDropdown':true,
  },
}


export const doseData = {
  serviceDate:{
    '#type': 'date',
    '#title': 'Service Date',
    '#webform_key': 'serviceDate',
    '#maxDate':today,
    '#required': true,
  },
  doseNumber: {
    '#type': 'select',
    '#title': 'Dose Number',
    '#webform_key': 'doseNumber',
    '#required': true,
    '#options': [],
    '#isDisabled': true,
  },
}


export const usgForm = {
  ultraSoundScreening: {
    '#type': 'select',
    '#title': 'Ultra Sound Screening',
    '#webform_key': 'ultraSoundScreening',
    '#required': true,
    '#options': [
      { value: 'Done', label: 'Done' },
      { value: 'NotDone', label: 'Not Done' }
    ]
  },
  screeningDoneUnder: {
    '#type': 'select',
    '#title': 'If done, Whether done under',
    '#webform_key': 'screeningDoneUnder',
  },
  ultraSoundDate: {
    '#type': 'date',
    '#title': 'Date when done',
    '#webform_key': 'ultraSoundDate',
    '#maxDate':today.toISOString().split('T')[0]
  }
};
export const tdInjectionData = {
  vaccineTakenOutside:{
    '#type': 'checkbox',
    '#title':'Vaccine taken Outside JANANI',
    '#webform_key': 'vaccineTakenOutside',
  },
  tdDose: {
    '#type': 'select',
    '#title': 'Select Dose',
    '#webform_key': 'tdDose',
    '#required': true,
    '#options': []
  },
  tdDoseDate: {
    '#type': 'date',
    '#title': 'Td Dose Date',
    '#webform_key': 'tdDoseDate',
    '#required': true,
    '#maxDate':today.toISOString().split('T')[0],
    '#minDate':twoDaysAgo.toISOString().split('T')[0]
  },
};

export const hbServiceData = {
  // hb: {
  //   '#type': 'textfield',
  //   '#title': 'Hb (g/dL)',
  //   '#webform_key': 'hb',
  //   '#required': true,
  //   '#options': [],
  //   '#inputMode': 'decimal',
  // },
  hb: {
    '#type': 'slider',
    '#title': 'Hb (g/dL)',
    '#webform_key': 'hb',
    '#required': true,
    '#min':1,
    '#max':18,
    '#default':1,
    '#smallStep': 0.1,
    '#largeStep': 1,
  },
}

export const peObstetricData = {
  height: {
    '#type': 'select',
    '#title': 'Height Measured in cms',
    '#webform_key': 'height',
    '#required': true,
    '#options': Array.from({ length: 101 }, (_, i) => ({ label: `${i + 100}`, value: `${i + 100}`}))
  },
  history: {
    '#type': 'select',
    '#title': 'Obstetric History',
    '#webform_key': 'history',
    '#multiDropdown':true,
    '#options': [],
    '#required': true,
  }
};

export const roledetailsForUpdate = {
  role_name: {
    '#type': 'select',
    '#title': 'Assign Role',
    '#webform_key': 'role_name',
    '#required': true,
    '#multiDropdown':true,
    '#options': {
      Role1: 'Administrator',
      Role2: 'Report/Dashboard User',
      Role3: 'Service provider',
      Role4:'Approver'
    },
  },
  state: {
    '#type': 'select',
    '#title': 'State',
    '#isDisabled':true,
    '#webform_key': 'state',
    '#required': true,
    '#options': {
      Assam: 'Madhya Pradesh - 23',
      Andhra: 'Jammu And Kashmir - 1',
    },
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#isDisabled':true,
    '#webform_key': 'district',
    '#required': true,
    '#options': {
      Dist1: 'Barwani - 393',
      Dist2: 'Srinagar - 1',
    },
  },

  block: {
    '#type': 'select',
    '#title': 'Block',
    '#webform_key': 'block',
    '#required': true,
    '#isDisabled':true,
    '#options': {
      Block1: 'Barwani Block - 101',
      Block2: 'Bapini - 6847',
    },
  },
  village: {
    '#type': 'select',
    '#title': 'Village',
    '#webform_key': 'village',
    '#required': false,
    '#options': {
      village1: 'Village A - 84529',
      village2: 'Village B - 84313',
      village3: 'Village C - 84314',
      village4: 'Village D - 84501',
    },
  },
 
  ulb: {
    '#type': 'select',
    '#title': 'ULB',
    '#webform_key': 'ulb',
    '#required': false,
    '#options': {
      ULB1: 'ANANTNAG - 1',
      ULB2: 'बड़वानी नगर परिषद - 2',
    },
  },
  ward: {
    '#type': 'select',
    '#title': 'Ward',
    '#webform_key': 'ward',
    '#required': false,
    '#options': {
      ward1: 'Ward - 3052120',
      ward2: 'Ward 1 - 3052121',
    },
  },


};
export const roledetailsForUrban = {
  role_name: {
    '#type': 'select',
    '#title': 'Assign Role',
    '#webform_key': 'role_name',
    '#required': true,
    '#multiDropdown':true,
    '#options': {
      Role1: 'Administrator',
      Role2: 'Report/Dashboard User',
      Role3: 'Service provider',
      Role4:'Approver'
    },
  },
  state: {
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    '#required': false,
    '#options': {
      Assam: 'Madhya Pradesh - 23',
      Andhra: 'Jammu And Kashmir - 1',
    },
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    '#required': false,
    '#options': {
      Dist1: 'Barwani - 393',
      Dist2: 'Srinagar - 1',
    },
  },
  ulb: {
    '#type': 'select',
    '#title': 'ULB',
    '#webform_key': 'ulb',
    '#required': false,
    '#options': {
      ULB1: 'ANANTNAG - 1',
      ULB2: 'बड़वानी नगर परिषद - 2',
    },
  },
  ward: {
    '#type': 'select',
    '#title': 'Ward',
    '#webform_key': 'ward',
    '#required': false,
    '#options': {
      ward1: 'Ward - 3052120',
      ward2: 'Ward 1 - 3052121',
    },
  },
 
  reportUserWithLineListingData:{
    '#type': 'checkbox',
    '#title': 'Report with line listing data',
    '#webform_key': 'reportUserWithLineListingData',
    '#required': false,
  },
  mfa:{
    '#type': 'checkbox',
    '#title': 'Multi-factor Authentication',
    '#webform_key': 'mfa',
    '#required': false,
  },
  offlineModeAccess:{
    '#type': 'checkbox',
    '#title': 'Offline mode access',
    '#webform_key': 'offlineModeAccess',
    '#required': false,
  },
};
export const roledetailsForRural = {
  role_name: {
    '#type': 'select',
    '#title': 'Assign Role',
    '#webform_key': 'role_name',
    '#required': true,
    '#multiDropdown':true,
    '#options': {
      Role1: 'Administrator',
      Role2: 'Report/Dashboard User',
      Role3: 'Service provider',
      Role4:'Approver'
    },
  },
  state: {
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    '#required': false,
    '#options': {
      Assam: 'Madhya Pradesh - 23',
      Andhra: 'Jammu And Kashmir - 1',
    },
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    '#required': false,
    '#options': {
      Dist1: 'Barwani - 393',
      Dist2: 'Srinagar - 1',
    },
  },
  block: {
    '#type': 'select',
    '#title': 'Block',
    '#webform_key': 'block',
    '#required': false,
    '#options': {
      Block1: 'Barwani Block - 101',
      Block2: 'Bapini - 6847',
    },
  },
  village: {
    '#type': 'select',
    '#title': 'Village',
    '#webform_key': 'village',
    '#required': false,
    '#options': {
      village1: 'Village A - 84529',
      village2: 'Village B - 84313',
      village3: 'Village C - 84314',
      village4: 'Village D - 84501',
    },
  },
  reportUserWithLineListingData:{
    '#type': 'checkbox',
    '#title': 'Report with line listing data',
    '#webform_key': 'reportUserWithLineListingData',
    '#required': false,
  },
  mfa:{
    '#type': 'checkbox',
    '#title': 'Multi-factor Authentication',
    '#webform_key': 'mfa',
    '#required': false,
  },
  offlineModeAccess:{
    '#type': 'checkbox',
    '#title': 'Offline mode access',
    '#webform_key': 'offlineModeAccess',
    '#required': false,
  },
};
export const updateRoleDetails = {
  role_name: {
    '#type': 'select',
    '#title': 'Assign Role',
    '#webform_key': 'role_name',
    '#required': true,
    '#multiDropdown':true,
    '#options': {
      Role1: 'Administrator',
      Role2: 'Report/Dashboard User',
      Role3: 'Service provider',
      Role4:'Approver'
    },
  },
  state: {
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    '#required': false,
    '#isDisabled':true,
    '#options': {
      Assam: 'Madhya Pradesh - 23',
      Andhra: 'Jammu And Kashmir - 1',
    },
  },
  zone_division: {
    '#type': 'select',
    '#title': 'Zone/Division/Circle',
    '#webform_key': 'zone_division',
    '#required': false,
    '#isDisabled':true,
    '#multiDropdown':false,
    '#options': {
      Assam: 'Madhya Pradesh - 23',
      Andhra: 'Jammu And Kashmir - 1',
    },
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
     '#isDisabled':true,
     '#required': false,
     '#options': {
      Dist1: 'Barwani - 393',
      Dist2: 'Srinagar - 1',
    },
  },
  rural_urban: {
    '#type': 'select',
    '#title': 'Rural/Urban',
    '#webform_key': 'rural_urban',
     '#isDisabled':true,
     '#required': false,
     '#options': {
      Rural: 'Rural',
      Urban: 'Urban',
    },
  },
  ulb: {
    '#type': 'select',
    '#title': 'ULB',
    '#isDisabled':true,
    '#webform_key': 'ulb',
    '#required': false,
    '#options': {
      ULB1: 'ANANTNAG - 1',
      ULB2: 'बड़वानी नगर परिषद - 2',
    },
  },
  sub_district:{
    '#type': 'select',
    '#title': 'Sub-District',
    '#webform_key': 'sub_district',
    '#required': false,
    '#isDisabled':true,
    '#options': {
      Rural: 'Rural',
      Urban: 'Urban',
    },
  },
  block: {
    '#type': 'select',
    '#title': 'Block',
    '#isDisabled':true,
    '#webform_key': 'block',
    '#required': false,
    '#options': {
      Block1: 'Barwani Block - 101',
      Block2: 'Bapini - 6847',
    },
  },
  health_block: {
    '#type': 'select',
    '#title': 'Health Block',
    '#webform_key': 'health_block',
    '#required': false,
    '#isDisabled':true,
    '#options': {
      Assam: 'Madhya Pradesh - 23',
      Andhra: 'Jammu And Kashmir - 1',
    },
  },
  sub_division: {
    '#type': 'select',
    '#title': 'Sub-Division',
    '#webform_key': 'sub_division',
    '#required': false,
    '#isDisabled':true,
    '#options': {
      Assam: 'Madhya Pradesh - 23',
      Andhra: 'Jammu And Kashmir - 1',
    },
  },
  ward: {
    '#type': 'select',
    '#title': 'Ward',
     '#isDisabled':true,
    '#webform_key': 'ward',
    '#required': false,
    '#options': {
      ward1: 'Ward - 3052120',
      ward2: 'Ward 1 - 3052121',
    },
  },
  village: {
    '#type': 'select',
    '#title': 'Village',
     '#isDisabled':true,
    '#webform_key': 'village',
    '#required': false,
    '#isVisible':false,
    '#options': {
      village1: 'Village A - 84529',
      village2: 'Village B - 84313',
      village3: 'Village C - 84314',
      village4: 'Village D - 84501',
    },
  },
  gram_panchayat: {
    '#type': 'select',
    '#title': 'Gram Panchayat / ADC Village',
    '#webform_key': 'gram_panchayat',
    '#required': false,
    '#isDisabled':true,
    '#isVisible':false,
    '#options': {
    },
  },
};
export const roledetails = {
  role_name: {
    '#type': 'select',
    '#title': 'Assign Role',
    '#webform_key': 'role_name',
    '#required': true,
    '#multiDropdown':true,
    '#options': {
      Role1: 'Administrator',
      Role2: 'Report/Dashboard User',
      Role3: 'Service provider',
      Role4:'Approver'
    },
  },
  state: {
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    '#required': false,
    '#options': {
      Assam: 'Madhya Pradesh - 23',
      Andhra: 'Jammu And Kashmir - 1',
    },
  },
  zone_div_circle: {
    '#type': 'select',
    '#title': 'Zone Division Circle',
    '#webform_key': 'zone_div_circle',
    '#required': false,
    '#multiDropdown':false,
    '#options': {
      Assam: 'Madhya Pradesh - 23',
      Andhra: 'Jammu And Kashmir - 1',
    },
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    // '#isDisabled':true,
    '#required': false,
    '#options': {
      Dist1: 'Barwani - 393',
      Dist2: 'Srinagar - 1',
    },
  },
  rural_urban: {
    '#type': 'select',
    '#title': 'Rural/Urban',
    '#webform_key': 'rural_urban',
    // '#isDisabled':true,
    '#required': false,
    '#options': {
      Rural: 'Rural',
      Urban: 'Urban',
    },
  },
  ulb: {
    '#type': 'select',
    '#title': 'ULB',
    '#isDisabled':true,
    '#webform_key': 'ulb',
    '#required': false,
    // '#options': {
    //   ULB1: 'ANANTNAG - 1',
    //   ULB2: 'बड़वानी नगर परिषद - 2',
    // },
    '#showPlaceholder':true,
    '#options': {},
  },
  sub_district:{
    '#type': 'select',
    '#title': 'Sub-District',
    '#webform_key': 'sub_district',
    '#required': false,
    '#isDisabled':false,
    '#options': {
      Rural: 'Rural',
      Urban: 'Urban',
    },
  },
  block: {
    '#type': 'select',
    '#title': 'Block',
    '#isDisabled':true,
    '#webform_key': 'block',
    '#required': false,
    '#options': {
      Block1: 'Barwani Block - 101',
      Block2: 'Bapini - 6847',
    },
  },
  health_block: {
    '#type': 'select',
    '#title': 'Health Block',
    '#webform_key': 'health_block',
    '#required': false,
    '#options': {
      Assam: 'Madhya Pradesh - 23',
      Andhra: 'Jammu And Kashmir - 1',
    },
  },
  sub_division: {
    '#type': 'select',
    '#title': 'Sub-Division',
    '#webform_key': 'sub_division',
    '#required': false,
    '#options': {
      Assam: 'Madhya Pradesh - 23',
      Andhra: 'Jammu And Kashmir - 1',
    },
  },
  ward: {
    '#type': 'select',
    '#title': 'Ward',
     '#isDisabled':true,
    '#webform_key': 'ward',
    '#required': false,
    '#options': {
      ward1: 'Ward - 3052120',
      ward2: 'Ward 1 - 3052121',
    },
  },
  village: {
    '#type': 'select',
    '#title': 'Village',
     '#isDisabled':true,
    '#webform_key': 'village',
    '#required': false,
    '#isVisible':false,
    '#options': {},
  },
  gram_panchayat: {
    '#type': 'select',
    '#title': 'Gram Panchayat / ADC Village',
    '#isDisabled':true,
    '#webform_key': 'gram_panchayat',
    '#required': false,
    '#isVisible':false,
    '#options': {},
  },
  reportUserWithLineListingData:{
    '#type': 'checkbox',
    '#title': 'Report with line listing data',
    '#webform_key': 'reportUserWithLineListingData',
    '#required': false,
  },
  mfa:{
    '#type': 'checkbox',
    '#title': 'Multi-factor Authentication',
    '#webform_key': 'mfa',
    '#isDisabled':false,
    '#required': false,
  },
  offlineModeAccess:{
    '#type': 'checkbox',
    '#title': 'Offline mode access',
    '#webform_key': 'offlineModeAccess',
    '#required': false,
    '#isDisabled':true,
    '#isVisible':'isVisible',
  },
};

export const userEditCheckBoxes={
  reportUserWithLineListingData:{
    '#type': 'checkbox',
    '#title': 'Report with line listing data',
    '#webform_key': 'reportUserWithLineListingData',
    '#required': true,
  },
  volunteerForPmsma:{
    '#type': 'checkbox',
    '#title': 'Volunteer For PMSMA',
    '#webform_key': 'volunteerForPmsma',
    '#required': false,
  },
  mfa:{
    '#type': 'checkbox',
    '#title': 'Multi-factor Authentication',
    '#webform_key': 'mfa',
    '#required': true,
  },
  offlineModeAccess:{
    '#type': 'checkbox',
    '#title': 'Offline mode access',
    '#webform_key': 'offlineModeAccess',
    '#required': true,
    '#isDisabled':true,
    '#isVisible':'isNotVisible',
  },

}
// export const roledetailurban = {
//   role_name: {
//     '#type': 'select',
//     '#title': 'Assign Role',
//     '#webform_key': 'role_name',
//     '#required': true,
//     '#multiDropdown':true,
//     '#options': {
//       Role1: 'Administrator',
//       Role2: 'Report/Dashboard User',
//       Role3: 'Service provider',
//       Role4:'Approver'
//     },
//   },
//   health_block: {
//     '#type': 'select',
//     '#title': 'Health Block',
//     '#webform_key': 'health_block',
//     '#required': false,
//     '#options': {
//       Assam: 'Madhya Pradesh - 23',
//       Andhra: 'Jammu And Kashmir - 1',
//     },
//   },
//   sub_division: {
//     '#type': 'select',
//     '#title': 'Sub-Division',
//     '#webform_key': 'sub_division',
//     '#required': false,
//     '#options': {
//       Assam: 'Madhya Pradesh - 23',
//       Andhra: 'Jammu And Kashmir - 1',
//     },
//   },
//   state: {
//     '#type': 'select',
//     '#title': 'State',
//     // '#isDisabled':true,
//     '#webform_key': 'state',
//     '#required': false,
//     '#options': {
//       Assam: 'Madhya Pradesh - 23',
//       Andhra: 'Jammu And Kashmir - 1',
//     },
//   },
//   rural_urban: {
//     '#type': 'select',
//     '#title': 'Rural/Urban',
//     '#webform_key': 'rural_urban',
//     // '#isDisabled':true,
//     '#required': false,
//     '#options': {
//       Rural: 'Rural',
//       Urban: 'Urban',
//     },
//   },
//   sub_district:{
//     '#type': 'select',
//     '#title': 'Sub-District',
//     '#webform_key': 'sub_district',
//     '#required': false,
//     // '#isDisabled':true,
//     '#options': {
//       Rural: 'Rural',
//       Urban: 'Urban',
//     },
//   },
//   district: {
//     '#type': 'select',
//     '#title': 'District',
//     '#webform_key': 'district',
//     // '#isDisabled':true,
//     '#required': false,
//     '#options': {
//       Dist1: 'Barwani - 393',
//       Dist2: 'Srinagar - 1',
//     },
//   },
//   ulb: {
//     '#type': 'select',
//     '#title': 'ULB',
//     // '#isDisabled':true,
//     '#webform_key': 'ulb',
//     '#required': false,
//     '#options': {
//       ULB1: 'ANANTNAG - 1',
//       ULB2: 'बड़वानी नगर परिषद - 2',
//     },
//   },
//   ward: {
//     '#type': 'select',
//     '#title': 'Ward',
//     // '#isDisabled':true,
//     '#webform_key': 'ward',
//     '#required': false,
//     '#options': {
//       ward1: 'Ward - 3052120',
//       ward2: 'Ward 1 - 3052121',
//     },
//   },
 
//   reportUserWithLineListingData:{
//     '#type': 'checkbox',
//     '#title': 'Report with line listing data',
//     '#webform_key': 'reportUserWithLineListingData',
//     '#required': false,
//   },
//   offlineModeAccess:{
//     '#type': 'checkbox',
//     '#title': 'Offline mode access',
//     '#webform_key': 'offlineModeAccess',
//     '#required': false,
//   },
//   mfa:{
//     '#type': 'checkbox',
//     '#title': 'Multi-factor Authentication',
//     '#webform_key': 'mfa',
//     '#required': false,
//   },
// };
export const abhaVerify={
  mfa:{
        '#type': 'checkbox',
        '#title': '',
        '#webform_key': 'mfa',
        '#required': false,
      }
}

export const hfrVerify = {
hfrId: {
    '#type': 'textfield',
    '#title': 'HFR ID',
    '#webform_key': 'hfr_id',
    '#required': true,
    '#isDisabled':false
  },
}

export const facility_details_for_Facility = {
  health_facility_type: {
    '#type': 'select',
    '#title': 'Health Facility Type',
    '#webform_key': 'health_facility_type',
    '#required': true,
    '#options': []
  },
  health_facility_name: {
    '#type': 'select',
    '#title': 'Health Facility Name',
    '#webform_key': 'health_facility_name',
    '#required': true,
    '#options': [],
  },
  health_provider_tagged: {
    '#type': 'select',
    '#title': 'Health Provider Tagged',
    '#webform_key': 'health_provider_tagged',
    '#required': false,
    '#multiDropdown':true,
    '#isDisabled':false,
    '#options': {
      Provider1: 'ANM',
      Provider2: 'ASHA',
      Provider3: 'Nurse',
    },
  },
  mobiliser_tagged: {
    '#type': 'select',
    '#title': 'ASHA / Mobiliser Tagged',
    '#webform_key': 'mobiliser_tagged',
    '#required': false,
    '#isDisabled':false,
    '#multiDropdown':true,
    '#options': {
      Asha1: 'Asha1',
      Asha2: 'Asha2',
      Asha3: 'Asha3',
    },
  },
  ward: {
    '#type': 'select',
    '#title': 'Wards Covered',
     '#isDisabled':true,
     '#multiDropdown':true,
    '#webform_key': 'ward',
    '#required': false,
    '#options': [],
  },
  village: {
    '#type': 'select',
    '#title': 'Villages Covered',
     '#isDisabled':true,
     '#multiDropdown':true,
    '#webform_key': 'village',
    '#required': false,
    '#isVisible': false,
    '#options': [],
  },
  gram_panchayat: {
    '#type': 'select',
    '#title': 'Gram Panchayat / ADC Village Covered',
    '#isDisabled':true,
    '#multiDropdown':true,
    '#webform_key': 'gram_panchayat',
    '#required': false,
    '#isVisible': false,
    '#options': [],
  },
  // hpr_id: {
  //   '#type': 'verify',
  //   '#title': 'HPR ID',
  //   '#webform_key': 'hpr_id',
  //   '#required': true,
  //   '#isDisabled':false
  //   },
  volunteerForPmsma:{
    '#type': 'checkbox',
    '#title': 'Volunteer For PMSMA',
    '#webform_key': 'volunteerForPmsma',
    '#required': false,
  }
};

export const updateLinkedFacilityData = {
  health_facility_type: {
    '#type': 'select',
    '#title': 'Health Facility Type',
    '#webform_key': 'health_facility_type',
    '#required': true,
    '#options': [],
  },
  wards_covered: {
    '#type': 'select',
    '#title': 'Wards Covered',
    '#isDisabled':true,
    '#multiDropdown':true,
    '#webform_key': 'wards_covered',
    '#required': false,
    '#options': [],
  },
  villages_covered: {
    '#type': 'select',
    '#title': 'Villages Covered',
    '#isDisabled':true,
    '#isVisible':false,
    '#multiDropdown':true,
    '#webform_key': 'villages_covered',
    '#required': false,
    '#options': [],
  },
  gram_panchayat_covered: {
    '#type': 'select',
    '#title': 'Gram Panchayat / ADC Village Covered',
    '#isVisible':false,
    '#isDisabled':true,
    '#multiDropdown':true,
    '#webform_key': 'gram_panchayat_covered',
    '#required': false,
    '#options': [],
  },
  mobiliser_tagged: {
    '#type': 'select',
    '#title': 'Asha/ Mobiliser Tagged',
     '#isDisabled':false,
    '#multiDropdown':true,
    '#webform_key': 'mobiliser_tagged',
    '#required': false,
    '#options': [],
  },
  hfr_id: {
    '#type': 'select',
    '#title': 'HFR ID',
    '#webform_key': 'hfr_id',
    '#required': true,
    '#isDisabled':false
    },
  health_facility_name: {
    '#type': 'select',
    '#title': 'Health Facility Name',
    '#webform_key': 'health_facility_name',
    '#required': true,
    '#options': {
    },
  },
 efective_from_date: {
    '#type': 'date',
    '#title': 'Effective From Date',
    '#webform_key': 'effective_from_date',
    '#required': true,
    '#isDisabled':false,
    '#dateMinimum':'true',
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate': ''
  },
  remarks: {
    '#type': 'textfield',
    '#title': 'Remarks',
    '#webform_key': 'remarks',
    '#required': false,
    '#isDisabled':false,
    '#options': {
     
    },
  },
};


export const facilityDetailsForHealthProvider = {
  health_facility_type: {
    '#type': 'select',
    '#title': 'Health Facility Type',
    '#webform_key': 'health_facility_type',
    '#required': true,
    '#options': [],
  },
  wards_covered: {
    '#type': 'select',
    '#title': 'Wards Covered',
    '#isDisabled':true,
    '#multiDropdown':true,
    '#webform_key': 'wards_covered',
    '#required': false,
    '#options': [],
  },
  villages_covered: {
    '#type': 'select',
    '#title': 'Villages Covered',
    '#isDisabled':true,
    '#isVisible':false,
    '#multiDropdown':true,
    '#webform_key': 'villages_covered',
    '#required': false,
    '#options': [],
  },
  gram_panchayat_covered: {
    '#type': 'select',
    '#title': 'Gram Panchayat / ADC Village Covered',
    '#isVisible':false,
    '#isDisabled':true,
    '#multiDropdown':true,
    '#webform_key': 'gram_panchayat_covered',
    '#required': false,
    '#options': [],
  },
  mobiliser_tagged: {
    '#type': 'select',
    '#title': 'Asha/ Mobiliser Tagged',
     '#isDisabled':false,
    '#multiDropdown':true,
    '#webform_key': 'mobiliser_tagged',
    '#required': false,
    '#options': [],
  },
  hfr_id: {
    '#type': 'select',
    '#title': 'HFR ID',
    '#webform_key': 'hfr_id',
    '#required': true,
    '#isDisabled':false
    },
  health_facility_name: {
    '#type': 'select',
    '#title': 'Health Facility Name',
    '#webform_key': 'health_facility_name',
    '#required': true,
    '#options': {
    },
  },
  effective_from_date: {
    '#type': 'date',
    '#title': 'Effective From Date',
    '#webform_key': 'effective_from_date',
    '#required': true,
    '#isDisabled': false,
    '#dateMinimum':'true',
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate': ''
  },
  remarks: {
    '#type': 'textfield',
    '#title': 'Remarks',
    '#webform_key': 'remarks',
    '#required': false,
    '#isDisabled':false,
    '#options': {
     
    },
  },
};
export const coverageShiftTransfer = {
  hfr_id: {
    '#type': 'select',
    '#title': 'HFR ID',
    '#webform_key': 'hfr_id',
    '#required': true,
    '#isDisabled':false
    },
  health_facility_type: {
    '#type': 'select',
    '#title': 'Health Facility Type',
    '#webform_key': 'health_facility_type',
    '#required': true,
    '#options': [],
  },
  health_facility_name: {
    '#type': 'select',
    '#title': 'Health Facility Name',
    '#webform_key': 'health_facility_name',
    '#required': true,
    '#options': [],
  },
  mobiliser_tagged: {
    '#type': 'select',
    '#title': 'Asha/ Mobiliser Tagged',
     '#isDisabled':false,
    '#webform_key': 'mobiliser_tagged',
    '#required': false,
    '#multiDropdown':true,
    '#options': [],
  },
  wards_covered: {
    '#type': 'select',
    '#title': 'Wards Covered',
    '#isDisabled':true,
    '#multiDropdown':true,
    '#webform_key': 'wards_covered',
    '#required': false,
    '#options': [],
  },
  villages_covered: {
    '#type': 'select',
    '#title': 'Villages Covered',
    '#isDisabled':true,
    '#isVisible':false,
    '#multiDropdown':true,
    '#webform_key': 'villages_covered',
    '#required': false,
    '#options': [],
  },
  gram_panchayat_covered: {
    '#type': 'select',
    '#title': 'Gram Panchayat / ADC Village Covered',
    '#isVisible':false,
    '#isDisabled':true,
    '#multiDropdown':true,
    '#webform_key': 'gram_panchayat_covered',
    '#required': false,
    '#options': [],
  },
}
export const facilityDetailsForHealthProviderTransfer = {
  efective_from_date: {
    '#type': 'date',
    '#title': 'Effective From Date',
    '#webform_key': 'effective_from_date',
    '#required': true,
    '#isDisabled':false,
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate': dayjs().startOf('month').format('YYYY-MM-DD')
  },
  state: {
    '#type': 'textfield',
    '#title': 'State',
    '#webform_key': 'state',
    "#isDisabled":false,
    '#required': false,
    '#options': {},
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    "#isDisabled":false,
    '#required': true,
    '#options': [],
  },
  rural_urban:{
    '#type': 'select',
    '#title': 'Rural/Urban',
    '#webform_key': 'rural_urban',
    '#required': true,
    '#options': [
      {
        label: "Rural",
        value: "Rural"
      },
      {
        value: 'Urban',
        label: 'Urban',
      }
      
    ],
  },
  ulb: {
    '#type': 'select',
    '#title': 'ULB',
    '#webform_key': 'ulb',
    '#required': false,
    "#isDisabled":true,
    // '#options': [],
    '#showPlaceholder':true,
    '#options': {},
  },
  sub_district: {
    '#type': 'select',
    '#title': 'Sub-District',
    '#webform_key': 'sub_district',
    '#required': false,
    '#options': []
  },
  block:{
    '#type': 'select',
    '#title': 'Block',
    '#webform_key': 'block',
    '#required': false,
    "#isDisabled":true,
    '#options': [],
  },
  health_block: {
    '#type': 'select',
    '#title': 'Health Block',
    '#webform_key': 'health_block',
    '#required': false,
    '#options': [],
  },
  sub_division: {
    '#type': 'select',
    '#title': 'Sub Division',
    '#webform_key': 'sub_division',
    '#required': false,
    '#options': [],
  },
  village: {
    '#type': 'select',
    '#title': 'Village',
    '#webform_key': 'village',
    '#isVisible':false,
    '#required': false,
    "#isDisabled":true,
    '#options': [],
  },
  gram_panchayat: {
    '#type': 'select',
    '#title': 'Gram Panchayat / ADC Village',
    '#isVisible':false,
    '#webform_key': 'gram_panchayat',
    '#required': false,
    "#isDisabled":true,
    '#options': [],
  },
  ward: {
    '#type': 'select',
    '#title': 'Ward',
    '#webform_key': 'ward',
    '#required': false,
    "#isDisabled":true,
    '#options': [],
  }
};

export const roleDetails = {
  user_type: {
    '#type': 'select',
    '#title': 'User Type',
    '#webform_key': 'user_type',
    '#required': true,
    '#options': []
  },
  role_name: {
    '#type': 'select',
    '#title': 'Role Name',
    '#webform_key': 'role_name',
    '#required': true,
    '#multiDropdown': false,
    '#options': [],
  },
  user_designation: {
    '#type': 'select',
    '#title': 'User Designation',
    '#webform_key': 'user_designation',
    '#required': true,
    '#multiDropdown': false,
    '#options': [],
  },
  status: {
    '#type': 'select',
    '#title': 'Status',
    '#webform_key': 'status',
    '#required': true,
    '#isDisabled':false,
    '#options': []
  },
  description: {
    '#type': 'textArea',
    '#title': 'Description',
    '#webform_key': 'description',
    '#required': false,
    '#isDisabled':false,
    '#options': {},
  },
}

export const editRoleDetails = {
  user_type: {
    '#type': 'select',
    '#title': 'User Type',
    '#webform_key': 'user_type',
    '#required': true,
    "#isDisabled":true,
    '#options': []
  },
  role_name: {
    '#type': 'select',
    '#title': 'Role Name',
    '#webform_key': 'role_name',
    '#required': true,
    '#multiDropdown': false,
    "#isDisabled":true,
    '#options': [],
  },
  user_designation: {
    '#type': 'select',
    '#title': 'User Designation',
    '#webform_key': 'user_designation',
    '#required': true,
    '#multiDropdown': false,
    "#isDisabled":true,
    '#options': [],
  },
  status: {
    '#type': 'select',
    '#title': 'Status',
    '#webform_key': 'status',
    '#required': true,
    "#isDisabled":false,
    '#options': []
  },
  description: {
    '#type': 'textArea',
    '#title': 'Description',
    '#webform_key': 'description',
    '#required': false,
    '#isDisabled':true,
    '#options': {},
  },
}
export const facility_details_for_field = {

  health_facility_type: {
    '#type': 'select',
    '#title': 'Health Facility Type',
    '#webform_key': 'health_facility_type',
    '#required': true,
    '#options': []
  },
  health_facility_name: {
    '#type': 'select',
    '#title': 'Health Facility Name',
    '#webform_key': 'health_facility_name',
    '#required': true,
    '#options': []
  },
  health_provider_tagged: {
    '#type': 'select',
    '#title': 'Health Provider Tagged',
    '#webform_key': 'health_provider_tagged',
    '#required': false,
    '#multiDropdown':true,
    '#options': {
      Provider1: 'ANM',
      Provider2: 'ASHA',
      Provider3: 'Nurse',
    },
  },
  mobiliser_tagged: {
    '#type': 'select',
    '#title': 'ASHA / Mobiliser Tagged',
    '#webform_key': 'mobiliser_tagged',
    '#required': false,
    '#isDisabled':false,
    '#multiDropdown':true,
    '#options': {
      Asha1: 'Asha1',
      Asha2: 'Asha2',
      Asha3: 'Asha3',
    },
  },
  ward: {
    '#type': 'select',
    '#title': 'Ward',
     '#isDisabled':true,
     '#multiDropdown':true,
    '#webform_key': 'ward',
    '#required': false,
    '#options': {
      ward1: 'Ward - 3052120',
      ward2: 'Ward 1 - 3052121',
    },
  },
  village: {
    '#type': 'select',
    '#title': 'Village',
     '#isDisabled':true,
     '#multiDropdown':true,
    '#webform_key': 'village',
    '#required': false,
    '#isVisible': false,
    '#options': {},
  },
  gram_panchayat: {
    '#type': 'select',
    '#title': 'Gram Panchayat / ADC Village',
    '#isDisabled':true,
    '#multiDropdown':true,
    '#webform_key': 'gram_panchayat',
    '#required': false,
    '#isVisible': false,
    '#options': {},
  },
};
export const credentials = {
  username: {
    '#type': 'textfield',
    '#title': 'Username',
    '#webform_key': 'Username',
    '#required': true,
  },
  password: {
    '#type': 'textfield',
    '#title': 'Password',
    '#webform_key': 'password',
    '#required': true,
  },
  checkboxes: {
    '#type': 'checkboxes',
    '#title': 'Checkboxes',
    '#title_display': 'none',
    '#webform_key': 'checkboxes',
    '#options': {
      change_pass: 'Change Password on Next Login',
    },
  },
};
export const userCredentials = {
  userName: {
    '#type': 'textfield',
    '#title': 'Username',
    '#webform_key': 'userName',
    '#required': false,
    '#isDisabled':true
  },
  passwordChange: {
    '#type': 'password',
    '#title': 'Password',
    '#webform_key': 'passwordChange',
    '#required': true,
    '#tooltipNeeded':true,
    '#tooltipText':"Password must be of 8 to 14 characters, have atleast one capital, one small, one digit and one special character(@$!%*?&)"
  },
  passwordReset: {
    '#type': 'checkbox',
    '#title': 'Change Password on Next Login',
    '#webform_key': 'passwordReset',
    '#required': false,
  },
};

export const report_module = {
  report_name : {
    '#type': 'select',
    '#title': 'Select Report',
    '#webform_key': 'select_report',
    '#required': true,
    '#options': {
      'RCH Implementation':'RCH Implementation',
      'Women Beneficiary Registration':'Women Beneficiary Registration',
      'Child Beneficiary':'Child Beneficiary',
      'Beneficiary - Temporary Registrations':'Beneficiary - Temporary Registrations',
      'Facilities without HFR Seeding':'Facilities without HFR Seeding',
      'Health Providers without HPR or ABHA Number':'Health Providers without HPR or ABHA Number',
      'Family Planning':'Family Planning',
      'Service Delivery Coverage - Maternal Health':'Service Delivery Coverage - Maternal Health'
    }
  }
}

export const report_time_period = {
  duration_type_for_PW:{
        "#type": "radios",
        "#title": "Duration Type for PW",
        '#options': {
          'LMP Date': 'LMP Date',
          'Registration Date' : 'Registration Date'
        },
        "#options_display": "side_by_side",
        "#states": {
          "visible": {
            ":input[name=\"hbnc_defect_identified_treated_referred\"]": {
              "value": "Treated"
            }
          }
        },
        '#display':'show'
      },
      duration_type_for_child:{
        "#type": "radios",
        "#title": "Duration Type for Child",
        '#options': {
          'Date of Birth': 'Date of Birth',
          'Registration Date' : 'Registration Date'
        },
        "#options_display": "side_by_side",
        "#states": {
          "visible": {
            ":input[name=\"hbnc_defect_identified_treated_referred\"]": {
              "value": "Treated"
            }
          }
        }
      },
  select_duration:{
    '#type': 'date',
    '#title': 'Select Duration',
    '#webform_key': 'select_duration',
    '#required': true,
  },
}

export const report_hierarchy = {
  state:{
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    '#required': true,
    '#options': {
      'Andhra Pradesh': 'Andhra Pradesh',
      'Arunachal Pradesh': 'Arunachal Pradesh',
    },
  },
  zone:{
    '#type': 'select',
    '#title': 'Zone/Division/Circle',
    '#webform_key': 'Zone_Division_Circle',
    '#required': false,
    '#options': {
      'Zone Name 1': 'Zone Name 1',
      'Zone Name 2': 'Zone Name 2',
    },
  },
  rural_urban:{
    '#type': 'select',
    '#title': 'Rural/Urban',
    '#webform_key': 'rural_ruban',
    '#required': false,
    '#options': {
      Rural: 'Rural',
      Urban: 'Urban',
    },
  },
  district:{
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    '#required': false,
    '#options': {
      'District 1': 'District 1',
      'District 2': 'District 2',
    },
  },
  sub_district:{
    '#type':'select',
    '#title':'Sub-district',
    '#webform_key': 'sub-district',
    '#required': false,
    '#options': {
      'Sub-District 1': 'Sub-District 1',
      'Sub-District 2': 'Sub-District 2',
    },
  },
  ulb:{
    '#type': 'select',
    '#title': 'ULB Name',
    '#webform_key': 'ulb',
    '#required': false,
    '#options': {
      'ULB Name': 'ULB Name',
      'ULB Name2': 'ULB Name2',
    },
  },
  block:{
    '#type': 'select',
    '#title': 'Block',
    '#webform_key': 'block',
    '#required': false,
    '#options': {
      'B1': 'B1',
      'B12': 'B12',
    },
  },
  health_block:{
    '#type': 'select',
    '#title': 'Health Block / Sub- division',
    '#webform_key': 'block',
    '#required': false,
    '#options': {
      'Health Block 1': 'Health Block 1',
      'Health Block 2': 'Health Block 2',
    },
  },
}

export const report_facility_details = {
  facility_type:{
    '#type': 'select',
    '#title': 'Facility Type',
    '#webform_key': 'facility_type',
    '#required': false,
    '#options': {
      'Facility Type': 'Facility Type',
      'Facility Type2': 'Facility Type2',
    },
  },
  facility_ownership:{
    '#type': 'select',
    '#title': 'Facility Ownership',
    '#webform_key': 'facility_ownership',
    '#required': false,
    '#options': {
      'Public': 'Public',
      'Private': 'Private',
    },
  },
  facility_name:{
    '#type': 'select',
    '#title': 'Facility Name',
    '#webform_key': 'facility_name',
    '#required': false,
    '#options': {
      'Facility Name 1': 'Facility Name 1',
      'Facility Name 2': 'Facility Name 2',
    },
  }
}
export const BenificiarySelfRegistrationconstant = {
  abha_number: {
    '#type': 'textfield',
    '#title': 'ABHA Number',
    '#webform_key': 'abha_number',
    '#isDisabled': false,
    '#required': true
  },
  beneificery_name: {
    '#type': 'textfield',
    '#title': 'Beneficiary Name',
    '#webform_key': 'beneificery_name',
    '#required': true,
    '#isDisabled': true,
  },
  Gender: {
    '#type': 'select',
    '#title': ' Gender',
    '#webform_key': 'Gender',
    '#isDisabled': true,
    '#required': true,
    '#options': {
      // Male: 'Male',
      Female: 'Female',

    },
  },
  Beneficiary_DOB: {
    '#type': 'date',
    '#title': 'Beneficiary DOB',
    '#webform_key': 'Beneficiary_DOB',
    '#required': true,
    '#isDisabled': true,
  },
  Beneficiary_Mobile_Number: {
    '#type': 'textfield',
    '#title': 'Mobile Number',
    '#webform_key': 'Beneficiary_Mobile_Number',
    '#isDisabled': true,
    '#required': true,
  },
  abhaAddress: {
    '#type': 'textfield',
    '#title': 'ABHA Address',
    '#webform_key': 'abhaAddress',
    '#required': true,
    '#isDisabled': true,
  },
}
export const TemporaryBenificryconstant={
  beneificery_name : {
    '#type': 'textfield',
    '#title': 'Beneficiary Name',
    '#webform_key': 'beneificery_name',
    '#required': true,
  },
  Gender : {      
   '#type': 'select',
    '#title': ' Gender',
    '#webform_key': 'Gender',
    '#isDisabled':false,
    '#required': true,
    '#options': {
     // Male: 'Male',
      Female: 'Female',
     
    },
  },
  Beneficiary_DOB:{
'#type': 'date',
     '#title': 'Beneficiary DOB',
     '#webform_key': 'Beneficiary_DOB',
     '#required': true,
     '#maxDate':today.toISOString().split('T')[0]
  },

  Beneficiary_Mobile_Number:{
    '#type': 'textfield',
      '#title': 'Mobile Number',
      '#webform_key': 'Beneficiary_Mobile_Number',
      '#isDisabled':false,
      '#required': false,
  
  },
  Spouse_Name:{
    '#type': 'textfield',
      '#title': 'Spouse/ Guardian Name',
      '#webform': 'beneficiary_registration_women',
      '#webform_id': 'beneficiary_registration_women--beneficiary_spouse',
      '#webform_key': 'Spouse_Name',
      '#webform_parent_key': 'other_details',
      '#webform_parent_flexbox': false,
      '#webform_depth': 1,
      '#webform_children': [],
      '#webform_multiple': false,
      '#webform_composite': false,
      '#webform_parents': ['other_details', 'beneficiary_spouse'],
      '#admin_title': 'Name of Husband',
      '#webform_plugin_id': 'textfield',
      '#required': true,

    },
    caste:{
     '#type': 'select',
    '#title': ' Caste',
    '#webform_key': 'caste',
    '#isDisabled':false,
    '#required': false,
    '#options':[],
    },
    Religion:{
      '#type': 'select',
      '#title': 'Religion',
      '#webform_key': 'Religion',
      '#required': false,
      '#options': [],
    },
    other_religion:{
      '#type': 'textfield',
      '#title': 'Others',
      '#webform_key': 'other_religion',
    },
    Alternate_Phone_Number:{
      '#type': 'textfield',
      '#title': ' Alternate Phone Number',
      '#webform_key': 'Alternate_Phone_Number',
      '#isDisabled':false,
      '#required': false,
    },
    Ward:{
      '#type': 'select',
      '#title': 'Ward',
      '#webform_key': 'Ward',
      '#required': false,
      '#options': [],
    },
    Village:{
      '#type': 'select',
      '#title': 'Village',
      '#webform_key': 'Village',
      '#required': false,
      '#options': [],
    },

    Facility_Type:{
      '#type': 'select',
          '#title': 'Facility Type',
          '#webform_key': 'Facility_type',
          '#required': true,
          '#options': [],
    },
  Facility_Name:{
    '#type': 'select',
    '#title': 'Facility Name',
    '#webform_key': 'Facility_Name',
    '#required': true,
    '#options':[],
  },
  sms:{
    '#type': 'checkbox',
    '#title': 'Enroll for SMS',
    '#webform_key': 'sms',
    '#required': false,
  },
  Health_Provider_Name:{
    '#type': 'select',
    '#title': 'Health Provider Name',
    '#webform_key': 'Health_Provider_Name',
    '#required': true,
    '#options': [],

},
  Asha_Name:{
    '#type': 'select',
    '#title': 'Asha /Mobiliser Name',
    '#webform_key': 'Asha_Name',
    '#required': false,
    '#options': [],
  }
}
export const MigratedBenificryconstant={
  beneificery_name : {
    '#type': 'textfield',
    '#title': 'Beneficery Name',
    '#webform_key': 'beneificery_name',
    '#required': true,
  },
  Gender : {      
   '#type': 'select',
   '#title': ' Gender',
   '#webform_key': 'Gender',
   '#isDisabled':false,
   '#required': false,
   '#isVisible': false,
   '#options': {
    // Male: 'Male',
     Female: 'Female',
     
    },
  },
  Beneficiary_DOB:{
     '#type': 'date',
     '#title': 'Beneficiary DOB',
     '#webform_key': 'Beneficiary_DOB',
     '#required': false,
     '#isDisabled':true,
     '#maxDate':today.toISOString().split('T')[0]
  },

  abha_number:{
      '#type': 'textfield',
      '#title': 'Abha Number',
      '#webform_key': 'abha_number',
      '#isDisabled':true,
      '#required': false,
  },
  Beneficiary_Mobile_Number:{
      '#type': 'textfield',
      '#title': 'Mobile Number',
      '#webform_key': 'Beneficiary_Mobile_Number',
      '#isDisabled':false,
      '#required': false,
  },
  rch1_id:{
      '#type': 'textfield',
      '#title': 'RCH 1 ID',
      '#webform_key': 'rch1_id',
      '#isDisabled':true,
      '#required': false,
  },
  Spouse_Name:{
      '#type': 'textfield',
      '#title': 'Spouse Name',
      '#webform': 'beneficiary_registration_women',
      '#webform_id': 'beneficiary_registration_women--beneficiary_spouse',
      '#webform_key': 'Spouse_Name',
      '#webform_parent_key': 'other_details',
      '#webform_parent_flexbox': false,
      '#webform_depth': 1,
      '#webform_children': [],
      '#webform_multiple': false,
      '#webform_composite': false,
      '#webform_parents': ['other_details', 'beneficiary_spouse'],
      '#admin_title': 'Name of Husband',
      '#webform_plugin_id': 'textfield',
      '#required': true,
    },
    caste:{
     '#type': 'select',
    '#title': ' Caste',
    '#webform_key': 'caste',
    '#isDisabled':false,
    '#required': false,
    '#options':[],
    },
    Religion:{
      '#type': 'select',
      '#title': 'Religion',
      '#webform_key': 'Religion',
      '#required': false,
      '#options': [],
    },
    other_religion:{
      '#type': 'textfield',
      '#title': 'Others',
      '#webform_key': 'other_religion',
    },
    Alternate_Phone_Number:{
      '#type': 'textfield',
      '#title': ' Alternate Phone Number',
      '#webform_key': 'Alternate_Phone_Number',
      '#isDisabled':false,
      '#required': false,
    },
    state:{
      '#type': 'select',
      '#title': 'State',
      '#webform_key': 'state',
      '#required': false,
      '#isDisabled':true,
      '#options': [],
    },
    district:{
      '#type': 'select',
      '#title': 'District',
      '#webform_key': 'district',
      '#required': false,
      '#isDisabled':true,
      '#options': [],
    },
    Ward:{
      '#type': 'select',
      '#title': 'Ward',
      '#webform_key': 'Ward',
      '#required': false,
      '#options': [],
    },
    Village:{
      '#type': 'select',
      '#title': 'Village',
      '#webform_key': 'Village',
      '#required': false,
      '#options': [],
    },

  sms:{
    '#type': 'checkbox',
    '#title': 'Enroll for SMS',
    '#webform_key': 'sms',
    '#required': false,
  },
}
export const BeneficiaryAdvancedSearchConstants = {
  name: {
    '#type': 'textfield',
    '#placeHolder': 'Enter at least 3 characters',
    '#title': 'Beneficiary Name',
    '#webform_key': 'name',
    '#isDisabled': false,
    '#required': false,
  },
  dob: {
    '#type': 'date',
    '#title': 'Date of Birth',
    '#webform_key': 'dob',
    '#isDisabled': false,
    '#required': false,
  },
  beneficiaryType: {
    '#type': 'select',
    '#title': 'Beneficiary Type',
    '#webform_key': 'beneficiaryType',
    '#isDisabled': false,
    '#required': false,
    '#options': [],
  },
    abhaNumber:{
    '#type': 'textfield',
    '#title': 'Abha Number',
    '#webform_key': 'abhaNumber',
    '#isDisabled':false,
    '#required': false,
  },
  rch1Id:{
    '#type': 'textfield',
    '#title': 'RCH 1 ID',
    '#webform_key': 'rch1Id',
    '#isDisabled':false,
    '#required': false,
  },
  mob:{
    '#type': 'textfield',
    '#title': 'Mobile Number',
    '#webform_key': 'mob',
    '#isDisabled':false,
    '#required': false,
  },
  source: {
    '#type': 'select',
    '#title': 'Source',
    '#webform_key': 'source',
    '#isDisabled': false,
    '#required': false,
    '#options': [],
  },
  state: {
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    '#isDisabled': false,
    '#required': false,
    '#isVisible':false,
    '#options': [],
  },
  ulbs: {
    '#type': 'select',
    '#title': 'ULB',
    '#isDisabled': false,
    '#webform_key': 'ulbs',
    '#required': false,
    '#showPlaceholder': true,
    '#isVisible':false,
    '#options': [],
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    '#isDisabled': false,
    '#required': false,
    '#isVisible':false,
    '#options': [],
  },
  block: {
    '#type': 'select',
    '#title': 'Block',
    '#webform_key': 'block',
    '#isDisabled': false,
    '#required': false,
    '#isVisible':false,
    '#options': [],
  },
  ward: {
    '#type': 'select',
    '#title': 'Ward',
    '#webform_key': 'ward',
    '#isDisabled': false,
    '#required': false,
    '#isVisible':false,
    '#options': [],
  },
  village: {
    '#type': 'select',
    '#title': 'Village',
    '#isDisabled': false,
    '#webform_key': 'village',
    '#required': false,
    '#isVisible':false,
    '#options': [],
  },
}
export const HealthFacilityMasterReportConstant = {
  state: {
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    "#isDisabled": false,
    '#required': true,
    '#options': {
      Tamilnadu: 'Tamilnadu',
      Telengana: 'Telengana',
      karnataka: 'karnataka',
      kerala: 'kerala',
    },
  },
  zone: {
    '#type': 'select',
    '#title': 'Zone/Circle/Region',
    '#webform_key': 'state',
    "#isDisabled": false,
    '#required': false,
    '#options': {
      Zone: 'Zone',
      Zone2: 'Zone2',
    },
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    '#required': false,
    '#options': {
      'District 1': 'District 1',
      'District 2': 'District 2',
    },
  },
  ulb: {
    '#type': 'select',
    '#title': 'ULB',
    '#webform_key': 'ulb',
    '#required': false,
    '#options': {
      'ULB': 'ULB',
      'ULB2': 'ULB2',
    },
  },
  sub_district_type: {
    '#type': 'select',
    '#title': 'Sub-district Type',
    '#webform_key': 'sub-district',
    '#required': false,
    '#options': {
      'Sub-District 1': 'Sub-District 1',
      'Sub-District 2': 'Sub-District 2',
    },
  },
  sub_district: {
    '#type': 'select',
    '#title': 'Sub-district',
    '#webform_key': 'sub-district',
    '#required': false,
    '#options': {
      'Sub-District 1': 'Sub-District 1',
      'Sub-District 2': 'Sub-District 2',
    },
  },
  block: {
    '#type': 'select',
    '#title': 'Block',
    '#webform_key': 'block',
    '#required': false,
    '#options': {
      'B1': 'B1',
      'B12': 'B12',
    },
  },
  health_block: {
    '#type': 'select',
    '#title': 'Health Block',
    '#webform_key': 'block',
    '#required': false,
    '#options': {
      'Health Block 1': 'Health Block 1',
      'Health Block 2': 'Health Block 2',
    },
  },
  sub_division: {
    '#type': 'select',
    '#title': 'Sub-division',
    '#webform_key': 'sub_division',
    '#required': false,
    '#options': {
      Healthblock1: 'Sub Division 1',
      Healthblock2: 'Sub Division 2',
      Healthblock3: 'Sub Division 3',
    },
  },
  parlimentary: {
    '#type': 'select',
    '#title': 'Parlimentary',
    '#webform_key': 'parlimentary',
    '#required': false,
    '#options': {
      Healthblock1: 'Health-block1',
      Healthblock2: 'Health-block2',
      Healthblock3: 'Health-block3',
    },
  },
  lac: {
    '#type': 'select',
    '#title': 'LAC',
    '#webform_key': 'lac',
    '#required': false,
    '#options': {
      Healthblock1: 'Health-block1',
      Healthblock2: 'Health-block2',
      Healthblock3: 'Health-block3',
    },
  },
  rural_urban: {
    '#type': 'select',
    '#title': 'Rural/Urban',
    '#webform_key': 'rural_ruban',
    '#required': false,
    '#options': {
      Rural: 'Rural',
      Urban: 'Urban',
    },
  },

}

 




// export const report_filters ={
//   select_duration:{
//     '#type': 'date',
//     '#title': 'Select Duration',
//     '#webform_key': 'select_duration',
//     '#required': true,
//   },
//   state:{
//     '#type': 'select',
//     '#title': 'State',
//     '#webform_key': 'state',
//     '#required': true,
//     '#options': {
//       'State 1': 'State 1',
//       'State 2': 'State 2',
//     },
//   },
//   district:{
//     '#type': 'select',
//     '#title': 'District',
//     '#webform_key': 'district',
//     '#required': true,
//     '#options': {
//       'District 1': 'District 1',
//       'District 2': 'District 2',
//     },
//   },
//   rural_urban:{
//     '#type': 'select',
//     '#title': 'Rural/Urban',
//     '#webform_key': 'rural_ruban',
//     '#required': true,
//     '#options': {
//       Rural: 'Rural',
//       Urban: 'Urban',
//     },
//   },
//   block_ulb:{
//     '#type': 'select',
//     '#title': 'BLock/ULB Name',
//     '#webform_key': 'block_ulb',
//     '#required': true,
//     '#options': {
//       B1: 'B1',
//       B2: 'B2',
//     },
//   },
//   facility_type:{
//     '#type': 'select',
//     '#title': 'Facility Type',
//     '#webform_key': 'facility_type',
//     '#required': true,
//     '#options': {
//       Facility1: 'Facility1',
//       Facility2: 'Facility2',
//     },
//   },
//   facility_name:{
//     '#type': 'select',
//     '#title': 'Facility Name',
//     '#webform_key': 'facility_name',
//     '#required': true,
//     '#options': {
//       'Facility Name 1': 'Facility Name 1',
//       'Facility Name 2': 'Facility Name 2',
//     },
//   }

// }

export const update_facilitydetails = {
  hpr_id: {
    '#type': 'verify',
    '#title': 'HFR ID',
    '#isDisabled':false,
    '#webform_key': 'hpr_id',
    '#required': true,
  },
  facility_category: {
    '#type': 'select',
    '#title': 'Facility Category',
    '#webform_key': 'facility_category',
    '#required': false,
    '#multiDropdown':true,
    '#isDisabled':false,
    '#options': {
      // HFN1: 'Delivery Point',
      // HFN2: 'NRC',
      // HFN3: 'NUHM Funded (only for Urban PHC)',
    },
  },
  facility_name: {
    '#type': 'textfield',
    '#title': 'Health Facility Name',
    '#webform_key': 'facility_name',
    '#required': true,
    '#isDisabled':true,
  },
  facility_type: {
    '#type': 'select',
    '#title': 'Health Facility Type',
    '#webform_key': 'facility_type',
    '#isDisabled':true,
    '#required': false,
    '#options': {
      HFN1: 'PHC',
      HFN2: 'District Hospital',
      HFN3: 'Railway Hospital',
    },
  },
  ownership: {
    '#type': 'select',
    '#title': 'Ownership',
    '#webform_key': 'ownership',
    '#required': false,
    '#isDisabled':true,
    '#options': {
      HFN1: 'Ownership1',
      HFN2: 'Ownership2',
      HFN3: 'Ownership3',
    },
  },
  administrative_body: {
    '#type': 'select',
    '#title': 'Administrative Body',
    '#webform_key': 'administrative_body',
    '#required': false,
    '#isDisabled':true,
    '#options': {
      HFN1: 'Admin1',
      HFN2: 'Admin2',
      HFN3: 'Admin3',
    },
  },
  central_govt_dept: {
    '#type': 'select',
    '#title': 'Central Government Dept',
    '#webform_key': 'central_govt_dept',
    '#isDisabled':true,
    '#required': false,
    '#options': {
      HFN1: 'HFN1',
      HFN2: 'HFN2',
      HFN3: 'HFN3',
    },
  },
  rural_urban: {
    '#type': 'select',
    '#title': 'Rural/Urban',
    '#webform_key': 'rural_urban',
    '#isDisabled':false,
    '#required': true,
    '#options': {
      Rural: 'Rural',
      Urban: 'Urban',
    },
  },
};
export const update_enrollmentdetails = {
  date_of_enrollment: {
    '#type': 'date',
    '#title': 'Date of Enrollment',
    '#webform_key': 'date_of_enrollment',
    '#isDisabled':true,
    '#required': false,
    // '#dateMinimum':'true',
    // '#maxDate':today.toISOString().split('T')[0],
    // '#minDate':'2005-01-01'
  },
  effective_from_date: {
    '#type': 'date',
    '#title': 'Effective from Date',
    '#isDisabled':true,
    '#webform_key': 'effective_from_date',
    '#required': false,
    // '#dateMinimum':'true',
    
  },
  status: {
    '#type': 'select',
    '#title': 'Status',
    '#webform_key': 'status',
    '#required': false,
    '#isDisabled':true,
    '#options': {
      Functional: 'Functional',
      PermanentlyClosed: 'Permanently Closed',
      TemporarilyClosed: 'Temporarily Closed',
    },
  },
  sanctionedbed_count: {
    '#type': 'textfield',
    '#title': 'Sanctioned Bed Count',
    '#webform_key': 'sanctionedbed_count',
    '#required': false,
  },
  functionalbed_count: {
    '#type': 'textfield',
    '#title': 'Functional Bed Count',
    '#webform_key': 'functionalbed_count',
    '#required': false,
    '#isDisabled':true
  },
};
export const ancFormData={
  date: {
    '#type': 'date',
    '#title': 'Date of ANC Visit',
    '#webform_key': 'date',
    '#required': true,
   },
   visitType: {
    '#type': 'select',
    '#title': 'Visit Type',
    '#webform_key': 'visitType',
    "#isDisabled":false,
    '#required': true,
  },
  completedWeeks: {
    '#type': 'textfield',
    '#title': 'Completed weeks of Pregnancy',
    '#webform_key': 'completedWeeks',
    "#isDisabled":true,
    '#required': true,
  },
}
export const deliveryVisitData={
  date: {
    '#type': 'date',
    '#title': 'Date of Visit',
    '#webform_key': 'date',
    '#required': true,
    '#minDate': dayjs().subtract(14, 'day'),
    '#maxDate': today,
  },
}

export const pregnancyFormData={
  result: {
    '#type': 'textfield',
    '#title': 'Pregnancy Test Result',
    '#webform_key': 'result',
    "#isDisabled":true,
    '#required': true,
  },
  firstPregnancy: {
    '#type': 'select',
    '#title': 'Is this First Pregnancy?',
    '#webform_key': 'firstPregnancy',
    '#required': true,
    '#options':[
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ],
  },
  dateOfRegistration: {
    '#type': 'date',
    '#title': 'Date of Registration',
    '#webform_key': 'dateOfRegistration',
    '#required': true,
    '#minDate': dayjs().subtract(config.serviceDateLimit, 'day'),
    '#maxDate': dayjs(),
    '#useRelativePopup':true,
  },
  jsy: {
    '#type': 'checkbox',
    '#title': 'Is JSY Entitled?',
    '#webform_key': 'jsy',
    '#required': false
  },
  facilityType: {
    '#type': 'select',
    '#title': 'Facility Type',
    '#webform_key': 'facilityType',
    '#required': true,
    '#options': []
  },
  facilityName: {
    '#type': 'select',
    '#title': 'Facility Name',
    '#webform_key': 'facilityName',
    '#required': true,
    '#options': []
  },
  hprName: {
    '#type': 'select',
    '#title': 'Health Provider Name',
    '#webform_key': 'hprName',
    '#required': true,
  },
  ashaName: {
    '#type': 'select',
    '#title': 'Asha Name',
    '#webform_key': 'ashaName',
  },
  //  dateOfReg: {
  //   '#type': 'date',
  //   '#title': 'Date of Registration',
  //   '#webform_key': 'dateOfReg',
  //   '#required': true,
  //   "#minDate": dayjs(new Date()).subtract(14, 'day').format("YYYY-MM-DD"),
  //   '#maxDate': today,
  // },
}
export const update_hierarchy_details = {
  state: {
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    "#isDisabled":true,
    '#required': true,
    '#options': {
      Tamilnadu: 'Tamilnadu',
      Telengana: 'Telengana',
      karnataka: 'karnataka',
      kerala: 'kerala',
    },
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    "#isDisabled":true,
    '#required': true,
    '#options': {
      villupuram: 'villupuram',
      maduari: 'madurai',
      chengalpattu: 'chengalpattu',
    },
  },
  rural_urban: {
    '#type': 'select',
    '#title': 'Rural/Urban',
    '#webform_key': 'rural_urban',
    '#required': true,
    '#options': {
      Rural: 'Rural',
      Urban: 'Urban',
    },
  },
  ulb: {
    '#type': 'select',
    '#title': 'ULB',
    '#webform_key': 'ulb',
    '#required': true,
    '#options': {
      Chennai: 'ULB-1',
      Madurai: 'ULB-2',
      Coimbatore: 'ULB-3',
    },
  },
  sub_district: {
    '#type': 'select',
    '#title': 'Sub-District',
    '#webform_key': 'sub_district',
    '#required': true,
    '#options': {
      Kumbakonam: 'Kumbakonam',
      Trichy: 'Trichy',
      Tambaram: 'Tambaram',
    },
  },
  block: {
    '#type': 'select',
    '#title': 'Block',
    '#webform_key': 'block',
    '#required': true,
    '#options': {
      block1: 'block-1',
      block2: 'block-2',
      block3: 'block-3',
    },
  },
  health_block: {
    '#type': 'select',
    '#title': 'Health Block',
    '#webform_key': 'health_block',
    '#required': false,
    '#options': {
      Healthblock1: 'Health-block1',
      Healthblock2: 'Health-block2',
      Healthblock3: 'Health-block3',
    },
  },
  sub_division: {
    '#type': 'select',
    '#title': 'Sub Division',
    '#webform_key': 'sub_division',
    '#required': false,
    '#options': {
      Healthblock1: 'Sub Division 1',
      Healthblock2: 'Sub Division 2',
      Healthblock3: 'Sub Division 3',
    },
  },
  village: {
    '#type': 'select',
    '#title': 'Village',
    '#webform_key': 'village',
    '#required': false,
    '#options': {
      Healthblock1: 'village-1',
      Healthblock2: 'village-2',
      Healthblock3: 'village-3',
    },
  },
  ward: {
    '#type': 'select',
    '#title': 'Ward',
    '#webform_key': 'ward',
    '#required': false,
    '#options': {
      Healthblock1: 'ward-1',
      Healthblock2: 'ward-2',
      Healthblock3: 'ward-3',
    },
  },
  parlimentary: {
    '#type': 'select',
    '#title': 'Parlimentary',
    '#webform_key': 'parlimentary',
    '#required': false,
    '#options': {
      Healthblock1: 'Health-block1',
      Healthblock2: 'Health-block2',
      Healthblock3: 'Health-block3',
    },
  },
  lac: {
    '#type': 'select',
    '#title': 'LAC',
    '#webform_key': 'lac',
    '#required': false,
    '#options': {
      Healthblock1: 'Health-block1',
      Healthblock2: 'Health-block2',
      Healthblock3: 'Health-block3',
    },
  },
};
export const deliveryDetails = {
  dateOfDelivery: {
    '#type': 'date',
    '#title': 'Date of Delivery',
    '#webform_key': 'dateOfDelivery',
    '#required': true,
  },
  timeOfDelivery: {
    '#type': 'time',
    '#title': 'Time of Delivery',
    '#webform_key': 'timeOfDelivery',
    '#required': true,
  },
  typeOfDelivery: {
    '#type': 'select',
    '#title': 'Type of Delivery',
    '#webform_key': 'typeOfDelivery',
    '#required': true,
    '#options': [],
  },
  placeOfDelivery: {
    '#type': 'select',
    '#title': 'Place of Delivery',
    '#webform_key': 'placeOfDelivery',
    '#required': true,
    '#options': []
  },
  whetherTabMisoprostolGiven: {
    '#type': 'select',
    '#title': 'If Home delivery, whether Tab Misoprostol given?',
    '#webform_key': 'whetherTabMisoprostolGiven',
    '#isDisabled':true,
    '#options': [],
  },
  whetherConductedSkilledPerson: {
    '#type': 'select',
    '#title': 'If Home delivery, whether conducted by Skilled Birth attendant',
    '#webform_key': 'whetherConductedSkilledPerson',
    '#isDisabled':true,
    '#options': []
  },
  deliveryComplications: {
    '#type': 'select',
    '#title': 'Delivery Complications',
    '#webform_key': 'deliveryComplications',
    '#required': true,
    '#multiDropdown': true,
    '#options': [],
  },
  noOfLiveBirth: {
    '#type': 'textfield',
    '#title': 'Number of Live Birth',
    '#webform_key': 'noOfLiveBirth',
    '#required': true,
    '#isDisabled':false,
  },
  noOfStillBirth: {
    '#type': 'textfield',
    '#title': 'Number of Still Birth',
    '#webform_key': 'noOfStillBirth',
    '#required': true,
    '#isDisabled':false,
  },
  stillBirthType: {
    '#type': 'select',
    '#title': 'If Still Birth type?',
    '#webform_key': 'stillBirthType',
    '#isDisabled':true,
    '#options': []
  },
  ppicdInserted: {
    '#type': 'select',
    '#title': 'If PPIUCD inserted?',
    '#webform_key': 'ppicdInserted',
    '#required': true,
    '#options': [],
  },
  ppicdInsertedType: {
    '#type': 'select',
    '#title': 'PPIUCD Inserted Type',
    '#webform_key': 'ppicdInsertedType',
    '#options': [],
    '#isDisabled':true,

  },
  dateOfDischarge: {
    '#type': 'date',
    '#title': 'Date of Discharge',
    '#webform_key': 'dateOfDischarge',
    '#required': false,
    '#isDisabled':true,
  },
  timeOfDischarge: {
    '#type': 'time',
    '#title': 'Time of Discharge',
    '#webform_key': 'timeOfDischarge',
    '#required': false,
    '#isDisabled':true,
  },
}

export const childRegistration = {
  isMotherAlive: {
    '#type': 'select',
    '#title': 'Is Mother Alive?',
    '#webform_key': 'isMotherAlive',
    '#required': true,
    '#isMotherAlive': false,
  },
  dateOfreg: {
    '#type': 'date',
    '#title': 'Date of Registration',
    '#webform_key': 'dateOfreg',
    '#required': true,
    '#dateMinimum':'true',
    '#isDisabled':true,
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate':'2000-01-01'
  },
  timeOfreg: {
    '#type': 'date',
    '#title': 'Time of Registration',
    '#webform_key': 'timeOfreg',
    '#required': true,
    '#dateMinimum':'true',
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate':'2000-01-01',
    '#isDisabled':true,
    '#showTime':true,
  },
  relationWithChild: {
    '#type': 'select',
    '#title': 'Relation with Child',
    '#webform_key': 'relationWithChild',
    '#required': true,
    '#options': {
      Mother: 'Mother',
    },
  },
  name: {
    '#type': 'textfield',
    '#title': 'Name of Child',
    '#webform_key': 'name',
    '#required': true,
  },
  dob: {
    '#type': 'date',
    '#title': 'Date of Birth',
    '#webform_key': 'dob',
    '#required': true,
    '#dateMinimum':'true',
    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    '#minDate':dayjs().subtract(5, 'year').format('YYYY-MM-DD')
  },
  timeOfbirth: {
    '#type': 'time',
    '#title': 'Time of Birth',
    '#webform_key': 'timeOfbirth',
    '#required': true,
    '#isDisabled':true,
  },
  gender: {
    '#type': 'select',
    '#title': 'Sex',
    '#webform_key': 'gender',
    '#required': true,
    '#options': {
      Male: 'Male',
      Female: 'Female',
    },
  },
  childAbha: {
    '#type': 'createAndVerify',
    '#title': 'Child/ BALABHA',
    '#webform_key': 'childAbha',
    '#id': 'parentchild',
    '#flow':'delivery',
  },
  maturity: {
    '#type': 'select',
    '#title': 'Maturity',
    '#webform_key': 'maturity',
    '#required': true,
    '#options': {},
  },
  weight: {
    '#type': 'textfield',
    '#title': 'Weight at Birth(gms)',
    '#webform_key': 'weight',
    '#required': true,
  },
};

export const childForm = {
  name: {
    '#type': 'textfield',
    '#title': 'Name of Child',
    '#webform_key': 'name',
    '#required': true,
  },
  timeOfbirth: {
    '#type': 'time',
    '#title': 'Time of Birth',
    '#webform_key': 'timeOfbirth',
    '#required': true,
    '#maxTime': dayjs(),
    '#isCurrentTime': true,
  },
  gender: {
    '#type': 'select',
    '#title': 'Sex',
    '#webform_key': 'gender',
    '#required': true,
    '#options': {
      Male: 'Male',
      Female: 'Female',
    },
  },
  childAbha: {
    '#type': 'createAndVerify',
    '#title': 'Child/ BALABHA',
    '#webform_key': 'childAbha',
    '#id': '',
    '#flow':'delivery',
  },
  maturity: {
    '#type': 'select',
    '#title': 'Maturity',
    '#webform_key': 'maturity',
    '#required': true,
    '#options': {},
  },
  weight: {
    '#type': 'textfield',
    '#title': 'Weight at Birth(gms)',
    '#webform_key': 'weight',
    '#required': true,
  },
}



export const update_location_details = {
  pincode: {
    '#type': 'textfield',
    '#title': 'Pincode',
    '#webform_key': 'pincode',
    '#required': true,
  },
  lattitude: {
    '#type': 'textfield',
    '#title': 'Lattitude',
    '#webform_key': 'lattitude',
    '#required': true,
  },
  longitude: {
    '#type': 'textfield',
    '#title': 'Longitude',
    '#webform_key': 'longitude',
    '#required': true,
  },
  address: {
    '#type': 'textfield',
    '#title': 'Address',
    '#webform_key': 'address',
    '#required': true,
  },
};

export const update_coverage_details = {
  // linked_facilities: {
  //   '#type': 'select',
  //   '#title': 'Linked Facilities',
  //   '#webform_key': 'linked_facilities',
  //   '#required': true,
  //   '#options': {
  //     "Noble Hospital": "Noble Hospital",
  //     "Ourlady of Grace Maternity Clinic": "Ourlady of Grace Maternity Clinic",
  //     "Sankalp Nursing Home": "Sankalp Nursing Home",
  //     "Talaulikar Nursing Home": "Talaulikar Nursing Home",
  //     "Kholpe": "Kholpe",
  //     "Srujan Polyclinic": "Srujan Polyclinic"
  //   }
  // },
  linked_facilities: {
    '#type': 'selectionDropdown',
    '#title': 'Linked Facilities',
    '#webform_key': 'linked_facilities',
    '#required': false,
    '#options': {}
  },
  villages_covered: {
    '#type': 'selectionDropdown',
    '#title': 'Villages Covered',
    '#webform_key': 'villages_covered',
    '#required': true,
    '#options': {},
  },
  wards_covered: {
    '#type': 'selectionDropdown',
    '#title': 'Wards Covered',
    '#webform_key': 'wards_covered',
    '#required': true,
    '#options': {},
  },
};

export const upgrade_facilitydetails = {
  hpr_id: {
    '#type': 'verify',
    '#title': 'HFR ID',
    '#isDisabled':false,
    '#webform_key': 'hpr_id',
    '#required': false,
  },
  facility_category: {
    '#type': 'select',
    '#title': 'Facility Category',
    '#webform_key': 'facility_category',
    '#required': false,
    '#multiDropdown':true,
    '#isDisabled':false,
    '#options': {
      // HFN1: 'Delivery Point',
      // HFN2: 'NRC',
      // HFN3: 'NUHM Funded (only for Urban PHC)',
    },
  },
  facility_name: {
    '#type': 'textfield',
    '#title': 'Health Facility Name',
    '#webform_key': 'facility_name',
    '#required': true,
    '#isDisabled':true,
  },
  facility_type: {
    '#type': 'select',
    '#title': 'Health Facility Type',
    '#webform_key': 'facility_type',
    '#isDisabled':false,
    '#required': true,
    '#options': {
      HFN1: 'PHC',
      HFN2: 'District Hospital',
      HFN3: 'Railway Hospital',
    },
  },
  ownership: {
    '#type': 'select',
    '#title': 'Ownership',
    '#webform_key': 'ownership',
    '#required': false,
    '#isDisabled':true,
    '#options': {
      HFN1: 'Ownership1',
      HFN2: 'Ownership2',
      HFN3: 'Ownership3',
    },
  },
  administrative_body: {
    '#type': 'select',
    '#title': 'Administrative Body',
    '#webform_key': 'administrative_body',
    '#required': false,
    '#isDisabled':true,
    '#options': {
      HFN1: 'Admin1',
      HFN2: 'Admin2',
      HFN3: 'Admin3',
    },
  },
  central_govt_dept: {
    '#type': 'select',
    '#title': 'Central Government Dept',
    '#webform_key': 'central_govt_dept',
    '#isDisabled':true,
    '#required': false,
    '#options': {
      HFN1: 'HFN1',
      HFN2: 'HFN2',
      HFN3: 'HFN3',
    },
  },
  rural_urban: {
    '#type': 'select',
    '#title': 'Rural/Urban',
    '#webform_key': 'rural_urban',
    '#isDisabled':false,
    '#required': true,
    '#options': {
      Rural: 'Rural',
      Urban: 'Urban',
    },
  },
};
export const upgrade_enrollmentdetails = {
  date_of_enrollment: {
    '#type': 'date',
    '#title': 'Date of Enrollment',
    '#webform_key': 'date_of_enrollment',
    '#isDisabled':true,
    '#required': false,
    '#dateMinimum':'true',
     '#maxDate':today.toISOString().split('T')[0],
    '#minDate':'2005-01-01'
  },
  effective_from_date: {
    '#type': 'date',
    '#title': 'Effective from Date',
    '#isDisabled':false,
    '#webform_key': 'effective_from_date',
    '#required': true,
    '#dateMinimum':'true',
    '#maxDate':today.toISOString().split('T')[0],
    '#minDate':oneYearAgoDate
  },
  status: {
    '#type': 'select',
    '#title': 'Status',
    '#webform_key': 'status',
    '#required': true,
    '#isDisabled':false,
    '#options': {
      Functional: 'Functional',
      PermanentlyClosed: 'Permanently Closed',
      TemporarilyClosed: 'Temporarily Closed',
    },
  },
  sanctionedbed_count: {
    '#type': 'textfield',
    '#title': 'Sanctioned Bed Count',
    '#webform_key': 'sanctionedbed_count',
    '#required': false,
  },
  functionalbed_count: {
    '#type': 'textfield',
    '#title': 'Functional Bed Count',
    '#webform_key': 'functionalbed_count',
    '#required': false,
    '#isDisabled':true,
  },
};
export const upgrade_hierarchy_details = {
  state: {
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    "#isDisabled":true,
    '#required': true,
    '#options': {
      Tamilnadu: 'Tamilnadu',
      Telengana: 'Telengana',
      karnataka: 'karnataka',
      kerala: 'kerala',
    },
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    "#isDisabled":false,
    '#required': true,
    '#options': {
      villupuram: 'villupuram',
      maduari: 'madurai',
      chengalpattu: 'chengalpattu',
    },
  },
  ulb: {
    '#type': 'select',
    '#title': 'ULB',
    '#webform_key': 'ulb',
    '#required': true,
    '#options': {
      Chennai: 'ULB-1',
      Madurai: 'ULB-2',
      Coimbatore: 'ULB-3',
    },
  },
  sub_district: {
    '#type': 'select',
    '#title': 'Sub-District',
    '#webform_key': 'sub_district',
    '#required': true,
    '#options': {
      Kumbakonam: 'Kumbakonam',
      Trichy: 'Trichy',
      Tambaram: 'Tambaram',
    },
  },
  block: {
    '#type': 'select',
    '#title': 'Block',
    '#webform_key': 'block',
    '#required': true,
    '#options': {
      block1: 'block-1',
      block2: 'block-2',
      block3: 'block-3',
    },
  },
  health_block: {
    '#type': 'select',
    '#title': 'Health Block',
    '#webform_key': 'health_block',
    '#required': false,
    '#options': {
      Healthblock1: 'Health-block1',
      Healthblock2: 'Health-block2',
      Healthblock3: 'Health-block3',
    },
  },
  sub_division: {
    '#type': 'select',
    '#title': 'Sub Division',
    '#webform_key': 'sub_division',
    '#required': false,
    '#options': {
      Healthblock1: 'Sub Division 1',
      Healthblock2: 'Sub Division 2',
      Healthblock3: 'Sub Division 3',
    },
  },
  village: {
    '#type': 'select',
    '#title': 'Village',
    '#webform_key': 'village',
    '#required': false,
    '#options': {
      Healthblock1: 'village-1',
      Healthblock2: 'village-2',
      Healthblock3: 'village-3',
    },
  },
  ward: {
    '#type': 'select',
    '#title': 'Ward',
    '#webform_key': 'ward',
    '#required': true,
    '#options': {
      Healthblock1: 'ward-1',
      Healthblock2: 'ward-2',
      Healthblock3: 'ward-3',
    },
  },
  parlimentary: {
    '#type': 'select',
    '#title': 'Parlimentary',
    '#webform_key': 'parlimentary',
    '#required': false,
    '#options': {
      Healthblock1: 'Health-block1',
      Healthblock2: 'Health-block2',
      Healthblock3: 'Health-block3',
    },
  },
  lac: {
    '#type': 'select',
    '#title': 'LAC',
    '#webform_key': 'lac',
    '#required': false,
    '#options': {
      // Healthblock1: 'Health-block1',
      // Healthblock2: 'Health-block2',
      // Healthblock3: 'Health-block3',
    },
  },
};

export const upgrade_rural_hierarchy_details = {
  state: {
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    "#isDisabled":true,
    '#required': false,
    '#options': {
      Tamilnadu: 'Tamilnadu',
      Telengana: 'Telengana',
      karnataka: 'karnataka',
      kerala: 'kerala',
    },
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    "#isDisabled":false,
    '#required': true,
    '#options': {
      villupuram: 'villupuram',
      maduari: 'madurai',
      chengalpattu: 'chengalpattu',
    },
  },
  sub_district: {
    '#type': 'select',
    '#title': 'Sub-District',
    '#webform_key': 'sub_district',
    '#required': true,
    '#options': {
      Kumbakonam: 'Kumbakonam',
      Trichy: 'Trichy',
      Tambaram: 'Tambaram',
    },
  },
  block: {
    '#type': 'select',
    '#title': 'Block',
    '#webform_key': 'block',
    '#required': false,
    '#options': {},
  },
  health_block: {
    '#type': 'select',
    '#title': 'Health Block',
    '#webform_key': 'health_block',
    '#required': false,
    '#options': {
      Healthblock1: 'Health-block1',
      Healthblock2: 'Health-block2',
      Healthblock3: 'Health-block3',
    },
  },
  sub_division: {
    '#type': 'select',
    '#title': 'Sub Division',
    '#webform_key': 'sub_division',
    '#required': false,
    '#options': {
      Healthblock1: 'Sub Division 1',
      Healthblock2: 'Sub Division 2',
      Healthblock3: 'Sub Division 3',
    },
  },
  village: {
    '#type': 'select',
    '#title': 'Village',
    '#webform_key': 'village',
    '#required': false,
    '#isVisible':false,
    '#options': {
      // Healthblock1: 'village-1',
      // Healthblock2: 'village-2',
      // Healthblock3: 'village-3',
    },
  },
  gram_panchayat: {
    '#type': 'select',
    '#title': 'Gram Panchayat / ADC Village',
    '#webform_key': 'gram_panchayat',
    '#required': true,
    '#isVisible':false,
    '#options': {
    },
  },

  parlimentary: {
    '#type': 'select',
    '#title': 'Parlimentary',
    '#webform_key': 'parlimentary',
    '#required': false,
    '#options': {
      // Healthblock1: 'Health-block1',
      // Healthblock2: 'Health-block2',
      // Healthblock3: 'Health-block3',
    },
  },
  lac: {
    '#type': 'select',
    '#title': 'LAC',
    '#webform_key': 'lac',
    '#required': false,
    '#options': {
      // Healthblock1: 'Health-block1',
      // Healthblock2: 'Health-block2',
      // Healthblock3: 'Health-block3',
    },
  },
};


export const upgrade_urban_hierarchy_details = {
  state: {
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    "#isDisabled":true,
    '#required': false,
    '#options': {
      Tamilnadu: 'Tamilnadu',
      Telengana: 'Telengana',
      karnataka: 'karnataka',
      kerala: 'kerala',
    },
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    "#isDisabled":false,
    '#required': true,
    '#options': {
      villupuram: 'villupuram',
      maduari: 'madurai',
      chengalpattu: 'chengalpattu',
    },
  },
  ulb: {
    '#type': 'select',
    '#title': 'ULB',
    '#webform_key': 'ulb',
    '#required': true,
    '#showPlaceholder': true,
    '#options': {},
  },
  sub_district: {
    '#type': 'select',
    '#title': 'Sub-District',
    '#webform_key': 'sub_district',
    '#required': true,
    '#options': {
      Kumbakonam: 'Kumbakonam',
      Trichy: 'Trichy',
      Tambaram: 'Tambaram',
    },
  },

  health_block: {
    '#type': 'select',
    '#title': 'Health Block',
    '#webform_key': 'health_block',
    '#required': false,
    '#options': {
      Healthblock1: 'Health-block1',
      Healthblock2: 'Health-block2',
      Healthblock3: 'Health-block3',
    },
  },
  sub_division: {
    '#type': 'select',
    '#title': 'Sub Division',
    '#webform_key': 'sub_division',
    '#required': false,
    '#options': {
      Healthblock1: 'Sub Division 1',
      Healthblock2: 'Sub Division 2',
      Healthblock3: 'Sub Division 3',
    },
  },
  ward: {
    '#type': 'select',
    '#title': 'Ward',
    '#webform_key': 'ward',
    "#isDisabled":false,
    '#required': true,
    '#options': {
      // Healthblock1: 'ward-1',
      // Healthblock2: 'ward-2',
      // Healthblock3: 'ward-3',
    },
  },

  parlimentary: {
    '#type': 'select',
    '#title': 'Parlimentary',
    '#webform_key': 'parlimentary',
    '#required': false,
    '#options': {
      // Healthblock1: 'Health-block1',
      // Healthblock2: 'Health-block2',
      // Healthblock3: 'Health-block3',
    },
  },
  lac: {
    '#type': 'select',
    '#title': 'LAC',
    '#webform_key': 'lac',
    '#required': false,
    '#options': {
      // Healthblock1: 'Health-block1',
      // Healthblock2: 'Health-block2',
      // Healthblock3: 'Health-block3',
    },
  },
};

export const update_rural_hierarchy_details = {
  state: {
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    "#isDisabled":true,
    '#required': false,
    '#options': {
      Tamilnadu: 'Tamilnadu',
      Telengana: 'Telengana',
      karnataka: 'karnataka',
      kerala: 'kerala',
    },
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    "#isDisabled":true,
    '#required': false,
    '#options': {
      villupuram: 'villupuram',
      maduari: 'madurai',
      chengalpattu: 'chengalpattu',
    },
  },
  sub_district: {
    '#type': 'select',
    '#title': 'Sub-District',
    '#webform_key': 'sub_district',
    '#required': true,
    '#options': {
      Kumbakonam: 'Kumbakonam',
      Trichy: 'Trichy',
      Tambaram: 'Tambaram',
    },
  },
  block: {
    '#type': 'select',
    '#title': 'Block',
    '#webform_key': 'block',
    '#required': false,
    '#options': {},
  },
  health_block: {
    '#type': 'select',
    '#title': 'Health Block',
    '#webform_key': 'health_block',
    '#required': false,
    '#options': {
      Healthblock1: 'Health-block1',
      Healthblock2: 'Health-block2',
      Healthblock3: 'Health-block3',
    },
  },
  sub_division: {
    '#type': 'select',
    '#title': 'Sub Division',
    '#webform_key': 'sub_division',
    '#required': false,
    '#options': {
      Healthblock1: 'Sub Division 1',
      Healthblock2: 'Sub Division 2',
      Healthblock3: 'Sub Division 3',
    },
  },
  village: {
    '#type': 'select',
    '#title': 'Village',
    '#webform_key': 'village',
    '#required': false,
    '#isVisible':false,
    '#options': {
      // Healthblock1: 'village-1',
      // Healthblock2: 'village-2',
      // Healthblock3: 'village-3',
    },
  },
  gram_panchayat: {
    '#type': 'select',
    '#title': 'Gram Panchayat / ADC Village',
    '#webform_key': 'gram_panchayat',
    '#required': true,
    '#isVisible':false,
    '#options': {
    },
  },

  parlimentary: {
    '#type': 'select',
    '#title': 'Parlimentary',
    '#webform_key': 'parlimentary',
    '#required': false,
    '#options': {
      // Healthblock1: 'Health-block1',
      // Healthblock2: 'Health-block2',
      // Healthblock3: 'Health-block3',
    },
  },
  lac: {
    '#type': 'select',
    '#title': 'LAC',
    '#webform_key': 'lac',
    '#required': false,
    '#options': {
      // Healthblock1: 'Health-block1',
      // Healthblock2: 'Health-block2',
      // Healthblock3: 'Health-block3',
    },
  },
};

export const update_urban_hierarchy_details = {
  state: {
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    "#isDisabled":true,
    '#required': false,
    '#options': {
      Tamilnadu: 'Tamilnadu',
      Telengana: 'Telengana',
      karnataka: 'karnataka',
      kerala: 'kerala',
    },
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    "#isDisabled":true,
    '#required': false,
    '#options': {
      villupuram: 'villupuram',
      maduari: 'madurai',
      chengalpattu: 'chengalpattu',
    },
  },
  ulb: {
    '#type': 'select',
    '#title': 'ULB',
    '#webform_key': 'ulb',
    '#required': true,
    '#showPlaceholder': true,
    '#options': {},
  },
  sub_district: {
    '#type': 'select',
    '#title': 'Sub-District',
    '#webform_key': 'sub_district',
    '#required': true,
    '#options': {
      Kumbakonam: 'Kumbakonam',
      Trichy: 'Trichy',
      Tambaram: 'Tambaram',
    },
  },

  health_block: {
    '#type': 'select',
    '#title': 'Health Block',
    '#webform_key': 'health_block',
    '#required': false,
    '#options': {
      Healthblock1: 'Health-block1',
      Healthblock2: 'Health-block2',
      Healthblock3: 'Health-block3',
    },
  },
  sub_division: {
    '#type': 'select',
    '#title': 'Sub Division',
    '#webform_key': 'sub_division',
    '#required': false,
    '#options': {
      Healthblock1: 'Sub Division 1',
      Healthblock2: 'Sub Division 2',
      Healthblock3: 'Sub Division 3',
    },
  },
  ward: {
    '#type': 'select',
    '#title': 'Ward',
    '#webform_key': 'ward',
    "#isDisabled":false,
    '#required': true,
    '#options': {
      // Healthblock1: 'ward-1',
      // Healthblock2: 'ward-2',
      // Healthblock3: 'ward-3',
    },
  },

  parlimentary: {
    '#type': 'select',
    '#title': 'Parlimentary',
    '#webform_key': 'parlimentary',
    '#required': false,
    '#options': {
      // Healthblock1: 'Health-block1',
      // Healthblock2: 'Health-block2',
      // Healthblock3: 'Health-block3',
    },
  },
  lac: {
    '#type': 'select',
    '#title': 'LAC',
    '#webform_key': 'lac',
    '#required': false,
    '#options': {
      // Healthblock1: 'Health-block1',
      // Healthblock2: 'Health-block2',
      // Healthblock3: 'Health-block3',
    },
  },
};


export const upgrade_location_details = {
  pincode: {
    '#type': 'textfield',
    '#title': 'Pincode',
    '#webform_key': 'pincode',
    '#required': true,
    '#isDisabled': false,
  },
  lattitude: {
    '#type': 'textfield',
    '#title': 'Lattitude',
    '#webform_key': 'lattitude',
    '#required': true,
    '#isDisabled': false,
  },
  longitude: {
    '#type': 'textfield',
    '#title': 'Longitude',
    '#webform_key': 'longitude',
    '#required': true,
    '#isDisabled': false,
  },
  address: {
    '#type': 'textfield',
    '#title': 'Address',
    '#webform_key': 'address',
    '#required': true,
    '#isDisabled': false,
  },
};

export const upgrade_urban_coverage_details = {
  linked_facilities: {
    '#type': 'selectionDropdown',
    '#title': 'Linked Facilities',
    '#webform_key': 'linked_facilities',
    '#required': false,
    '#options': {}
  },

  wards_covered: {
    '#type': 'selectionDropdown',
    '#title': 'Wards Covered',
    '#webform_key': 'wards_covered',
    '#required': true,
    '#options': {},
  },
};
export const upgrade_rural_coverage_details = {
  linked_facilities: {
    '#type': 'selectionDropdown',
    '#title': 'Linked Facilities',
    '#webform_key': 'linked_facilities',
    '#required': false,
    '#options': {}
  },
  villages_covered: {
    '#type': 'selectionDropdown',
    '#title': 'Villages Covered',
    '#webform_key': 'villages_covered',
    '#required': true,
    '#options': {},
  },
};
export  const linkedUrbanFacility = [
  { id: "78667", name: 'Noble Hospital', code: 71 },
  { id: "78666", name: 'Ourlady of Grace Maternity Clinic', code:72 },
  { id: "78665", name: 'Sankalp Nursing Home', code:73 },
  { id: "78609", name: 'Talaulikar Nursing Home',code:74 },
  { id: "79967", name: 'Kholpe', code:75},
  { id: "78608", name: 'Srujan Polyclinic', code:75 },
];
export  const linkedRuralFacility = [
  { id: "68667", name: 'Noble Hospitals', code:61 },
  { id: "68666", name: 'Ourlady of Grace Maternity Clinics' , code:62},
  { id: "68665", name: 'Sankalp Nursing Homes', code:63 },
  { id: "68609", name: 'Talaulikar Nursing Homes',code:64 },
  { id: "69967", name: 'Kholpe', code:65 },
  { id: "68608", name: 'Srujan Polyclinics', code:66 },
];
export const linkedVillages = [
  { id: "76667", name: ' Mandrem', code:761},
  { id: "76666", name: ' Uguem' , code:762},
  { id: "76665", name: ' Mopa' , code:763},
  { id: "76609", name: ' Dargalim' , code:764},
  { id: "76967", name: ' Paliem' , code:765},
  { id: "76609", name: ' Poroscodem' , code:766},
  { id: "76667", name: ' Parcem' , code:767},
  { id: "76097", name: ' Amberem', code:768 },
  { id: "76067", name: ' Ozorim', code:769 },
  { id: "76567", name: ' Arambol' , code:770},
  { id: "76977", name: ' Ibrampur', code:771 },
  { id: "76467", name: ' Chopdem' , code:772},
];


export const linkedWards = [
  { id: "77667", name: 'Ward No. 6', code:773},
  { id: "77666", name: 'Ward No. 4' , code:774},
  { id: "77665", name: 'Ward No. 1' , code:775},
  { id: "77609", name: 'Ward No. 2' , code:776},
  { id: "77967", name: 'Ward No. 3' , code:777},
  { id: "77609", name: 'Ward No. 5' , code:778},
  { id: "77667", name: 'Ward No. 11', code:779},
  { id: "77097", name: 'Ward No. 7' , code:780},
  { id: "77067", name: 'Ward No. 8' , code:781},
  { id: "77567", name: 'Ward No. 9' , code:782},
  { id: "77977", name: 'Ward No. 17' , code:783},
  { id: "77467", name: 'Ward No. 10' , code:784},
]



export const create_facilitydetails = {
  facility_name: {
    '#type': 'textfield',
    '#title': 'Facility Name',
    '#webform_key': 'facility_name',
    '#required': true,
  },
  hpr_id: {
    '#type': 'verify',
    '#title': 'HFR ID',
    '#webform_key': 'hpr_id',
    '#required': false,
  },
  rural_urban: {
    '#type': 'select',
    '#title': 'Rural/Urban',
    '#webform_key': 'rural_urban',
    '#required': true,
    '#options': {
      Rural: 'Rural',
      Urban: 'Urban',
    },
  },
  facility_type: {
    '#type': 'select',
    '#title': 'Facility Type',
    '#webform_key': 'facility_type',
    '#required': true,
    '#options': {
      HFN1: 'PHC',
      HFN2: 'District Hospital',
      HFN3: 'Railway Hospital',
    },
  },
  facility_category: {
    '#type': 'select',
    '#title': 'Facility Category',
    '#webform_key': 'facility_category',
    '#required': false,
    '#multiDropdown':true,
    '#options': {
      // HFN1: 'Delivery Point',
      // HFN2: 'NRC',
      // HFN3: 'NUHM Funded (only for Urban PHC)',
    },
  },
  ownership: {
    '#type': 'select',
    '#title': 'Ownership',
    '#webform_key': 'ownership',
    '#required': false,
    '#isDisabled':true,
    '#options': {
      HFN1: 'Ownership1',
      HFN2: 'Ownership2',
      HFN3: 'Ownership3',
    },
  },
  administrative_body: {
    '#type': 'select',
    '#title': 'Administrative Body',
    '#webform_key': 'administrative_body',
    '#required': false,
    '#isDisabled':true,
    '#options': {
      HFN1: 'Admin1',
      HFN2: 'Admin2',
      HFN3: 'Admin3',
    },
  },
  central_govt_dept: {
    '#type': 'select',
    '#title': 'Central Government Department',
    '#webform_key': 'central_govt_dept',
    '#isDisabled':true,
    '#required': false,
    '#options': {
      HFN1: 'HFN1',
      HFN2: 'HFN2',
      HFN3: 'HFN3',
    },
  },
  
};
export const facility_enrollmentdetails = {
  date_of_enrollment: {
    '#type': 'date',
    '#title': 'Date of Enrollment',
    '#webform_key': 'date_of_enrollment',
    '#required': true,
    '#dateMinimum':'true',
    '#maxDate':today.toISOString().split('T')[0],
    '#minDate':'2005-01-01'
  },
  effective_from_date: {
    '#type': 'date',
    '#title': 'Effective from Date',
    '#webform_key': 'effective_from_date',
    '#required': true,
    '#dateMinimum':'true',
    '#maxDate':today.toISOString().split('T')[0],
    '#minDate':'2005-01-01',
  },
  status: {
    '#type': 'select',
    '#title': 'Status',
    '#webform_key': 'status',
    '#required': true,
    '#isDisabled':false,
    '#options': {
      // Functional: 'Functional',
      // PermanentlyClosed: 'Permanently Closed',
      // TemporarilyClosed: 'Temporarily Closed',
    },
  },
  sanctionedbed_count: {
    '#type': 'textfield',
    '#title': 'Sanctioned Bed Count',
    '#webform_key': 'sanctionedbed_count',
    '#required': false,
  },
  functionalbed_count: {
    '#type': 'textfield',
    '#title': 'Functional Bed Count',
    '#webform_key': 'functionalbed_count',
    '#required': false,
    '#isDisabled':true,
  },
};
export const hierarchy_details = {
  state: {
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    "#isDisabled":false,
    '#required': true,
    '#options': {
      Tamilnadu: 'Tamilnadu',
      Telengana: 'Telengana',
      karnataka: 'karnataka',
      kerala: 'kerala',
    },
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    "#isDisabled":false,
    '#required': true,
    '#options': {
      villupuram: 'villupuram',
      maduari: 'madurai',
      chengalpattu: 'chengalpattu',
    },
  },
  ulb: {
    '#type': 'select',
    '#title': 'ULB',
    '#webform_key': 'ulb',
    '#required': true,
    '#options': {
      Chennai: 'ULB-1',
      Madurai: 'ULB-2',
      Coimbatore: 'ULB-3',
    },
  },
  sub_district: {
    '#type': 'select',
    '#title': 'Sub-District',
    '#webform_key': 'sub_district',
    '#required': true,
    '#options': {
      Kumbakonam: 'Kumbakonam',
      Trichy: 'Trichy',
      Tambaram: 'Tambaram',
    },
  },
  block: {
    '#type': 'select',
    '#title': 'Block',
    '#webform_key': 'block',
    '#required': true,
    '#options': {
      block1: 'block-1',
      block2: 'block-2',
      block3: 'block-3',
    },
  },
  health_block: {
    '#type': 'select',
    '#title': 'Health Block',
    '#webform_key': 'health_block',
    '#required': false,
    '#options': {
      Healthblock1: 'Health-block1',
      Healthblock2: 'Health-block2',
      Healthblock3: 'Health-block3',
    },
  },
  sub_division: {
    '#type': 'select',
    '#title': 'Sub Division',
    '#webform_key': 'sub_division',
    '#required': false,
    '#options': {
      Healthblock1: 'Sub Division 1',
      Healthblock2: 'Sub Division 2',
      Healthblock3: 'Sub Division 3',
    },
  },
  village: {
    '#type': 'select',
    '#title': 'Village',
    '#webform_key': 'village',
    '#required': true,
    '#options': {
      Healthblock1: 'village-1',
      Healthblock2: 'village-2',
      Healthblock3: 'village-3',
    },
  },
  ward: {
    '#type': 'select',
    '#title': 'Ward',
    '#webform_key': 'ward',
    '#required': true,
    '#options': {
      Healthblock1: 'ward-1',
      Healthblock2: 'ward-2',
      Healthblock3: 'ward-3',
    },
  },
  parlimentary: {
    '#type': 'select',
    '#title': 'Parlimentary',
    '#webform_key': 'parlimentary',
    '#required': false,
    '#options': {
      Healthblock1: 'Health-block1',
      Healthblock2: 'Health-block2',
      Healthblock3: 'Health-block3',
    },
  },
  lac: {
    '#type': 'select',
    '#title': 'LAC',
    '#webform_key': 'lac',
    '#required': false,
    '#options': {
      Healthblock1: 'Health-block1',
      Healthblock2: 'Health-block2',
      Healthblock3: 'Health-block3',
    },
  },
};


export const hierarchy_details_urban = {
  state: {
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    "#isDisabled":false,
    '#required': true,
    '#options': {
      // State1: 'State1',
      // State2: 'State2',
      // State3: 'State3',
    }
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    "#isDisabled":false,
    '#required': true,
    '#options': {
    }
  },
  ulb: {
    '#type': 'select',
    '#title': 'ULB',
    '#webform_key': 'ulb',
    '#required': true,
    '#showPlaceholder':true,
    '#options': {},
  },
  sub_district: {
    '#type': 'select',
    '#title': 'Sub-District',
    '#webform_key': 'sub_district',
    '#required': true,
    '#options': {
      // Kumbakonam: 'Kumbakonam',
      // Trichy: 'Trichy',
      // Tambaram: 'Tambaram',
    },
  },
  health_block: {
    '#type': 'select',
    '#title': 'Health Block',
    '#webform_key': 'health_block',
    '#required': false,
    '#options': {
      // Healthblock1: 'Health-block1',
      // Healthblock2: 'Health-block2',
      // Healthblock3: 'Health-block3',
    },
  },
  sub_division: {
    '#type': 'select',
    '#title': 'Sub Division',
    '#webform_key': 'sub_division',
    '#required': false,
    '#options': {
      // Healthblock1: 'Sub Division 1',
      // Healthblock2: 'Sub Division 2',
      // Healthblock3: 'Sub Division 3',
    },
  },
  ward: {
    '#type': 'select',
    '#title': 'Ward',
    '#webform_key': 'ward',
    '#required': false,
    '#options': {
      // Healthblock1: 'ward-1',
      // Healthblock2: 'ward-2',
      // Healthblock3: 'ward-3',
    },
  },
  parlimentary: {
    '#type': 'select',
    '#title': 'Parlimentary',
    '#webform_key': 'parlimentary',
    '#required': false,
    '#options': {
      // Healthblock1: 'Health-block1',
      // Healthblock2: 'Health-block2',
      // Healthblock3: 'Health-block3',
    },
  },
  lac: {
    '#type': 'select',
    '#title': 'LAC',
    '#webform_key': 'lac',
    '#required': false,
    '#options': {
      // Healthblock1: 'Health-block1',
      // Healthblock2: 'Health-block2',
      // Healthblock3: 'Health-block3',
    },
  },
};

export const hierarchy_details_rural = {
  state: {
    '#type': 'select',
    '#title': 'State',
    '#webform_key': 'state',
    "#isDisabled":false,
    '#required': true,
    '#options': {
      
    }
  },
  district: {
    '#type': 'select',
    '#title': 'District',
    '#webform_key': 'district',
    "#isDisabled":false,
    '#required': true,
    '#options': {

    }
  },
  sub_district: {
    '#type': 'select',
    '#title': 'Sub-District',
    '#webform_key': 'sub_district',
    '#required': false,
    '#options': {
      // Kumbakonam: 'Kumbakonam',
      // Trichy: 'Trichy',
      // Tambaram: 'Tambaram',
    },
  },
  block: {
    '#type': 'select',
    '#title': 'Block',
    '#webform_key': 'block',
    '#required': false,
    '#options': {
      // block1: 'block-1',
      // block2: 'block-2',
      // block3: 'block-3',
    },
  },
  health_block: {
    '#type': 'select',
    '#title': 'Health Block',
    '#webform_key': 'health_block',
    '#required': false,
    '#options': {
      // Healthblock1: 'Health-block1',
      // Healthblock2: 'Health-block2',
      // Healthblock3: 'Health-block3',
    },
  },
  sub_division: {
    '#type': 'select',
    '#title': 'Sub Division',
    '#webform_key': 'sub_division',
    '#required': false,
    '#options': {
      // Healthblock1: 'Sub Division 1',
      // Healthblock2: 'Sub Division 2',
      // Healthblock3: 'Sub Division 3',
    },
  },
  village: {
    '#type': 'select',
    '#title': 'Village',
    '#webform_key': 'village',
    '#required': false,
    '#isVisible':false,
    '#options': {
      // Healthblock1: 'village-1',
      // Healthblock2: 'village-2',
      // Healthblock3: 'village-3',
    },
  },
  gram_panchayat: {
    '#type': 'select',
    '#title': 'Gram Panchayat / ADC Village',
    '#webform_key': 'gram_panchayat',
    '#required': false,
    '#isDisabled':false,
    '#isVisible':false,
    '#options': {
    },
  },

  parlimentary: {
    '#type': 'select',
    '#title': 'Parlimentary',
    '#webform_key': 'parlimentary',
    '#required': false,
    '#options': {
      // Healthblock1: 'Health-block1',
      // Healthblock2: 'Health-block2',
      // Healthblock3: 'Health-block3',
    },
  },
  lac: {
    '#type': 'select',
    '#title': 'LAC',
    '#webform_key': 'lac',
    '#required': false,
    '#options': {
      // Healthblock1: 'Health-block1',
      // Healthblock2: 'Health-block2',
      // Healthblock3: 'Health-block3',
    },
  },
};





export const location_details = {
  pincode: {
    '#type': 'textfield',
    '#title': 'Pincode',
    '#webform_key': 'pincode',
    '#required': false,
    '#isDisabled':true,
  },
  lattitude: {
    '#type': 'textfield',
    '#title': 'Lattitude',
    '#webform_key': 'lattitude',
    '#required': true,
    '#isDisabled':false,
  },
  longitude: {
    '#type': 'textfield',
    '#title': 'Longitude',
    '#webform_key': 'longitude',
    '#required': true,
    '#isDisabled':false,
  },
  address: {
    '#type': 'textfield',
    '#title': 'Address',
    '#webform_key': 'address',
    '#required': true,
    '#isDisabled':false,
  },
};

export const coverage_details = {
  // linked_facilities: {
  //   '#type': 'select',
  //   '#title': 'Linked Facilities',
  //   '#webform_key': 'linked_facilities',
  //   '#required': true,
  //   '#options': {
  //     "Noble Hospital": "Noble Hospital",
  //     "Ourlady of Grace Maternity Clinic": "Ourlady of Grace Maternity Clinic",
  //     "Sankalp Nursing Home": "Sankalp Nursing Home",
  //     "Talaulikar Nursing Home": "Talaulikar Nursing Home",
  //     "Kholpe": "Kholpe",
  //     "Srujan Polyclinic": "Srujan Polyclinic"
  //   }
  // },
  linked_facilities: {
    '#type': 'selectionDropdown',
    '#title': 'Linked Facilities',
    '#webform_key': 'linked_facilities',
    '#required': false,
    '#options': {}
  },
  villages_covered: {
    '#type': 'selectionDropdown',
    '#title': 'Villages Covered',
    '#webform_key': 'villages_covered',
    '#required': true,
    '#options': {},
  },
  wards_covered: {
    '#type': 'selectionDropdown',
    '#title': 'Wards Covered',
    '#webform_key': 'wards_covered',
    '#required': true,
    '#options': {},
  },
};

export const health_facility_creation_coverage_details = {
  linked_facilities: {
    '#type': 'selectionDropdown',
    '#title': 'Linked Facilities',
    '#webform_key': 'linked_facilities',
    '#required': false,
    '#options': {
      // "Facility 1":'Facility 1'
    },
  },
  wards_covered: {
    '#type': 'selectionDropdown',
    '#title': 'Wards Covered',
    '#webform_key': 'wards_covered',
    '#required': true,
    '#options': {},
  },
  villages_covered: {
    '#type': 'selectionDropdown',
    '#title': 'Villages Covered',
    '#webform_key': 'villages_covered',
    '#required': true,
    '#isVisible': false,
    '#options': {},
  },
  gram_panchayat_covered: {
    '#type': 'selectionDropdown',
    '#title': 'Gram Panchayats / ADC Villages Covered',
    '#webform_key': 'gram_panchayat_covered',
    '#required': true,
    '#isVisible': false,
    '#options': {},
  },
};

export const coverage_details_urban = {
  linked_facilities: {
    '#type': 'selectionDropdown',
    '#title': 'Linked Facilities',
    '#webform_key': 'linked_facilities',
    '#required': false,
    '#options': {
      // "Facility 1":'Facility 1'
    },
  },
  wards_covered: {
    '#type': 'selectionDropdown',
    '#title': 'Wards Covered',
    '#webform_key': 'wards_covered',
    '#required': true,
    '#options': {},
  },
};
// export const formJson = {
//   "hbnc_visit": {
//     "#type": "select",
//     "#title": "HBNC Visit",
//     "#options": {
//       "Visit -1 - 1st Day": "Visit -1 - 1st Day",
//       "Visit -2 - 3rd Day": "Visit -2 - 3rd Day",
//       "Visit -3 - 7th Day": "Visit -3 - 7th Day",
//       "Visit -4 - 14th Day": "Visit -4 - 14th Day",
//       "Visit -5 - 21st Day": "Visit -5 - 21st Day",
//       "Visit -6 - 28th Day,": "Visit -6 - 28th Day",
//       "Visit -7 - 42nd Day": "Visit -7 - 42nd Day"
//     },
//     "#required": true,
//     "#webform": "child_service_hbnc",
//     "#webform_id": "child_service_hbnc--hbnc_visit",
//     "#webform_key": "hbnc_visit",
//     "#webform_parent_key": "",
//     "#webform_parent_flexbox": false,
//     "#webform_depth": 0,
//     "#webform_children": [],
//     "#webform_multiple": false,
//     "#webform_composite": false,
//     "#webform_parents": [
//       "hbnc_visit"
//     ],
//     "#admin_title": "HBNC Visit",
//     "#webform_plugin_id": "select"
//   },
//   "hbnc_visit_date": {
//     "#type": "date",
//     "#title": "Date of HBNC Visit",
//     "#webform": "child_service_hbnc",
//     "#webform_id": "child_service_hbnc--hbnc_visit_date",
//     "#webform_key": "hbnc_visit_date",
//     "#webform_parent_key": "",
//     "#webform_parent_flexbox": false,
//     "#webform_depth": 0,
//     "#webform_children": [],
//     "#webform_multiple": false,
//     "#webform_composite": false,
//     "#webform_parents": [
//       "hbnc_visit_date"
//     ],
//     "#admin_title": "Date of HBNC Visit",
//     "#webform_plugin_id": "date"
//   },
//   "hbnc_breast_feeding": {
//     "#type": "radios",
//     "#title": "Whether Exclusive Breast Feeding Continuing ?",
//     "#options": {
//       "Yes": "Yes",
//       "No": "No"
//     },
//     "#options_display": "side_by_side",
//     "#webform": "child_service_hbnc",
//     "#webform_id": "child_service_hbnc--hbnc_breast_feeding",
//     "#webform_key": "hbnc_breast_feeding",
//     "#webform_parent_key": "",
//     "#webform_parent_flexbox": false,
//     "#webform_depth": 0,
//     "#webform_children": [],
//     "#webform_multiple": false,
//     "#webform_composite": false,
//     "#webform_parents": [
//       "hbnc_breast_feeding"
//     ],
//     "#admin_title": "Whether Exclusive Breast Feeding Continuing ?",
//     "#webform_plugin_id": "radios"
//   },
//   "hbnc_hiv_tested": {
//     "#type": "radios",
//     "#title": "Whether baby tested for HIV?",
//     "#options": {
//       "Yes": "Yes",
//       "No": "No"
//     },
//     "#options_display": "side_by_side",
//     "#webform": "child_service_hbnc",
//     "#webform_id": "child_service_hbnc--hbnc_hiv_tested",
//     "#webform_key": "hbnc_hiv_tested",
//     "#webform_parent_key": "",
//     "#webform_parent_flexbox": false,
//     "#webform_depth": 0,
//     "#webform_children": [],
//     "#webform_multiple": false,
//     "#webform_composite": false,
//     "#webform_parents": [
//       "hbnc_hiv_tested"
//     ],
//     "#admin_title": "Whether baby tested for HIV?",
//     "#webform_plugin_id": "radios"
//   },
//   "hbnc_danger_signs": {
//     "#type": "checkboxes",
//     "#title": "Indicate Danger Sign(s) (if any) Present for Baby",
//     "#options": {
//       "No danger sign": "No danger sign",
//       "Not able to feed": "Not able to feed",
//       "Convulsions": "Convulsions",
//       "Respiratory Distress/ Difficulty in Breathing/ Fast breathing (More than 60 Breaths Per Minute) / Grunting (Severe Chest in-Drawing)": "Respiratory Distress/ Difficulty in Breathing/ Fast breathing (More than 60 Breaths Per Minute) / Grunting (Severe Chest in-Drawing)",
//       "Axillary Temperature 37.5°C or Above (Feels Hot To Touch)": "Axillary Temperature 37.5°C or Above (Feels Hot To Touch)",
//       "Axillary Temperature 35.5°C or Less (Feels Cold To Touch)": "Axillary Temperature 35.5°C or Less (Feels Cold To Touch)",
//       "Movement Only When Stimulation or No Movement at All": "Movement Only When Stimulation or No Movement at All",
//       "No Gain or Loss of Weight": "No Gain or Loss of Weight",
//       "Very Small Baby (Less Than 1500 grams)": "Very Small Baby (Less Than 1500 grams)"
//     },
//     "#webform": "child_service_hbnc",
//     "#webform_id": "child_service_hbnc--hbnc_danger_signs",
//     "#webform_key": "hbnc_danger_signs",
//     "#webform_parent_key": "",
//     "#webform_parent_flexbox": false,
//     "#webform_depth": 0,
//     "#webform_children": [],
//     "#webform_multiple": true,
//     "#webform_composite": false,
//     "#webform_parents": [
//       "hbnc_danger_signs"
//     ],
//     "#admin_title": "Indicate Danger Sign(s) (if any) Present for Baby",
//     "#webform_plugin_id": "checkboxes"
//   },
//   "hbnc_danger_sign_treated_referred": {
//     "#type": "radios",
//     "#title": "If any danger sign identified in the newborn (above) treated / referred to a higher facility ?",
//     "#options": {
//       "Treated": "Treated",
//       "Referred": "Referred"
//     },
//     "#options_display": "side_by_side",
//     "#webform": "child_service_hbnc",
//     "#webform_id": "child_service_hbnc--hbnc_danger_sign_treated_referred",
//     "#webform_key": "hbnc_danger_sign_treated_referred",
//     "#webform_parent_key": "",
//     "#webform_parent_flexbox": false,
//     "#webform_depth": 0,
//     "#webform_children": [],
//     "#webform_multiple": false,
//     "#webform_composite": false,
//     "#webform_parents": [
//       "hbnc_danger_sign_treated_referred"
//     ],
//     "#admin_title": "If any danger sign identified in the newborn (above) treated / referred to a higher facility ?",
//     "#webform_plugin_id": "radios"
//   },
//   "hbnc_visible_birth_defects": {
//     "#type": "checkboxes",
//     "#title": "Any Visible Birth Defect Seen ?",
//     "#options": {
//       "No defect": "No defect",
//       "Cleft Lip": "Cleft Lip",
//       "Cleft Palate": "Cleft Palate",
//       "Club Foot": "Club Foot",
//       "Down's Syndrome": "Down's Syndrome",
//       "Developmental Dysplasia of the Hip": "Developmental Dysplasia of the Hip",
//       "Congenital cataract": "Congenital cataract",
//       "Hydrocephalus": "Hydrocephalus",
//       "Imperforate Anus": "Imperforate Anus",
//       "Neural Tube Defect (Spinal Bifida)": "Neural Tube Defect (Spinal Bifida)"
//     },
//     "#webform": "child_service_hbnc",
//     "#webform_id": "child_service_hbnc--hbnc_visible_birth_defects",
//     "#webform_key": "hbnc_visible_birth_defects",
//     "#webform_parent_key": "",
//     "#webform_parent_flexbox": false,
//     "#webform_depth": 0,
//     "#webform_children": [],
//     "#webform_multiple": true,
//     "#webform_composite": false,
//     "#webform_parents": [
//       "hbnc_visible_birth_defects"
//     ],
//     "#admin_title": "Any Visible Birth Defect Seen ?",
//     "#webform_plugin_id": "checkboxes"
//   },
//   "hbnc_defect_identified_treated_referred": {
//     "#type": "radios",
//     "#title": "If any defect identified (above) treated/ referred to higher facility?",
//     "#options": {
//       "Treated": "Treated",
//       "Referred": "Referred"
//     },
//     "#options_display": "side_by_side",
//     "#webform": "child_service_hbnc",
//     "#webform_id": "child_service_hbnc--hbnc_defect_identified_treated_referred",
//     "#webform_key": "hbnc_defect_identified_treated_referred",
//     "#webform_parent_key": "",
//     "#webform_parent_flexbox": false,
//     "#webform_depth": 0,
//     "#webform_children": [],
//     "#webform_multiple": false,
//     "#webform_composite": false,
//     "#webform_parents": [
//       "hbnc_defect_identified_treated_referred"
//     ],
//     "#admin_title": "If any defect identified (above) treated/ referred to higher facility?",
//     "#webform_plugin_id": "radios"
//   },
//   "if_treatment_done_method_of_treatment": {
//     "#type": "radios",
//     "#title": "If treatment done, method of treatment",
//     "#options": {
//       "Medical": "Medical",
//       "Surgical": "Surgical"
//     },
//     "#options_display": "side_by_side",
//     "#states": {
//       "visible": {
//         ":input[name=\"hbnc_defect_identified_treated_referred\"]": {
//           "value": "Treated"
//         }
//       }
//     },
//     "#webform": "child_service_hbnc",
//     "#webform_id": "child_service_hbnc--if_treatment_done_method_of_treatment",
//     "#webform_key": "if_treatment_done_method_of_treatment",
//     "#webform_parent_key": "",
//     "#webform_parent_flexbox": false,
//     "#webform_depth": 0,
//     "#webform_children": [],
//     "#webform_multiple": false,
//     "#webform_composite": false,
//     "#webform_parents": [
//       "if_treatment_done_method_of_treatment"
//     ],
//     "#admin_title": "If treatment done, method of treatment",
//     "#webform_plugin_id": "radios"
//   }
// }
export const UserList = [
  {
    userId: '1',
    crDt: '2024-06-18T03:02:58.307Z',
    crBy: '123',
    fName: 'chenna van lu sen sim',
    mName: 'keshav',
    lName: 'reddy',
    email: 'ck.reddy@example.com',
    mob: '1234567890',
    designation: 'National',
    doj: '2024-01-01',
    facilityId: '456',
    mfa: true,
    volunteerForPmsma: false,
    hprId: 'ABC123',
    abhaId: 'XYZ456',
    reportUserWithLineListingData: true,
    offlineModeAccess: false,
    user_type: 'Super Admin User',
    role_name: 'Super Admin Role',
    user_status: 'active',
  },
  {
    userId: '2',
    crDt: '2024-06-18T04:20:10.363Z',
    crBy: '178',
    fName: 'Nava',
    mName: 'Ramesh',
    lName: 'Hopper',
    email: 'nv.h@example.com',
    mob: '9874567890',
    designation: 'state',
    doj: '2023-01-01',
    facilityId: '459',
    mfa: true,
    volunteerForPmsma: false,
    hprId: 'ABC876',
    abhaId: 'XYZ987',
    reportUserWithLineListingData: true,
    offlineModeAccess: false,
    user_type: 'National-Level User',
    role_name: 'Administrator',
    user_status: 'active',
  },
  {
    userId: '3',
    crDt: '2024-06-18T04:20:10.363Z',
    crBy: '178',
    fName: 'sachin',
    mName: 'Ramesh',
    lName: 'Ten',
    email: 'sr.r@example.com',
    mob: '9874567890',
    designation: 'state',
    doj: '2023-01-01',
    facilityId: '459',
    mfa: true,
    volunteerForPmsma: false,
    hprId: 'ABC876',
    abhaId: 'XYZ987',
    reportUserWithLineListingData: true,
    offlineModeAccess: false,
    user_type: 'District-Level User',
    role_name: 'Dashboard User',
    user_status: 'active',
  },
  {
    userId: '4',
    crDt: '2024-06-18T04:21:08.691Z',
    crBy: '178',
    fName: 'Virat',
    mName: 'Kohli',
    lName: 'Ten',
    email: 'vr.t@example.com',
    mob: '8874567890',
    designation: 'Block',
    doj: '2023-01-01',
    facilityId: '366',
    mfa: true,
    volunteerForPmsma: false,
    hprId: 'ABC098',
    abhaId: 'XYZ098',
    reportUserWithLineListingData: true,
    offlineModeAccess: false,
    user_type: 'District-Level User',
    role_name: 'Approver',
    user_status: 'active',
  },
  {
    userId: '5',
    crDt: '2024-06-18T04:22:36.890Z',
    crBy: '111',
    fName: 'mahesh',
    mName: 'kumar',
    lName: 'sen',
    email: 'mk.sen@example.com',
    mob: '8800567890',
    designation: 'State',
    doj: '2022-01-01',
    facilityId: '343',
    mfa: true,
    volunteerForPmsma: false,
    hprId: 'ABC111',
    abhaId: 'XYZ111',
    reportUserWithLineListingData: true,
    offlineModeAccess: false,
    user_type: 'State-Level User',
    role_name: 'Report user',
    user_status: 'active',
  },
  {
    userId: '6',
    crDt: '2024-06-18T04:23:49.145Z',
    crBy: '111',
    fName: 'Anil',
    mName: 'Sagar',
    lName: 'Gupta',
    email: 'as.gupta@example.com',
    mob: '8800500890',
    designation: 'National',
    doj: '2022-10-10',
    facilityId: '123',
    mfa: true,
    volunteerForPmsma: false,
    hprId: 'ABC222',
    abhaId: 'XYZ222',
    reportUserWithLineListingData: true,
    offlineModeAccess: false,
    user_type: 'Beneficiaries',
    role_name: 'Service Update',
    user_status: 'active',
  },
  {
    userId: '7',
    crDt: '2024-06-18T04:25:27.217Z',
    crBy: '777',
    fName: 'prakash',
    mName: 'kumar',
    lName: 'aggarwal',
    email: 'pk.ag@example.com',
    mob: '8800500000',
    designation: 'Block',
    doj: '2022-08-09',
    facilityId: '177',
    mfa: true,
    volunteerForPmsma: false,
    hprId: 'ABC333',
    abhaId: 'XYZ333',
    reportUserWithLineListingData: true,
    offlineModeAccess: false,
    user_type: 'District-Level User',
    role_name: 'Administrator',
    user_status: 'active',
  },
  {
    userId: '8',
    crDt: '2024-06-18T04:26:56.818Z',
    crBy: '888',
    fName: 'sandeep',
    mName: 'unni',
    lName: 'krish',
    email: 'su.k@example.com',
    mob: '7700500000',
    designation: 'State',
    doj: '2022-11-09',
    facilityId: '169',
    mfa: true,
    volunteerForPmsma: false,
    hprId: 'ABC888',
    abhaId: 'XYZ888',
    reportUserWithLineListingData: true,
    offlineModeAccess: false,
    user_type: 'Field-level user',
    role_name: 'Administrator',
    user_status: 'active',
  },
  {
    userId: '9',
    crDt: '2024-06-18T04:28:50.075Z',
    crBy: '888',
    fName: 'ravi',
    mName: 'teja',
    lName: 'krish',
    email: 'rt.k@example.com',
    mob: '7700500011',
    designation: 'ASHA',
    doj: '2023-01-09',
    facilityId: '980',
    mfa: true,
    volunteerForPmsma: false,
    hprId: 'ABC999',
    abhaId: 'XYZ999',
    reportUserWithLineListingData: true,
    offlineModeAccess: false,
    user_type: 'Field-level user',
    role_name: 'Dashboard User',
    user_status: 'active',
  },
  {
    userId: '10',
    crDt: '2024-06-18T04:30:45.628Z',
    crBy: '10',
    fName: 'teja',
    mName: 'majji',
    lName: 'rao',
    email: 'tm.rao@example.com',
    mob: '7799900011',
    designation: 'ANM',
    doj: '2023-01-10',
    facilityId: '760',
    mfa: true,
    volunteerForPmsma: false,
    hprId: 'ABC101',
    abhaId: 'XYZ101',
    reportUserWithLineListingData: true,
    offlineModeAccess: false,
    user_type: 'Field-level user',
    role_name: 'Service Delivery',
    user_status: 'active',
  },
];


 
export const FacilityList = [
  {
    facility_id :'1',
    hfr_id:'ID-38U928',
    nin_id:'nin_id',
    fk_lgd_id:'1',
    fk_lgd_st_cd:'2',
    facility_name: 'facility 1',
    enrollment_dt: 'date',
    fk_facility_type_id: '1',
    fk_facility_type_name:'District Hospital',
    admin_body:'State Government',
    status: '0',
    sanctioned_bed_count :'10',
    functional_bed_count: '20',
    address : 'Adress 1,600094',
    latitude: '12343.45',
    longitude: '12343.45',
    pincode: '600023',
    nuhm_funded : '0',
    create_date : 'timestamp',
    update_date: 'timestamp',
    created_by :'',
    updated_by :'',
    is_deleted :'',
    func_date : 'timestamp',
    end_date: 'timestamp'
  },
  {
    facility_id :'2',
    hfr_id:'ID-38U924',
    nin_id:'nin_id',
    fk_lgd_id:'1',
    fk_lgd_st_cd:'2',
    facility_name: 'facility 2',
    enrollment_dt: 'date',
    fk_facility_type_id: '1',
    fk_facility_type_name:'Railway Hospital',
    admin_body:'Central Government',
    status: '0',
    sanctioned_bed_count :'10',
    functional_bed_count: '20',
    address : 'Adress 1,600094',
    latitude: '12343.45',
    longitude: '12343.45',
    pincode: '600023',
    nuhm_funded : '0',
    create_date : 'timestamp',
    update_date: 'timestamp',
    created_by :'',
    updated_by :'',
    is_deleted :'',
    func_date : 'timestamp',
    end_date: 'timestamp'
  },
  {
    facility_id :'3',
    hfr_id:'ID-38U925',
    nin_id:'nin_id',
    fk_lgd_id:'1',
    fk_lgd_st_cd:'2',
    facility_name: 'facility 3',
    enrollment_dt: 'date',
    fk_facility_type_id: '1',
    fk_facility_type_name:'Military Hospital',
    admin_body:'Centarl Government',
    status: '0',
    sanctioned_bed_count :'10',
    functional_bed_count: '20',
    address : 'Adress 1,600094',
    latitude: '12343.45',
    longitude: '12343.45',
    pincode: '600023',
    nuhm_funded : '0',
    create_date : 'timestamp',
    update_date: 'timestamp',
    created_by :'',
    updated_by :'',
    is_deleted :'',
    func_date : 'timestamp',
    end_date: 'timestamp'
  },
  {
    facility_id :'4',
    hfr_id:'ID-38U926',
    nin_id:'nin_id',
    fk_lgd_id:'1',
    fk_lgd_st_cd:'2',
    facility_name: 'facility 4',
    enrollment_dt: 'date',
    fk_facility_type_id: '1',
    fk_facility_type_name:'District Hospital',
    admin_body:'State Government',
    status: '0',
    sanctioned_bed_count :'10',
    functional_bed_count: '20',
    address : 'Adress 1,600094',
    latitude: '12343.45',
    longitude: '12343.45',
    pincode: '600023',
    nuhm_funded : '0',
    create_date : 'timestamp',
    update_date: 'timestamp',
    created_by :'',
    updated_by :'',
    is_deleted :'',
    func_date : 'timestamp',
    end_date: 'timestamp'
  },
  {
    facility_id :'5',
    hfr_id:'ID-38U927',
    nin_id:'nin_id',
    fk_lgd_id:'1',
    fk_lgd_st_cd:'2',
    facility_name: 'facility 5',
    enrollment_dt: 'date',
    fk_facility_type_id: '1',
    fk_facility_type_name:'District Hospital',
    admin_body:'State Government',
    status: '0',
    sanctioned_bed_count :'10',
    functional_bed_count: '20',
    address : 'Adress 1,600094',
    latitude: '12343.45',
    longitude: '12343.45',
    pincode: '600023',
    nuhm_funded : '0',
    create_date : 'timestamp',
    update_date: 'timestamp',
    created_by :'',
    updated_by :'',
    is_deleted :'',
    func_date : 'timestamp',
    end_date: 'timestamp'
  },
  {
    facility_id :'6',
    hfr_id:'ID-38U928',
    nin_id:'nin_id',
    fk_lgd_id:'1',
    fk_lgd_st_cd:'2',
    facility_name: 'facility 6',
    enrollment_dt: 'date',
    fk_facility_type_id: '1',
    fk_facility_type_name:'Districts Hospital',
    admin_body:'Central Government',
    status: '0',
    sanctioned_bed_count :'10',
    functional_bed_count: '20',
    address : 'Adress 1,600094',
    latitude: '12343.45',
    longitude: '12343.45',
    pincode: '600023',
    nuhm_funded : '0',
    create_date : 'timestamp',
    update_date: 'timestamp',
    created_by :'',
    updated_by :'',
    is_deleted :'',
    func_date : 'timestamp',
    end_date: 'timestamp'
  },
  {
    facility_id :'7',
    hfr_id:'ID-38U929',
    nin_id:'nin_id',
    fk_lgd_id:'1',
    fk_lgd_st_cd:'2',
    facility_name: 'facility 7',
    enrollment_dt: 'date',
    fk_facility_type_id: '1',
    fk_facility_type_name:'District Hospital',
    admin_body:'State Government',
    status: '0',
    sanctioned_bed_count :'10',
    functional_bed_count: '20',
    address : 'Adress 1,600094',
    latitude: '12343.45',
    longitude: '12343.45',
    pincode: '600023',
    nuhm_funded : '0',
    create_date : 'timestamp',
    update_date: 'timestamp',
    created_by :'',
    updated_by :'',
    is_deleted :'',
    func_date : 'timestamp',
    end_date: 'timestamp'
  },
  {
    facility_id :'8',
    hfr_id:'ID-38U930',
    nin_id:'nin_id',
    fk_lgd_id:'1',
    fk_lgd_st_cd:'2',
    facility_name: 'facility 8',
    enrollment_dt: 'date',
    fk_facility_type_id: '1',
    fk_facility_type_name:'District Hospital',
    admin_body:'State Government',
    status: '0',
    sanctioned_bed_count :'10',
    functional_bed_count: '20',
    address : 'Adress 1,600094',
    latitude: '12343.45',
    longitude: '12343.45',
    pincode: '600023',
    nuhm_funded : '0',
    create_date : 'timestamp',
    update_date: 'timestamp',
    created_by :'',
    updated_by :'',
    is_deleted :'',
    func_date : 'timestamp',
    end_date: 'timestamp'
  }
];
export const ABDMDetails=
{
  "health_facility_type":"Health Facility 1",
  "ownership":"PHC",
  "facility_name":"Health Sub-Facility 1",
  "facility_status":"Functional",
  "state":"Madya Pradesh",
  "district_name":"Bhopal",
  "sub_dist_name":"Berassia",
  "village/city/townname":"Village 001",
  "address":"Health Facility 1",
  "latitude":"23.6279° N",
  "longitute":"77.4314° E",
  "pincode":"507210"

}

export const linkedFacilitiesCoverage ={
      "Noble Hospital": "Noble Hospital",
      "Ourlady of Grace Maternity Clinic": "Ourlady of Grace Maternity Clinic",
      "Sankalp Nursing Home": "Sankalp Nursing Home",
      "Talaulikar Nursing Home": "Talaulikar Nursing Home",
      "Kholpe": "Kholpe",
      "Srujan Polyclinic": "Srujan Polyclinic"
    }

export const villageCoverage=
{
  "Mandrem (Ct)": "Mandrem (Ct)",
  "Uguem": "Uguem",
  "Mopa": "Mopa",
  "Dargalim": "Dargalim",
  "Paliem": "Paliem",
  "Poroscodem": "Poroscodem",
  "Parcem (Ct)": "Parcem (Ct)",
  "Amberem": "Amberem",
  "Ozorim": "Ozorim",
  "Arambol (Ct)": "Arambol (Ct)",
  "Cansarvornem": "Cansarvornem",
  "Agarvado": "Agarvado",
  "Chandel": "Chandel",
  "Tiracol": "Tiracol",
  "Ibrampur": "Ibrampur",
  "Virnora": "Virnora",
  "Corgao": "Corgao",
  "Tamboxem": "Tamboxem",
  "Querim": "Querim",
  "Casnem": "Casnem",
  "Torxem": "Torxem",
  "Morgim": "Morgim",
  "Chopdem": "Chopdem",
  "Varconda": "Varconda",
  "Tuem": "Tuem",
  "Alorna": "Alorna"
}
export const wardsCoverage=
{
  "Ward No. 6": "Ward No. 6",
  "Ward No. 4": "Ward No. 4",
  "Ward No. 1": "Ward No. 1",
  "Ward No. 2": "Ward No. 2",
  "Ward No. 7": "Ward No. 7",
  "Ward No. 5": "Ward No. 5",
  "Ward No. 3": "Ward No. 3"
}
export const stateList = [
  {
      "stateCode": 1,
      "stateNameEnglish": "Jammu And Kashmir",
      "stateNameLocal": "JAMMU AND KASHMIR",
      "shortName": "JK",
      "census2011Code": "01",
      "effectiveDate": "2019-08-24",
      "lastUpdated": "2019-09-16",
      "majorVersion": 3,
      "minorVersion": 1,
      "stateOrUt": "U",
      "transactionId": "210278",
      "operationCode": 43,
      "transactionDescription": "Previous State name{JAMMU AND KASHMIR}with state code {1} is Modified as New UT {JAMMU AND KASHMIR}.",
      "isactive": true
  },
  {
      "stateCode": 23,
      "stateNameEnglish": "Madhya Pradesh",
      "stateNameLocal": "मध्य प्रदेश",
      "shortName": "MP",
      "census2011Code": "23",
      "effectiveDate": "1956-11-01",
      "lastUpdated": "2020-01-01",
      "majorVersion": 1,
      "minorVersion": 1,
      "stateOrUt": "S",
      "transactionId": "1001",
      "operationCode": 1,
      "transactionDescription": "Initial state creation",
      "isactive": true
  }
]

export const districtList = [
  {
      "districtCode": 393,
      "districtNameEnglish": "Barwani",
      "districtNameLocal": "बड़वानी",
      "districtNameshort": "BRW",
      "stateCode": 23,
      "census2011Code": "441",
      "effectiveDate": "2005-01-01",
      "lastUpdated": "2005-01-01",
      "majorVersion": 1,
      "minorVersion": 1,
      "transactionId": 0,
      "operationCode": 0,
      "transactionDescription": "",
      "isactive": true
  },
  {
      "districtCode": 1,
      "districtNameEnglish": "Srinagar",
      "districtNameLocal": "SRINAGAR",
      "districtNameshort": "SRI",
      "stateCode": 1,
      "census2011Code": "002",
      "effectiveDate": "1979-04-01",
      "lastUpdated": "2019-09-16",
      "majorVersion": 2,
      "minorVersion": 1,
      "transactionId": 12345,
      "operationCode": 21,
      "transactionDescription": "Updated district boundaries",
      "isactive": true
  }
]

export const blockList = [
  {
      "blockCode": 6847,
      "blockNameEnglish": "Bapini",
      "blockNameLocal": "",
      "districts": [
          {
              "districtCode": 772
          }
      ],
      "effectiveDate": "2023-09-27",
      "lastUpdated": "2024-04-11",
      "majorVersion": 3,
      "minorVersion": 1,
      "transactionId": 859803,
      "operationCode": 42,
      "transactionDescription": "The Block 'Aau,Bap,Bapini,Dechu,Ghantiyali,Lohawat,Phalodi,' has been shifted to District Phalodi from District Jodhpur in Rajasthan.",
      "isActive": true,
      "villageCoverage": [
          {
              "villageCode": 84529
          },
          {
              "villageCode": 84313
          },
          {
              "villageCode": 84314
          },
          {
              "villageCode": 84501
          }
      ]
  },
  {
      "blockCode": 101,
      "blockNameEnglish": "Barwani Block",
      "blockNameLocal": "बड़वानी ब्लॉक",
      "districts": [
          {
              "districtCode": 393
          }
      ],
      "effectiveDate": "2005-01-01",
      "lastUpdated": "2020-01-01",
      "majorVersion": 2,
      "minorVersion": 1,
      "transactionId": 67890,
      "operationCode": 10,
      "transactionDescription": "Updated block information",
      "isActive": true,
      "villageCoverage": [
          {
              "villageCode": 900598
          }
      ]
  }
]

export const villageList = [
  {
      "villageCode": 900598,
      "villageNameEnglish": "00522900",
      "villageNameLocal": "",
      "subDistrictCode": 305,
      "stateCode": 5,
      "census2011Code": "000000",
      "effectiveDate": "2016-11-08",
      "lastUpdated": "2023-08-28",
      "majorVersion": 2,
      "minorVersion": 2,
      "transactionId": 799060,
      "operationCode": 68,
      "transactionDescription": "village 00522900(900598) is reactivated",
      "isactive": true,
      "villageStatus": "I",
      "is_pesa": "N"
  },
  {
      "villageCode": 84529,
      "villageNameEnglish": "Village A",
      "villageNameLocal": "गांव ए",
      "subDistrictCode": 101,
      "stateCode": 23,
      "census2011Code": "000001",
      "effectiveDate": "2010-01-01",
      "lastUpdated": "2020-01-01",
      "majorVersion": 1,
      "minorVersion": 1,
      "transactionId": 98765,
      "operationCode": 30,
      "transactionDescription": "New village added",
      "isactive": true,
      "villageStatus": "I",
      "is_pesa": "Y"
  },
  {
      "villageCode": 84313,
      "villageNameEnglish": "Village B",
      "villageNameLocal": "गांव बी",
      "subDistrictCode": 101,
      "stateCode": 23,
      "census2011Code": "000002",
      "effectiveDate": "2011-02-01",
      "lastUpdated": "2021-02-01",
      "majorVersion": 1,
      "minorVersion": 1,
      "transactionId": 98766,
      "operationCode": 31,
      "transactionDescription": "New village added",
      "isactive": true,
      "villageStatus": "I",
      "is_pesa": "N"
  },
  {
      "villageCode": 84314,
      "villageNameEnglish": "Village C",
      "villageNameLocal": "गांव सी",
      "subDistrictCode": 101,
      "stateCode": 23,
      "census2011Code": "000003",
      "effectiveDate": "2012-03-01",
      "lastUpdated": "2022-03-01",
      "majorVersion": 1,
      "minorVersion": 1,
      "transactionId": 98767,
      "operationCode": 32,
      "transactionDescription": "New village added",
      "isactive": true,
      "villageStatus": "I",
      "is_pesa": "N"
  },
  {
      "villageCode": 84501,
      "villageNameEnglish": "Village D",
      "villageNameLocal": "गांव डी",
      "subDistrictCode": 101,
      "stateCode": 23,
      "census2011Code": "000004",
      "effectiveDate": "2013-04-01",
      "lastUpdated": "2023-04-01",
      "majorVersion": 1,
      "minorVersion": 1,
      "transactionId": 98768,
      "operationCode": 33,
      "transactionDescription": "New village added",
      "isactive": true,
      "villageStatus": "I",
      "is_pesa": "Y"
  }
]

export const wardList = [
  {
      "wardCode": 3052120,
      "wardNameEnglish": "----",
      "wardNameLocal": "",
      "localBodyCode": 242461,
      "localBodyNameEnglish": "Sharkwara",
      "effectiveDate": "2023-07-29",
      "lastUpdated": "2023-07-29",
      "majorVersion": 1,
      "minorVersion": 1,
      "transactionId": 792760,
      "operationCode": 32,
      "transactionDescription": "New Wards ('Shrakwara 8' (Code:3052121)...etc) are created in 'Sharkwara' Village Panchayat (Jammu And Kashmir State).",
      "isactive": true
  },
  {
      "wardCode": 3052121,
      "wardNameEnglish": "Ward 1",
      "wardNameLocal": "वॉर्ड 1",
      "localBodyCode": 1,
      "localBodyNameEnglish": "Anantnag",
      "effectiveDate": "2022-06-15",
      "lastUpdated": "2022-06-15",
      "majorVersion": 1,
      "minorVersion": 1,
      "transactionId": 891011,
      "operationCode": 12,
      "transactionDescription": "Ward boundaries updated",
      "isactive": true
  }
]


export const ulbList = [
  {
      "localBodyCode": 1,
      "localBodyNameEnglish": "Anantnag",
      "localBodyNameLocal": "ANANTNAG",
      "localBodyTypeCode": "1",
      "localBodyTypeName": "District Panchayat",
      "parentLocalBodyCode": 0,
      "stateCode": 1,
      "census2011Code": "000000",
      "effectiveDate": "2018-04-21",
      "lastUpdated": "2018-09-07",
      "majorVersion": 3,
      "minorVersion": 1,
      "transactionId": 158179,
      "operationCode": 36,
      "transactionDescription": "Change Local Government Setup(PRI)",
      "isActive": true,
      "coverage": [
          {
              "entityCode": 1,
              "entityType": "D",
              "coverageType": "P"
          }
      ]
  },
  {
      "localBodyCode": 2,
      "localBodyNameEnglish": "Barwani Municipal Council",
      "localBodyNameLocal": "बड़वानी नगर परिषद",
      "localBodyTypeCode": "2",
      "localBodyTypeName": "Municipal Council",
      "parentLocalBodyCode": 0,
      "stateCode": 23,
      "census2011Code": "000000",
      "effectiveDate": "2000-01-01",
      "lastUpdated": "2020-01-01",
      "majorVersion": 2,
      "minorVersion": 1,
      "transactionId": 56789,
      "operationCode": 20,
      "transactionDescription": "New local body created",
      "isActive": true,
      "coverage": [
          {
              "entityCode": 393,
              "entityType": "D",
              "coverageType": "P"
          }
      ]
  }
]

export const AbdmInfo = [{
"state_id":'0057d769-0b11-49a9-b8da-6df1d906dc4e',
"state_name":'Delhi',
"district_id":'0057d769-0b11-49a9-b8da-6df1d906dc4e',
"district_name":'North West'
}]

export const ERROR_MESSAGES:{[key:string]:string} ={
  "type_name":"the type field is mandatory. Select type from the dropdown",
  "effective_form_date":"Effective from date is mandatory",
  "state":"Please select State",
  "district":"Please select district",
  "sub_district":"Please select sub_district",
  "health_block_name":`Pease enter Health block name`,
  "health_block_name_already_exists":`The name already exists. Choose a unique name to continue`,
  "zone_name_already_exists":"This Zone Name already exists",
  "division_name_already_exists":"This Division Name already exists",
  "circle_name_already_exists":"This circle name already exists",
  "zone_name":"Please enter Zone Name",
  "division_name":"Please enter Division Name",
  "circle_name":"Please enter Circle Name",
  "type":"Pease enter type",
  "villages_maped_empty":"At least one Village mapped need to selected",
  "wards_maped_empty":"At least one Ward mapped need to selected",
}

export const MAPPED_VALUE:any={
  'mapped_district_count':"District Count",
  "mapped_village_count":"Village Count",
  "mapped_gram_panchayat_count":"Gram Panchayat / ADC Village Count",
  "mapped_wards_count":'Ward Count'
  }

export const MAPPED_DETAIL:any={
  'mapped_district_count':"districts",
  "mapped_village_count":"villages",
  "mapped_wards_count":'wards'
  }


  export const dateFormate = {
    yyyy_mm_dd: 'YYYY-MM-DD',
    dd_mm_yyyy: 'DD-MM-YYYY',
    'dd/mm/yyy':'DD/MM/YYYY',
    dd_m_yyyy: 'DD-M-YYYY',
    hh_mm_A: 'hh:mm A',
    onlyMonth: 'MMMM',
    ddmmyyyy: 'dd-mm-yyyy'
  };

  export const immunizationData={
    adverseEffect: {
        '#type': 'select',
        '#title': 'Select Adverse Effect',
        '#webform_key': 'adverseEffect',
        '#required': true,
        '#isDisabled': false,
        '#options': []
    },
    deathByAEFI: {
        '#type': 'select',
        '#title': 'Death Following AEFI',
        '#webform_key': 'deathByAEFI',
        '#required': true,
        '#isDisabled': false,
        '#options': []
    },
    reportedDate: {
        '#type': 'date',
        '#title': 'Reported Date',
        '#webform_key': 'reportedDate',
        '#required': true,
        '#isDisabled': false,
        '#dateMinimum':'true',
        '#useRelativePopup':true,
        '#maxDate':today.toISOString().split('T')[0],
        '#minDate':new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
    }
}

  export const viewHeader = {
    text1: 'JANANI',
    text2: 'Journey of Antenatal, Natal and Neonatal Integrated Care',
    text3: 'Sehat ke Sath, Every Step of Care',
  };

  export const calenderViews: any[] = ['month', 'agenda'];

  export const module_type = {
    vhndExecution: 'vhndExecution',
    workPlan: 'workPlan'
  };

  export const routes_page_constant = {
    dashBoard: 'Dashboard',
    vhendExecution: 'VHND/UHND Execution',
    workPlan: 'Work Plan',
    approvals:'Approvals'
  };


  export const download_colums_common: any[] = [
    { label: 'Sl.No.', value: 'serialNo' },
    { label: 'Name', value: 'benf_name' },
    { label: 'Abha ID', value: 'abha_id' },
    { label: 'Mobile Number', value: 'mob' }
  ];

  export const download_colums_services_common_object: any[] = [
    { label: 'Service Due', value: 'service_period_full_name' },
    {
        label: 'Service Status',
        value: 'service_period_status_name',
    }
  ];

  export const GENDER = {
    MALE: 'Male',
    FEMALE: 'Female',
    male:'M',
    female:'F'
  }

  export const COMMON_CONSTANTS = {
    FATHER: 'Father',
    MOTHER: 'Mother',
    CHILD: 'Child',
    GUARDIAN: 'Guardian',
    NO_PREGNANCY_TITLE: 'There is no ongoing pregnancy, click add pregnancy to register a pregnancy',
    VIEW: 'view',
    FIELD_LEVEL_USER: 'Field Level User',
    NOT_AVAILABLE: 'Not Available',
    HB: 'hb',
    HB_GM: 'hb_gm',
    HB_LEVEL: 'hbLevel',
    MISSED: 'Missed',
    RECEIVED: 'Received',
    NOT_DONE: 'Not Done',
  }

  export const COMMON_FIELD_NAME = {
    HB_DL: 'Hb (g/dL)',
    HB_GM: 'Hb (gm%)'
  }

  export const COMMON_UNITS = {
    G_DL: 'g/dL'
  }

  export const YES_NO_OPTIONS = {
    YES: 'Yes',
    NO: 'No',
  };

  export const DATA_TYPES = {
    BOOLEAN: 'boolean',
    STRING: 'string',
    NUMBER: 'number',
    OBJECT: 'object',
    ARRAY: 'array',
  };

  export const userDesignation = {
    anm: 'ANM',
    moic: 'Medical Officer Incharge - PHC/CHC'
  };

  export const CONSENT_DETAILS = {
    CHILD_CONSENT_TYPE:"ChildBeneficiary",
    CONSENT_NAME: "abha",
  }